var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketPulseMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 582,
    viewBox: "0 0 640 582",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3142_7091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4639 398.316V124.908L69.2361 99.061L102.812 118.443V185.533L119.606 175.829V149.982L136.401 140.277V41.8721L186.771 12.7728L209.164 25.7029V55.9169L231.557 42.9868L253.936 55.9169V111.939L276.329 124.843V71.1157L298.721 58.1856L326.699 74.3417V138.992L354.69 122.823V19.3952L388.279 0L427.453 22.6212V106.549L444.248 116.24V150.218L466.64 163.148V46.9209L494.618 30.7517L528.207 50.1469V77.7512L544.988 87.4554V162.033L567.381 174.963V124.502L600.97 105.106L617.751 114.797L617.764 398.316H24.4639Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 246.551L222.445 243.81V239.666L227.204 242.407V246.551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 261.855L222.445 259.101V254.957L227.204 257.698V261.855Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 238.906L222.445 236.165V232.008L227.204 234.762V238.906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 230.723L222.445 227.982V223.838L227.204 226.579V230.723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 254.196L222.445 251.456V247.312L227.204 250.052V254.196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 200.128L222.445 197.388V193.244L227.204 195.985V200.128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 192.483L222.445 189.742V185.598L227.204 188.339V192.483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 207.787L222.445 205.033V200.889L227.204 203.63V207.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 223.077L222.445 220.337V216.18L227.204 218.934V223.077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 215.432L222.445 212.691V208.534L227.204 211.288V215.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 284.791L222.445 282.05V277.906L227.204 280.647V284.791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 323.568L222.445 320.827V316.67L227.204 319.424V323.568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 307.74L222.445 304.999V300.842L227.204 303.596V307.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 315.923L222.445 313.169V309.025L227.204 311.766V315.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 338.859L222.445 336.118V331.974L227.204 334.715V338.859Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 331.213L222.445 328.472V324.329L227.204 327.069V331.213Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 277.145L222.445 274.405V270.261L227.204 273.001V277.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 300.094L222.445 297.341V293.197L227.204 295.95V300.094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 269.5L222.445 266.759V262.602L227.204 265.356V269.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 184.838L222.445 182.097V177.94L227.204 180.694V184.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 292.449L222.445 289.695V285.551L227.204 288.292V292.449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 90.3404L222.445 87.5996V83.4426L227.204 86.1965V90.3404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 82.6951L222.445 79.9412V75.7973L227.204 78.5381V82.6951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 75.0498L222.445 72.2959V68.152L227.204 70.8928V75.0498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 340.813L212.599 338.072V333.915L217.345 336.669V340.813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 333.167L212.599 330.413V326.269L217.345 329.01V333.167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 348.458L212.599 345.717V341.573L217.345 344.314V348.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 356.103L212.599 353.362V349.218L217.345 351.959V356.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 346.517L222.445 343.763V339.619L227.204 342.36V346.517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 113.289L222.445 110.536V106.392L227.204 109.132V113.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 153.155L222.445 150.401V146.257L227.204 148.998V153.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 144.972L222.445 142.231V138.074L227.204 140.828V144.972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 161.889L222.445 159.148V155.004L227.204 157.745V161.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 136.225L222.445 133.485V129.341L227.204 132.081V136.225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 169.547L222.445 166.793V162.649L227.204 165.39V169.547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 177.193L222.445 174.439V170.295L227.204 173.036V177.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 97.9857L222.445 95.2449V91.101L227.204 93.8418V97.9857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 105.631L222.445 102.89V98.7463L227.204 101.487V105.631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 128.58L222.445 125.839V121.682L227.204 124.436V128.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 120.935L222.445 118.181V114.037L227.204 116.791V120.935Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 95.481L139.666 92.7271V88.5832L144.412 91.324V95.481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 234.932L139.666 232.178V228.034L144.412 230.775V234.932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 227.287L139.666 224.533V220.389L144.412 223.13V227.287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 219.629L139.666 216.888V212.744L144.412 215.485V219.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 242.578L139.666 239.837V235.68L144.412 238.434V242.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 250.223L139.666 247.482V243.338L144.412 246.079V250.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 172.655L139.666 169.901V165.757L144.412 168.498V172.655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 189.034L139.666 186.294V182.15L144.412 184.89V189.034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 211.983L139.666 209.242V205.085L144.412 207.839V211.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 181.389L139.666 178.648V174.504L144.412 177.245V181.389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 196.693L139.666 193.939V189.795L144.412 192.536V196.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 258.406L139.666 255.665V251.508L144.412 254.262V258.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 204.338L139.666 201.597V197.44L144.412 200.194V204.338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 319.594L139.666 316.841V312.697L144.412 315.437V319.594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 311.949L139.666 309.195V305.051L144.412 307.792V311.949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 335.423L139.666 332.669V328.525L144.412 331.266V335.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 304.291L139.666 301.55V297.406L144.412 300.147V304.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 327.24L139.666 324.499V320.342L144.412 323.096V327.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 281.355L139.666 278.601V274.457L144.412 277.198V281.355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 296.645L139.666 293.905V289.748L144.412 292.502V296.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 273.696L139.666 270.956V266.812L144.412 269.553V273.696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 266.051L139.666 263.31V259.166L144.412 261.907V266.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 289L139.666 286.246V282.102L144.412 284.856V289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 103.126L139.666 100.372V96.2285L144.412 98.9692V103.126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 57.2283L139.666 54.4875V50.3436L144.412 53.0843V57.2283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 164.997L139.666 162.256V158.112L144.412 160.853V164.997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 64.8867L139.666 62.1328V57.9889L144.412 60.7296V64.8867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 80.1773L139.666 77.4365V73.2795L144.412 76.0333V80.1773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 72.532L139.666 69.7912V65.6342L144.412 68.3881V72.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 141.904L139.666 139.163V135.019L144.412 137.76V141.904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 134.258L139.666 131.517V127.374L144.412 130.114V134.258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 157.207L139.666 154.453V150.309L144.412 153.063V157.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 149.562L139.666 146.808V142.664L144.412 145.405V149.562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 87.8226L139.666 85.0818V80.9379L144.412 83.6786V87.8226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 126.062L139.666 123.321V119.177L144.412 121.918V126.062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.204 354.162L222.445 351.421V347.264L227.204 350.018V354.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 325.522L212.599 322.768V318.624L217.345 321.365V325.522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 110.772L139.666 108.031V103.874L144.412 106.628V110.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 118.417L139.666 115.676V111.532L144.412 114.273V118.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 72.1517L386.732 69.3978V65.2539L391.491 67.9946V72.1517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 179.842L386.732 177.088V172.944L391.491 175.685V179.842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 195.132L386.732 192.391V188.234L391.491 190.988V195.132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 218.081L386.732 215.327V211.183L391.491 213.924V218.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 202.777L386.732 200.037V195.893L391.491 198.634V202.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 210.423L386.732 207.682V203.538L391.491 206.279V210.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 187.487L386.732 184.733V180.589L391.491 183.343V187.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 133.34L386.732 130.586V126.443L391.491 129.183V133.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 140.986L386.732 138.232V134.088L391.491 136.829V140.986Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 148.631L386.732 145.89V141.733L391.491 144.487V148.631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 156.893L386.732 154.152V149.995L391.491 152.749V156.893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 164.538L386.732 161.797V157.64L391.491 160.394V164.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 172.183L386.732 169.442V165.298L391.491 168.039V172.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 272.149L386.732 269.395V265.251L391.491 267.992V272.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 279.794L386.732 277.054V272.897L391.491 275.65V279.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 287.44L386.732 284.699V280.555L391.491 283.296V287.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 295.085L386.732 292.344V288.2L391.491 290.941V295.085Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 264.491L386.732 261.75V257.606L391.491 260.347V264.491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 249.2L386.732 246.459V242.302L391.491 245.056V249.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 241.555L386.732 238.801V234.657L391.491 237.411V241.555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 256.845L386.732 254.105V249.961L391.491 252.701V256.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 233.909L386.732 231.156V227.012L391.491 229.752V233.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 225.726L386.732 222.986V218.829L391.491 221.583V225.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 302.743L386.732 299.989V295.846L391.491 298.586V302.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 351.107L376.873 348.366V344.209L381.632 346.963V351.107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 125.682L386.732 122.941V118.797L391.491 121.538V125.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 343.461L376.873 340.708V336.564L381.632 339.318V343.461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 320.512L376.873 317.772V313.628L381.632 316.369V320.512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 328.158L376.873 325.417V321.273L381.632 324.014V328.158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 335.816L376.873 333.062V328.918L381.632 331.659V335.816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 49.2027L386.732 46.4619V42.3049L391.491 45.0587V49.2027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 102.746L386.732 99.9921V95.8482L391.491 98.5889V102.746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 95.0876L386.732 92.3468V88.2029L391.491 90.9436V95.0876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 118.037L386.732 115.296V111.139L391.491 113.893V118.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 110.391L386.732 107.651V103.493L391.491 106.247V110.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 87.4423L386.732 84.7015V80.5576L391.491 83.2984V87.4423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 64.5064L386.732 61.7525V57.6086L391.491 60.3493V64.5064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 79.797L386.732 77.0562V72.8992L391.491 75.653V79.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 56.848L386.732 54.1072V49.9633L391.491 52.704V56.848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 343.068L139.666 340.327V336.17L144.412 338.924V343.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 194.437L212.599 191.683V187.539L217.345 190.28V194.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 202.082L212.599 199.342V195.185L217.345 197.938V202.082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 310.913L386.732 308.172V304.028L391.491 306.769V310.913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 217.373L212.599 214.632V210.488L217.345 213.229V217.373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 225.031L212.599 222.278V218.134L217.345 220.874V225.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 233.201L212.599 230.461V226.317L217.345 229.057V233.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 171.488L212.599 168.747V164.59L217.345 167.344V171.488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 163.843L212.599 161.102V156.945L217.345 159.699V163.843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 156.198L212.599 153.444V149.3L217.345 152.04V156.198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 179.133L212.599 176.393V172.249L217.345 174.989V179.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 186.792L212.599 184.038V179.894L217.345 182.635V186.792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 294.39L212.599 291.649V287.505L217.345 290.246V294.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 240.86L212.599 238.106V233.962L217.345 236.703V240.86Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 302.035L212.599 299.294V295.151L217.345 297.891V302.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 279.099L212.599 276.345V272.201L217.345 274.942V279.099Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 310.218L212.599 307.477V303.333L217.345 306.074V310.218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 286.745L212.599 284.004V279.847L217.345 282.601V286.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 248.505L212.599 245.751V241.607L217.345 244.361V248.505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 271.441L212.599 268.7V264.556L217.345 267.297V271.441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 256.15L212.599 253.41V249.253L217.345 252.006V256.15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 263.796L212.599 261.055V256.911L217.345 259.652V263.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 209.728L212.599 206.987V202.843L217.345 205.584V209.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 356.811L386.732 354.057V349.913L391.491 352.654V356.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 349.153L386.732 346.412V342.268L391.491 345.009V349.153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 317.863L212.599 315.123V310.979L217.345 313.72V317.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 147.451L212.599 144.71V140.553L217.345 143.307V147.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 326.217L386.732 323.463V319.319L391.491 322.073V326.217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 333.862L386.732 331.121V326.964L391.491 329.718V333.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 341.508L386.732 338.767V334.623L391.491 337.364V341.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.491 318.572L386.732 315.818V311.674L391.491 314.415V318.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 115.23L212.599 112.489V108.346L217.345 111.086V115.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 122.876L212.599 120.135V115.991L217.345 118.732V122.876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 130.534L212.599 127.78V123.636L217.345 126.377V130.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 139.268L212.599 136.527V132.383L217.345 135.124V139.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 107.585L212.599 104.844V100.687L217.345 103.441V107.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 76.9906L212.599 74.2499V70.0928L217.345 72.8467V76.9906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 84.636L212.599 81.8952V77.7513L217.345 80.492V84.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 69.3454L212.599 66.5915V62.4475L217.345 65.2014V69.3454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 99.9397L212.599 97.1858V93.0418L217.345 95.7826V99.9397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.345 92.2944L212.599 89.5405V85.3965L217.345 88.1373V92.2944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 341.835L48.5347 339.081V334.938L53.2938 337.678V341.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 350.713L139.666 347.973V343.815L144.412 346.569V350.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 305.012L38.6885 302.258V298.114L43.4345 300.855V305.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 320.827L38.6885 318.086V313.942L43.4345 316.683V320.827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 297.354L38.6885 294.613V290.469L43.4345 293.21V297.354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 328.486L38.6885 325.732V321.588L43.4345 324.329V328.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 282.063L38.6885 279.322V275.165L43.4345 277.919V282.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 259.114L38.6885 256.373V252.229L43.4345 254.97V259.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 266.759L38.6885 264.019V259.875L43.4345 262.615V266.759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 274.418L38.6885 271.664V267.52L43.4345 270.261V274.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 336.131L38.6885 333.39V329.233L43.4345 331.987V336.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 351.421L38.6885 348.681V344.537L43.4345 347.278V351.421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 359.08L38.6885 356.326V352.182L43.4345 354.923V359.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 343.776L38.6885 341.035V336.891L43.4345 339.632V343.776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 251.469L38.6885 248.728V244.571L43.4345 247.325V251.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 289.708L38.6885 286.968V282.81L43.4345 285.564V289.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 243.823L38.6885 241.07V236.926L43.4345 239.666V243.823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 151.254L38.6885 148.5V144.356L43.4345 147.097V151.254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 158.899L38.6885 156.145V152.001L43.4345 154.755V158.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 143.569L38.6885 140.828V136.671L43.4345 139.425V143.569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 212.691L38.6885 209.951V205.807L43.4345 208.547V212.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 166.807L38.6885 164.066V159.909L43.4345 162.663V166.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 220.35L38.6885 217.596V213.452L43.4345 216.193V220.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 235.64L38.6885 232.9V228.743L43.4345 231.497V235.64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 227.995L38.6885 225.241V221.097L43.4345 223.851V227.995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 205.046L38.6885 202.305V198.161L43.4345 200.902V205.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 174.452L38.6885 171.711V167.567L43.4345 170.308V174.452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 182.097L38.6885 179.356V175.212L43.4345 177.953V182.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 189.756L38.6885 187.002V182.858L43.4345 185.598V189.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 197.401L38.6885 194.66V190.503L43.4345 193.257V197.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 295.413L48.5347 292.659V288.515L53.2938 291.256V295.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 334.177L48.5347 331.436V327.292L53.2938 330.033V334.177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 312.867L376.873 310.126V305.969L381.632 308.723V312.867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 357.126L48.5347 354.385V350.228L53.2938 352.982V357.126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 318.349L48.5347 315.608V311.464L53.2938 314.205V318.349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 310.703L48.5347 307.963V303.819L53.2938 306.559V310.703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 326.532L48.5347 323.791V319.634L53.2938 322.388V326.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 303.058L48.5347 300.317V296.16L53.2938 298.914V303.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 349.481L48.5347 346.727V342.583L53.2938 345.324V349.481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 287.754L48.5347 285.014V280.87L53.2938 283.61V287.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 172.511L48.5347 169.757V165.613L53.2938 168.354V172.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 164.59L48.5347 161.85V157.706L53.2938 160.446V164.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 187.802L48.5347 185.061V180.904L53.2938 183.658V187.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 195.447L48.5347 192.706V188.562L53.2938 191.303V195.447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 149.273L48.5347 146.52V142.376L53.2938 145.116V149.273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 203.105L48.5347 200.351V196.207L53.2938 198.948V203.105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 156.945L48.5347 154.204V150.06L53.2938 152.801V156.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 180.156L48.5347 177.416V173.258L53.2938 176.012V180.156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 257.173L48.5347 254.419V250.275L53.2938 253.016V257.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 264.818L48.5347 262.078V257.921L53.2938 260.675V264.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 272.464L48.5347 269.723V265.566L53.2938 268.32V272.464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 249.515L48.5347 246.774V242.63L53.2938 245.371V249.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 280.109L48.5347 277.368V273.224L53.2938 275.965V280.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 241.345L48.5347 238.591V234.447L53.2938 237.188V241.345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 218.396L48.5347 215.655V211.498L53.2938 214.252V218.396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 226.041L48.5347 223.3V219.156L53.2938 221.897V226.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 233.686L48.5347 230.946V226.802L53.2938 229.543V233.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2938 210.751L48.5347 207.997V203.853L53.2938 206.607V210.751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4345 312.657L38.6885 309.903V305.759L43.4345 308.5V312.657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 232.978L149.511 230.238V226.094L154.27 228.834V232.978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 225.333L149.511 222.592V218.435L154.27 221.189V225.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 240.624L149.511 237.883V233.739L154.27 236.48V240.624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 248.282L149.511 245.528V241.384L154.27 244.125V248.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 170.701L149.511 167.961V163.803L154.27 166.557V170.701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 210.042L149.511 207.289V203.145L154.27 205.885V210.042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 187.093L149.511 184.353V180.196L154.27 182.949V187.093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 255.927L149.511 253.187V249.03L154.27 251.783V255.927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 178.347L149.511 175.606V171.462L154.27 174.203V178.347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 194.739L149.511 191.998V187.841L154.27 190.595V194.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 202.384L149.511 199.643V195.499L154.27 198.24V202.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 217.688L149.511 214.934V210.79L154.27 213.531V217.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 309.995L149.511 307.254V303.097L154.27 305.851V309.995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 302.35L149.511 299.596V295.452L154.27 298.193V302.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 317.641L149.511 314.9V310.756L154.27 313.497V317.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 332.944L149.511 330.19V326.046L154.27 328.787V332.944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 325.286L149.511 322.545V318.401L154.27 321.142V325.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 271.756L149.511 269.002V264.858L154.27 267.612V271.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 264.11L149.511 261.356V257.213L154.27 259.953V264.11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 279.401L149.511 276.66V272.503L154.27 275.257V279.401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 294.692L149.511 291.951V287.807L154.27 290.548V294.692Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 287.046L149.511 284.305V280.161L154.27 282.902V287.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 70.578L149.511 67.8373V63.6933L154.27 66.4341V70.578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 341.114L149.511 338.373V334.229L154.27 336.97V341.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.412 358.359L139.666 355.618V351.474L144.412 354.215V358.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 78.2365L149.511 75.4826V71.3386L154.27 74.0794V78.2365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 162.899L149.511 160.158V156.014L154.27 158.755V162.899Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 139.963L149.511 137.209V133.065L154.27 135.819V139.963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 131.767L149.511 129.026V124.869L154.27 127.623V131.767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 147.608L149.511 144.867V140.71L154.27 143.464V147.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 124.121L149.511 121.381V117.224L154.27 119.977V124.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 155.253L149.511 152.513V148.369L154.27 151.109V155.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 93.527L149.511 90.7863V86.6292L154.27 89.3831V93.527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 85.8817L149.511 83.1279V78.9839L154.27 81.7247V85.8817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 101.172L149.511 98.4316V94.2877L154.27 97.0284V101.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 108.818L149.511 106.077V101.933L154.27 104.674V108.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 116.476L149.511 113.722V109.578L154.27 112.319V116.476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 62.9327L149.511 60.192V56.0349L154.27 58.7888V62.9327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 261.068L28.8296 258.314V254.17L33.5756 256.911V261.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 214.645L28.8296 211.905V207.748L33.5756 210.501V214.645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 276.359L28.8296 273.618V269.474L33.5756 272.215V276.359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 284.004L28.8296 281.263V277.119L33.5756 279.86V284.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 291.662L28.8296 288.908V284.764L33.5756 287.505V291.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 253.423L28.8296 250.669V246.525L33.5756 249.266V253.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 222.291L28.8296 219.55V215.406L33.5756 218.147V222.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 245.764L28.8296 243.023V238.88L33.5756 241.62V245.764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 229.936L28.8296 227.195V223.051L33.5756 225.792V229.936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 238.119L28.8296 235.378V231.221L33.5756 233.975V238.119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 268.713L28.8296 265.972V261.815L33.5756 264.569V268.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 345.73L28.8296 342.976V338.832L33.5756 341.573V345.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 299.308L28.8296 296.567V292.41L33.5756 295.164V299.308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 338.072L28.8296 335.331V331.187L33.5756 333.928V338.072Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 353.375L28.8296 350.635V346.478L33.5756 349.231V353.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 306.953L28.8296 304.212V300.055L33.5756 302.809V306.953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 315.136L28.8296 312.395V308.238L33.5756 310.992V315.136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 348.772L149.511 346.019V341.875L154.27 344.615V348.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 330.426L28.8296 327.686V323.542L33.5756 326.282V330.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 322.781L28.8296 320.04V315.883L33.5756 318.637V322.781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 207L28.8296 204.246V200.102L33.5756 202.843V207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.27 356.418L149.511 353.664V349.52L154.27 352.261V356.418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 184.051L28.8296 181.31V177.153L33.5756 179.907V184.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 176.406L28.8296 173.652V169.508L33.5756 172.262V176.406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 168.76L28.8296 166.007V161.863L33.5756 164.603V168.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 191.696L28.8296 188.956V184.812L33.5756 187.552V191.696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 199.342L28.8296 196.601V192.457L33.5756 195.198V199.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 137.865L28.8296 135.124V130.98L33.5756 133.721V137.865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 161.102L28.8296 158.361V154.217L33.5756 156.958V161.102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 145.549L28.8296 142.808V138.651L33.5756 141.405V145.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5756 153.194L28.8296 150.454V146.31L33.5756 149.051V153.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 313.483L588.711 316.224V312.08L593.457 309.326V313.483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 93.7893L470.39 91.0486V86.9046L475.149 89.6454V93.7893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 101.435L470.39 98.6939V94.5499L475.149 97.2907V101.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 86.144L470.39 83.4033V79.2462L475.149 82.0001V86.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 109.093L470.39 106.339V102.195L475.149 104.936V109.093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 116.738L470.39 113.984V109.841L475.149 112.594V116.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 124.384L470.39 121.643V117.486L475.149 120.24V124.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 340.852L608.417 343.593V339.449L613.176 336.708V340.852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 356.142L608.417 358.896V354.739L613.176 351.999V356.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 348.497L608.417 351.238V347.094L613.176 344.353V348.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 70.8403L470.39 68.0995V63.9556L475.149 66.6964V70.8403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 78.4987L470.39 75.7448V71.6009L475.149 74.3417V78.4987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 185.572L470.39 182.818V178.674L475.149 181.428V185.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 132.029L470.39 129.288V125.144L475.149 127.885V132.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 193.218L470.39 190.477V186.32L475.149 189.074V193.218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 200.863L470.39 198.122V193.978L475.149 196.719V200.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 170.269L470.39 167.528V163.384L475.149 166.125V170.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 177.927L470.39 175.173V171.029L475.149 173.77V177.927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 139.674L470.39 136.933V132.79L475.149 135.53V139.674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 147.333L470.39 144.579V140.435L475.149 143.176V147.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 162.623L470.39 159.882V155.739L475.149 158.479V162.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 154.978L470.39 152.237V148.08L475.149 150.834V154.978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 333.207L608.417 335.947V331.803L613.176 329.049V333.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 225.058L608.417 227.812V223.668L613.176 220.914V225.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 209.767L608.417 212.508V208.364L613.176 205.623V209.767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 217.412L608.417 220.166V216.009L613.176 213.268V217.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 209.046L470.39 206.305V202.148L475.149 204.902V209.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 233.241L608.417 235.995V231.837L613.176 229.097V233.241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 194.476L608.417 197.217V193.073L613.176 190.319V194.476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 179.173L608.417 181.914V177.77L613.176 175.029V179.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 202.122L608.417 204.863V200.719L613.176 197.978V202.122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 186.818L608.417 189.572V185.415L613.176 182.674V186.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 248.544L608.417 251.285V247.141L613.176 244.387V248.544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 240.886L608.417 243.64V239.483L613.176 236.742V240.886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 294.429L608.417 297.17V293.026L613.176 290.285V294.429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 171.527L608.417 174.268V170.124L613.176 167.384V171.527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 310.257L608.417 312.998V308.854L613.176 306.114V310.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 317.903L608.417 320.644V316.5L613.176 313.759V317.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 256.19L608.417 258.93V254.786L613.176 252.046V256.19Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 325.548L608.417 328.302V324.145L613.176 321.404V325.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 263.835L608.417 266.576V262.432L613.176 259.691V263.835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 271.48L608.417 274.234V270.077L613.176 267.336V271.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 279.139L608.417 281.879V277.735L613.176 274.982V279.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 286.784L608.417 289.525V285.381L613.176 282.627V286.784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 302.075L608.417 304.828V300.671L613.176 297.931V302.075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 145.379L480.249 142.638V138.494L484.995 141.235V145.379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 137.733L480.249 134.993V130.836L484.995 133.589V137.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 153.024L480.249 150.283V146.139L484.995 148.88V153.024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 160.682L480.249 157.929V153.785L484.995 156.525V160.682Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 168.328L480.249 165.574V161.43L484.995 164.184V168.328Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 99.4938L480.249 96.7399V92.596L484.995 95.3499V99.4938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 216.691L470.39 213.95V209.806L475.149 212.547V216.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 130.088L480.249 127.334V123.19L484.995 125.931V130.088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 175.973L480.249 173.232V169.075L484.995 171.829V175.973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 122.43L480.249 119.689V115.545L484.995 118.286V122.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 114.784L480.249 112.044V107.9L484.995 110.64V114.784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 237.686L480.249 234.945V230.801L484.995 233.542V237.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 222.396L480.249 219.655V215.498L484.995 218.252V222.396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 230.041L480.249 227.3V223.143L484.995 225.897V230.041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 91.8485L480.249 89.0946V84.9507L484.995 87.6915V91.8485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 245.345L480.249 242.591V238.447L484.995 241.188V245.345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 252.99L480.249 250.236V246.092L484.995 248.833V252.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 191.264L480.249 188.523V184.379L484.995 187.12V191.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 183.618L480.249 180.878V176.734L484.995 179.474V183.618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 198.922L480.249 196.168V192.024L484.995 194.765V198.922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 214.75L480.249 211.996V207.852L484.995 210.593V214.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 206.567L480.249 203.827V199.669L484.995 202.423V206.567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 107.139L480.249 104.398V100.241L484.995 102.995V107.139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 293.708L470.39 290.967V286.81L475.149 289.564V293.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 84.1901L480.249 81.4493V77.3054L484.995 80.0461V84.1901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 277.88L470.39 275.139V270.982L475.149 273.736V277.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 254.931L470.39 252.19V248.046L475.149 250.787V254.931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 286.063L470.39 283.309V279.165L475.149 281.906V286.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 270.234L470.39 267.481V263.337L475.149 266.077V270.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 231.995L470.39 229.241V225.097L475.149 227.838V231.995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 224.336L470.39 221.596V217.452L475.149 220.192V224.336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 239.64L470.39 236.899V232.742L475.149 235.496V239.64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 247.285L470.39 244.545V240.388L475.149 243.141V247.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 262.589L470.39 259.835V255.691L475.149 258.432V262.589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 354.897L470.39 352.143V347.999L475.149 350.74V354.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 347.238L470.39 344.497V340.354L475.149 343.094V347.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 76.5448L480.249 73.804V69.6601L484.995 72.4008V76.5448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 339.593L470.39 336.852V332.708L475.149 335.449V339.593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 308.999L470.39 306.258V302.114L475.149 304.855V308.999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 301.353L470.39 298.613V294.469L475.149 297.209V301.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 316.657L470.39 313.903V309.759L475.149 312.5V316.657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 324.302L470.39 321.548V317.404L475.149 320.158V324.302Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 331.948L470.39 329.207V325.05L475.149 327.804V331.948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 298.18L588.711 300.921V296.777L593.457 294.036V298.18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 290.534L588.711 293.275V289.131L593.457 286.391V290.534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 282.889L588.711 285.63V281.486L593.457 278.732V282.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 305.825L588.711 308.579V304.422L593.457 301.681V305.825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 321.653L588.711 324.407V320.25L593.457 317.509V321.653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 244.65L588.711 247.39V243.246L593.457 240.492V244.65Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 329.299L588.711 332.053V327.909L593.457 325.155V329.299Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 275.231L588.711 277.985V273.828L593.457 271.087V275.231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 252.295L588.711 255.036V250.892L593.457 248.138V252.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 259.94L588.711 262.681V258.537L593.457 255.796V259.94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 267.585L588.711 270.339V266.182L593.457 263.442V267.585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 305.222L376.873 302.468V298.324L381.632 301.065V305.222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 336.957L588.711 339.698V335.554L593.457 332.8V336.957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 260.635L480.249 257.894V253.737L484.995 256.491V260.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 344.602L588.711 347.343V343.199L593.457 340.458V344.602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 352.248L588.711 354.988V350.845L593.457 348.104V352.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 236.467L588.711 239.207V235.063L593.457 232.323V236.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 228.821L588.711 231.562V227.418L593.457 224.664V228.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 144.067L588.711 146.821V142.664L593.457 139.923V144.067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 136.422L588.711 139.176V135.019L593.457 132.278V136.422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 198.227L588.711 200.968V196.824L593.457 194.07V198.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 205.872L588.711 208.613V204.469L593.457 201.728V205.872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 190.569L588.711 193.322V189.165L593.457 186.425V190.569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 213.518L588.711 216.258V212.114L593.457 209.374V213.518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 221.163L588.711 223.917V219.76L593.457 217.019V221.163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 175.278L588.711 178.019V173.875L593.457 171.134V175.278Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 159.371L588.711 162.112V157.968L593.457 155.227V159.371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 167.633L588.711 170.373V166.23L593.457 163.476V167.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 151.726L588.711 154.467V150.323L593.457 147.569V151.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.457 182.923L588.711 185.677V181.52L593.457 178.779V182.923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 246.59L598.571 249.331V245.187L603.317 242.446V246.59Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 331.253L598.571 333.993V329.849L603.317 327.109V331.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 346.543L598.571 349.297V345.153L603.317 342.399V346.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 354.202L598.571 356.942V352.798L603.317 350.045V354.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 323.607L598.571 326.348V322.204L603.317 319.463V323.607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 300.134L598.571 302.874V298.731L603.317 295.977V300.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 307.779L598.571 310.52V306.376L603.317 303.635V307.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 315.962L598.571 318.703V314.559L603.317 311.805V315.962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 140.317L608.417 143.071V138.914L613.176 136.173V140.317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 132.671L608.417 135.412V131.268L613.176 128.528V132.671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 147.975L608.417 150.716V146.572L613.176 143.818V147.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 156.224L608.417 158.978V154.834L613.176 152.08V156.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 125.026L608.417 127.767V123.623L613.176 120.882V125.026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 292.475L598.571 295.229V291.072L603.317 288.331V292.475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 338.898L598.571 341.652V337.495L603.317 334.754V338.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 177.232L598.571 179.973V175.829L603.317 173.075V177.232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 169.573L598.571 172.327V168.17L603.317 165.43V169.573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 184.877L598.571 187.618V183.474L603.317 180.733V184.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 192.523L598.571 195.263V191.119L603.317 188.379V192.523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 161.928L598.571 164.669V160.525L603.317 157.784V161.928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 200.168L598.571 202.922V198.765L603.317 196.024V200.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 284.83L598.571 287.584V283.427L603.317 280.686V284.83Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 153.667L598.571 156.42V152.263L603.317 149.523V153.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 130.731L598.571 133.471V129.327L603.317 126.574V130.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 146.021L598.571 148.762V144.618L603.317 141.877V146.021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 138.376L598.571 141.117V136.973L603.317 134.219V138.376Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 254.236L598.571 256.99V252.833L603.317 250.092V254.236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.176 163.882L608.417 166.623V162.479L613.176 159.725V163.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 261.894L598.571 264.635V260.491L603.317 257.737V261.894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 269.539L598.571 272.28V268.136L603.317 265.382V269.539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 207.813L598.571 210.567V206.423L603.317 203.669V207.813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 277.185L598.571 279.925V275.782L603.317 273.041V277.185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 215.472L598.571 218.212V214.068L603.317 211.314V215.472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 238.945L598.571 241.686V237.542L603.317 234.801V238.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 223.117L598.571 225.858V221.714L603.317 218.973V223.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.317 230.762L598.571 233.503V229.359L603.317 226.618V230.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 183.736L367.027 180.982V176.839L371.773 179.579V183.736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 191.382L367.027 188.641V184.484L371.773 187.238V191.382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 199.027L367.027 196.286V192.142L371.773 194.883V199.027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 214.331L367.027 211.577V207.433L371.773 210.174V214.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 206.672L367.027 203.931V199.788L371.773 202.528V206.672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 153.142L367.027 150.388V146.244L371.773 148.998V153.142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 222.5L367.027 219.76V215.616L371.773 218.357V222.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 145.497L367.027 142.743V138.599L371.773 141.34V145.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 168.433L367.027 165.692V161.548L371.773 164.289V168.433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 160.787L367.027 158.047V153.889L371.773 156.643V160.787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 176.078L367.027 173.337V169.193L371.773 171.934V176.078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 230.159L367.027 227.405V223.261L371.773 226.002V230.159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 283.689L367.027 280.948V276.791L371.773 279.545V283.689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 276.044L367.027 273.303V269.146L371.773 271.9V276.044Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 291.334L367.027 288.594V284.45L371.773 287.19V291.334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 137.235L367.027 134.481V130.337L371.773 133.078V137.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 268.399L367.027 265.645V261.501L371.773 264.241V268.399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 299.517L367.027 296.777V292.62L371.773 295.373V299.517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 245.45L367.027 242.709V238.552L371.773 241.306V245.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 237.804L367.027 235.05V230.906L371.773 233.647V237.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 253.095L367.027 250.354V246.21L371.773 248.951V253.095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 260.74L367.027 257.999V253.855L371.773 256.596V260.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 339.711L357.168 336.957V332.813L361.914 335.554V339.711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 355.002L357.168 352.261V348.117L361.914 350.858V355.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 37.8069L367.027 35.053V30.909L371.773 33.6498V37.8069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 347.356L357.168 344.615V340.458L361.914 343.212V347.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 45.4522L367.027 42.7114V38.5543L371.773 41.3082V45.4522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 316.762L357.168 314.021V309.864L361.914 312.618V316.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 324.407L357.168 321.666V317.523L361.914 320.263V324.407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 129.577L367.027 126.836V122.692L371.773 125.433V129.577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 307.163L367.027 304.422V300.278L371.773 303.019V307.163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 332.066L357.168 329.312V325.168L361.914 327.909V332.066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 53.0975L367.027 50.3567V46.2128L371.773 48.9535V53.0975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 91.3371L367.027 88.5963V84.4524L371.773 87.1931V91.3371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 98.9955L367.027 96.2416V92.0977L371.773 94.8384V98.9955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 121.931L367.027 119.191V115.047L371.773 117.787V121.931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 114.286L367.027 111.545V107.388L371.773 110.142V114.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 106.641L367.027 103.887V99.743L371.773 102.497V106.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 68.4012L367.027 65.6473V61.5034L371.773 64.2441V68.4012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 83.6918L367.027 80.951V76.7939L371.773 79.5478V83.6918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 60.7428L367.027 58.002V53.858L371.773 56.5988V60.7428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 76.0465L367.027 73.3057V69.1487L371.773 71.9025V76.0465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 353.061L367.027 350.307V346.163L371.773 348.904V353.061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 314.808L367.027 312.067V307.923L371.773 310.664V314.808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 189.428L376.873 186.687V182.543L381.632 185.284V189.428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 181.782L376.873 179.042V174.898L381.632 177.638V181.782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 268.28L480.249 265.54V261.396L484.995 264.137V268.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 204.731L376.873 201.978V197.834L381.632 200.587V204.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 174.137L376.873 171.396V167.239L381.632 169.993V174.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 151.188L376.873 148.447V144.303L381.632 147.044V151.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 158.833L376.873 156.093V151.949L381.632 154.689V158.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 166.492L376.873 163.738V159.594L381.632 162.335V166.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 220.022L376.873 217.281V213.137L381.632 215.878V220.022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 212.377L376.873 209.636V205.479L381.632 208.233V212.377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 266.445L376.873 263.704V259.547L381.632 262.301V266.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 281.748L376.873 278.994V274.85L381.632 277.591V281.748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 274.09L376.873 271.349V267.205L381.632 269.946V274.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 289.394L376.873 286.64V282.496L381.632 285.237V289.394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 297.039L376.873 294.298V290.141L381.632 292.895V297.039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 235.85L376.873 233.109V228.966L381.632 231.706V235.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 243.496L376.873 240.755V236.611L381.632 239.352V243.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 228.205L376.873 225.464V221.307L381.632 224.061V228.205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 258.799L376.873 256.058V251.901L381.632 254.655V258.799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 251.154L376.873 248.4V244.256L381.632 246.997V251.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 197.086L376.873 194.332V190.188L381.632 192.929V197.086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 309.117L357.168 306.363V302.219L361.914 304.973V309.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 51.1566L376.873 48.4027V44.2588L381.632 46.9996V51.1566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 43.4982L376.873 40.7574V36.6135L381.632 39.3543V43.4982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 322.466L367.027 319.713V315.569L371.773 318.309V322.466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 330.112L367.027 327.371V323.214L371.773 325.968V330.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 337.757L367.027 335.016V330.872L371.773 333.613V337.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.773 345.402L367.027 342.661V338.518L371.773 341.258V345.402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 97.0415L376.873 94.3008V90.1437L381.632 92.8976V97.0415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 104.687L376.873 101.946V97.8021L381.632 100.543V104.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 112.332L376.873 109.591V105.447L381.632 108.188V112.332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 135.281L376.873 132.54V128.383L381.632 131.137V135.281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 127.636L376.873 124.895V120.738L381.632 123.492V127.636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 119.991L376.873 117.237V113.093L381.632 115.833V119.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 89.3962L376.873 86.6423V82.4984L381.632 85.2392V89.3962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 66.4472L376.873 63.7065V59.5494L381.632 62.3033V66.4472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 74.0925L376.873 71.3517V67.2078L381.632 69.9486V74.0925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 58.8019L376.873 56.0612V51.9041L381.632 54.658V58.8019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 81.7509L376.873 78.9971V74.8531L381.632 77.5939V81.7509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.632 142.926L376.873 140.186V136.042L381.632 138.782V142.926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 181.677L490.108 178.924V174.78L494.854 177.52V181.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 189.323L490.108 186.582V182.425L494.854 185.179V189.323Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 196.968L490.108 194.227V190.07L494.854 192.824V196.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 204.613L490.108 201.873V197.729L494.854 200.469V204.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 212.272L490.108 209.518V205.374L494.854 208.115V212.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 143.438L490.108 140.684V136.54L494.854 139.281V143.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 151.083L490.108 148.329V144.185L494.854 146.939V151.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 220.442L490.108 217.701V213.557L494.854 216.298V220.442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 174.019L490.108 171.278V167.134L494.854 169.875V174.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 158.728L490.108 155.988V151.831L494.854 154.585V158.728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 301.471L357.168 298.717V294.574L361.914 297.314V301.471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 281.63L490.108 278.889V274.732L494.854 277.486V281.63Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 228.087L490.108 225.346V221.202L494.854 223.943V228.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 273.985L490.108 271.244V267.087L494.854 269.841V273.985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 297.459L490.108 294.718V290.561L494.854 293.315V297.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 289.276L490.108 286.535V282.391L494.854 285.132V289.276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 266.34L490.108 263.586V259.442L494.854 262.183V266.34Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 135.779L490.108 133.039V128.895L494.854 131.636V135.779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 243.391L490.108 240.65V236.493L494.854 239.247V243.391Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 235.745L490.108 232.991V228.848L494.854 231.588V235.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 251.036L490.108 248.295V244.151L494.854 246.892V251.036Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 258.681L490.108 255.94V251.797L494.854 254.537V258.681Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 337.652L480.249 334.898V330.754L484.995 333.495V337.652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 128.134L490.108 125.393V121.249L494.854 123.99V128.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 322.348L480.249 319.608V315.464L484.995 318.204V322.348Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 314.703L480.249 311.962V307.805L484.995 310.559V314.703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 305.104L490.108 302.363V298.219L494.854 300.96V305.104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 329.994L480.249 327.253V323.109L484.995 325.85V329.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 283.584L480.249 280.83V276.686L484.995 279.427V283.584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 345.297L480.249 342.557V338.4L484.995 341.153V345.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 275.926L480.249 273.185V269.041L484.995 271.782V275.926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 299.412L480.249 296.659V292.515L484.995 295.255V299.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 291.754L480.249 289.013V284.869L484.995 287.61V291.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 307.058L480.249 304.304V300.16L484.995 302.914V307.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 97.5399L490.108 94.7991V90.6552L494.854 93.3959V97.5399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 352.943L480.249 350.202V346.058L484.995 348.799V352.943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 105.185L490.108 102.444V98.3004L494.854 101.041V105.185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 112.844L490.108 110.09V105.946L494.854 108.687V112.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 120.489L490.108 117.748V113.591L494.854 116.345V120.489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 89.8946L490.108 87.1538V82.9967L494.854 85.7506V89.8946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 82.2493L490.108 79.4954V75.3514L494.854 78.1053V82.2493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.149 63.2999L470.39 60.546V56.4021L475.149 59.1429V63.2999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.995 68.9913L480.249 66.2505V62.1066L484.995 64.8474V68.9913Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 74.6957L490.108 71.9419V67.7979L494.854 70.5518V74.6957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 166.374L490.108 163.633V159.489L494.854 162.23V166.374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 193.336L357.168 190.582V186.438L361.914 189.179V193.336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 178.032L357.168 175.291V171.134L361.914 173.888V178.032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 185.677L357.168 182.936V178.792L361.914 181.533V185.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 208.626L357.168 205.885V201.728L361.914 204.482V208.626Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 139.792L357.168 137.051V132.894L361.914 135.648V139.792Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 200.981L357.168 198.227V194.083L361.914 196.824V200.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 147.438L357.168 144.697V140.553L361.914 143.294V147.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 170.387L357.168 167.633V163.489L361.914 166.243V170.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 155.083L357.168 152.342V148.198L361.914 150.939V155.083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 162.741L357.168 159.987V155.843L361.914 158.584V162.741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 312.749L490.108 310.008V305.864L494.854 308.605V312.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 277.985L357.168 275.244V271.1L361.914 273.841V277.985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 262.694L357.168 259.953V255.796L361.914 258.55V262.694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 270.339L357.168 267.599V263.455L361.914 266.195V270.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 285.643L357.168 282.889V278.745L361.914 281.486V285.643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 293.813L357.168 291.072V286.928L361.914 289.669V293.813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 232.1L357.168 229.359V225.202L361.914 227.956V232.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 239.745L357.168 237.004V232.86L361.914 235.601V239.745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 224.454L357.168 221.714V217.557L361.914 220.31V224.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 255.049L357.168 252.295V248.151L361.914 250.892V255.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 247.403L357.168 244.65V240.506L361.914 243.246V247.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 216.809L357.168 214.055V209.911L361.914 212.652V216.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 131.531L357.168 128.79V124.633L361.914 127.387V131.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 358.647L490.108 355.893V351.749L494.854 354.503V358.647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 47.4061L357.168 44.6522V40.5083L361.914 43.2491V47.4061Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 39.7477L357.168 37.0069V32.863L361.914 35.6037V39.7477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 32.1024L357.168 29.3616V25.2177L361.914 27.9584V32.1024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 320.408L490.108 317.654V313.51L494.854 316.25V320.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 328.053L490.108 325.312V321.155L494.854 323.909V328.053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 335.698L490.108 332.957V328.8L494.854 331.554V335.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 343.343L490.108 340.603V336.459L494.854 339.2V343.343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.854 351.002L490.108 348.248V344.104L494.854 346.845V351.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 108.582L357.168 105.841V101.697L361.914 104.438V108.582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 93.291L357.168 90.5502V86.3932L361.914 89.1471V93.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 100.936L357.168 98.1955V94.0516L361.914 96.7924V100.936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 116.24L357.168 113.486V109.342L361.914 112.083V116.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 123.885L357.168 121.131V116.987L361.914 119.741V123.885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 62.6967L357.168 59.9559V55.7989L361.914 58.5528V62.6967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 55.0514L357.168 52.2975V48.1536L361.914 50.9075V55.0514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 70.342L357.168 67.6012V63.4573L361.914 66.1981V70.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 77.9873L357.168 75.2465V71.1026L361.914 73.8434V77.9873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.914 85.6457L357.168 82.8918V78.7479L361.914 81.4887V85.6457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 108.45L185.054 111.204V107.06L189.813 104.307V108.45Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 100.805L185.054 103.559V99.402L189.813 96.6612V100.805Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 116.109L185.054 118.85V114.706L189.813 111.952V116.109Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 124.541L185.054 127.282V123.138L189.813 120.397V124.541Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 132.186L185.054 134.94V130.783L189.813 128.042V132.186Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 77.4759L185.054 80.2297V76.0727L189.813 73.3319V77.4759Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 224.586L185.054 227.326V223.182L189.813 220.429V224.586Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 62.1853L185.054 64.926V60.7821L189.813 58.0282V62.1853Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 69.8306L185.054 72.5713V68.4274L189.813 65.6866V69.8306Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 139.845L185.054 142.586V138.442L189.813 135.688V139.845Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 85.1212L185.054 87.875V83.7311L189.813 80.9772V85.1212Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 216.927L185.054 219.681V215.524L189.813 212.783V216.927Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 237.935L175.195 240.676V236.532L179.954 233.778V237.935Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 186.346L185.054 189.087V184.943L189.813 182.189V186.346Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 193.991L185.054 196.732V192.588L189.813 189.834V193.991Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 209.282L185.054 212.036V207.879L189.813 205.138V209.282Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 147.49L185.054 150.231V146.087L189.813 143.333V147.49Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 54.54L185.054 57.2807V53.1368L189.813 50.3829V54.54Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 155.135L185.054 157.876V153.732L189.813 150.991V155.135Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 162.781L185.054 165.534V161.377L189.813 158.637V162.781Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 171.042L185.054 173.783V169.639L189.813 166.898V171.042Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 178.688L185.054 181.441V177.284L189.813 174.544V178.688Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 93.0812L185.054 95.8351V91.678L189.813 88.9373V93.0812Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 284.345L175.195 287.099V282.942L179.954 280.201V284.345Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 292.003L175.195 294.744V290.6L179.954 287.846V292.003Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 299.649L175.195 302.389V298.245L179.954 295.505V299.649Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 276.699L175.195 279.44V275.296L179.954 272.556V276.699Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 307.294L175.195 310.035V305.891L179.954 303.15V307.294Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 245.581L175.195 248.321V244.177L179.954 241.424V245.581Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 314.939L175.195 317.693V313.536L179.954 310.795V314.939Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 253.751L175.195 256.504V252.36L179.954 249.607V253.751Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 261.409L175.195 264.15V260.006L179.954 257.252V261.409Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 269.054L175.195 271.795V267.651L179.954 264.91V269.054Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 338.413L175.195 341.167V337.009L179.954 334.269V338.413Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 322.584L175.195 325.338V321.194L179.954 318.44V322.584Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 353.716L175.195 356.457V352.313L179.954 349.572V353.716Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 46.8815L185.054 49.6354V45.4784L189.813 42.7376V46.8815Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 330.767L175.195 333.521V329.364L179.954 326.623V330.767Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 346.071L175.195 348.812V344.668L179.954 341.914V346.071Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 201.637L185.054 204.377V200.233L189.813 197.493V201.637Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 95.1138L194.913 97.8546V93.7106L199.672 90.9568V95.1138Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 102.759L194.913 105.5V101.356L199.672 98.6152V102.759Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 110.404L194.913 113.145V109.001L199.672 106.26V110.404Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 134.14L194.913 136.881V132.737L199.672 129.996V134.14Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 118.837L194.913 121.59V117.446L199.672 114.693V118.837Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 56.4808L194.913 59.2216V55.0776L199.672 52.3369V56.4808Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 71.7845L194.913 74.5253V70.3813L199.672 67.6275V71.7845Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 64.1261L194.913 66.88V62.7229L199.672 59.9822V64.1261Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 79.4298L194.913 82.1706V78.0266L199.672 75.2859V79.4298Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 87.3898L194.913 90.1306V85.9867L199.672 83.2328V87.3898Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 126.495L194.913 129.236V125.092L199.672 122.338V126.495Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 195.932L194.913 198.686V194.529L199.672 191.788V195.932Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 180.641L194.913 183.382V179.238L199.672 176.498V180.641Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 188.287L194.913 191.028V186.884L199.672 184.143V188.287Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 203.591L194.913 206.331V202.187L199.672 199.433V203.591Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 141.786L194.913 144.526V140.382L199.672 137.642V141.786Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 211.236L194.913 213.977V209.833L199.672 207.092V211.236Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 157.089L194.913 159.83V155.686L199.672 152.932V157.089Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 149.431L194.913 152.185V148.028L199.672 145.287V149.431Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 172.996L194.913 175.737V171.593L199.672 168.839V172.996Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 165.338L194.913 168.092V163.948L199.672 161.194V165.338Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 286.299L185.054 289.04V284.896L189.813 282.155V286.299Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 278.653L185.054 281.394V277.25L189.813 274.496V278.653Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 271.008L185.054 273.749V269.605L189.813 266.851V271.008Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 293.944L185.054 296.698V292.541L189.813 289.8V293.944Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 309.248L185.054 311.989V307.845L189.813 305.091V309.248Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 301.589L185.054 304.343V300.186L189.813 297.445V301.589Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 239.876L185.054 242.617V238.473L189.813 235.732V239.876Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 263.35L185.054 266.104V261.947L189.813 259.206V263.35Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 248.059L185.054 250.8V246.656L189.813 243.915V248.059Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 255.704L185.054 258.445V254.301L189.813 251.56V255.704Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 340.367L185.054 343.107V338.963L189.813 336.223V340.367Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 355.657L185.054 358.411V354.267L189.813 351.513V355.657Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 41.1902L194.913 43.931V39.787L199.672 37.0331V41.1902Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 232.231L185.054 234.972V230.828L189.813 228.087V232.231Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 332.721L185.054 335.462V331.318L189.813 328.577V332.721Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 348.012L185.054 350.766V346.609L189.813 343.868V348.012Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 316.893L185.054 319.634V315.49L189.813 312.749V316.893Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.813 325.076L185.054 327.817V323.673L189.813 320.919V325.076Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 48.8355L194.913 51.5763V47.4323L199.672 44.6916V48.8355Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 351.762L165.349 354.516V350.359L170.095 347.618V351.762Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 127.505L165.349 130.245V126.102L170.095 123.361V127.505Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 135.937L165.349 138.691V134.534L170.095 131.793V135.937Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 143.595L165.349 146.336V142.192L170.095 139.438V143.595Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 151.241L165.349 153.981V149.837L170.095 147.097V151.241Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 119.859L165.349 122.6V118.456L170.095 115.702V119.859Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 96.5301L165.349 99.2709V95.1269L170.095 92.373V96.5301Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 112.214L165.349 114.955V110.811L170.095 108.057V112.214Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 158.886L165.349 161.627V157.483L170.095 154.742V158.886Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 88.8848L165.349 91.6256V87.4816L170.095 84.7278V88.8848Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 104.477L165.349 107.231V103.087L170.095 100.333V104.477Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 81.2264L165.349 83.9803V79.8232L170.095 77.0824V81.2264Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 166.531L165.349 169.285V165.128L170.095 162.387V166.531Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 213.032L165.349 215.786V211.629L170.095 208.888V213.032Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 235.981L165.349 238.722V234.578L170.095 231.837V235.981Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 205.387L165.349 208.128V203.984L170.095 201.243V205.387Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 228.336L165.349 231.077V226.933L170.095 224.179V228.336Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 220.691L165.349 223.432V219.288L170.095 216.534V220.691Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 197.742L165.349 200.483V196.339L170.095 193.598V197.742Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 174.176L165.349 176.93V172.786L170.095 170.033V174.176Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 182.438L165.349 185.192V181.035L170.095 178.294V182.438Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 190.097L165.349 192.837V188.693L170.095 185.939V190.097Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 73.5811L165.349 76.3219V72.1779L170.095 69.4371V73.5811Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 285.289L317.627 288.03V283.886L322.373 281.145V285.289Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 293.472L317.627 296.213V292.069L322.373 289.328V293.472Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 277.644L317.627 280.384V276.241L322.373 273.5V277.644Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 301.117L317.627 303.858V299.714L322.373 296.973V301.117Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 308.763L317.627 311.516V307.359L322.373 304.619V308.763Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 269.998L317.627 272.739V268.595L322.373 265.841V269.998Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 247.049L317.627 249.79V245.646L322.373 242.905V247.049Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 254.695L317.627 257.449V253.291L322.373 250.551V254.695Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 324.066L317.627 326.807V322.663L322.373 319.909V324.066Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 262.34L317.627 265.094V260.937L322.373 258.196V262.34Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 243.627L165.349 246.381V242.224L170.095 239.483V243.627Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 230.277L175.195 233.031V228.874L179.954 226.133V230.277Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 58.2905L165.349 61.0313V56.8873L170.095 54.1334V58.2905Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 65.9358L165.349 68.6765V64.5326L170.095 61.7918V65.9358Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 339.357L317.627 342.098V337.954L322.373 335.213V339.357Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 331.712L317.627 334.452V330.308L322.373 327.568V331.712Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 347.002L317.627 349.756V345.599L322.373 342.858V347.002Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 354.661L317.627 357.401V353.257L322.373 350.504V354.661Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 121.8L175.195 124.554V120.397L179.954 117.656V121.8Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 114.155L175.195 116.896V112.752L179.954 110.011V114.155Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 137.891L175.195 140.632V136.488L179.954 133.747V137.891Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 130.245L175.195 132.986V128.842L179.954 126.088V130.245Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 145.536L175.195 148.29V144.133L179.954 141.392V145.536Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 106.51L175.195 109.25V105.106L179.954 102.366V106.51Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 75.535L175.195 78.2758V74.1319L179.954 71.378V75.535Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 83.1803L175.195 85.9211V81.7772L179.954 79.0364V83.1803Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 98.7857L175.195 101.526V97.3825L179.954 94.6417V98.7857Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 90.8256L175.195 93.5664V89.4225L179.954 86.6817V90.8256Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 184.392L175.195 187.133V182.989L179.954 180.248V184.392Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 153.181L175.195 155.935V151.778L179.954 149.037V153.181Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 199.683L175.195 202.437V198.279L179.954 195.539V199.683Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 214.986L175.195 217.727V213.583L179.954 210.842V214.986Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 192.037L175.195 194.791V190.634L179.954 187.893V192.037Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 222.632L175.195 225.372V221.228L179.954 218.488V222.632Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 207.341L175.195 210.082V205.938L179.954 203.184V207.341Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 168.485L175.195 171.226V167.082L179.954 164.341V168.485Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 251.272L165.349 254.026V249.869L170.095 247.128V251.272Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 239.404L317.627 242.145V238.001L322.373 235.247V239.404Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 67.8766L175.195 70.6305V66.4734L179.954 63.7327V67.8766Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 160.84L175.195 163.581V159.437L179.954 156.683V160.84Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 305.34L165.349 308.094V303.95L170.095 301.196V305.34Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 297.695L165.349 300.448V296.291L170.095 293.551V297.695Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 320.644L165.349 323.384V319.24L170.095 316.5V320.644Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 312.998L165.349 315.739V311.595L170.095 308.841V312.998Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 328.289L165.349 331.03V326.886L170.095 324.145V328.289Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 290.049L165.349 292.79V288.646L170.095 285.905V290.049Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 259.455L165.349 262.196V258.052L170.095 255.311V259.455Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 60.2313L175.195 62.9852V58.8282L179.954 56.0874V60.2313Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 282.404L165.349 285.145V281.001L170.095 278.26V282.404Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 274.759L165.349 277.499V273.355L170.095 270.602V274.759Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 267.1L165.349 269.854V265.697L170.095 262.956V267.1Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 52.586L175.195 55.3268V51.1828L179.954 48.4421V52.586Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 344.117L165.349 346.858V342.714L170.095 339.973V344.117Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 218.881L194.913 221.622V217.478L199.672 214.737V218.881Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 336.472L165.349 339.213V335.069L170.095 332.328V336.472Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.954 176.747L175.195 179.487V175.344L179.954 172.59V176.747Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 219.55L82.7266 222.291V218.147L87.4726 215.406V219.55Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 227.195L82.7266 229.936V225.792L87.4726 223.051V227.195Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 235.378L82.7266 238.119V233.975L87.4726 231.221V235.378Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 243.023L82.7266 245.764V241.62L87.4726 238.88V243.023Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 250.669L82.7266 253.423V249.266L87.4726 246.525V250.669Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 258.314L82.7266 261.068V256.911L87.4726 254.17V258.314Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 181.31L82.7266 184.051V179.907L87.4726 177.153V181.31Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 188.956L82.7266 191.696V187.552L87.4726 184.812V188.956Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 196.601L82.7266 199.342V195.198L87.4726 192.457V196.601Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 204.246L82.7266 207V202.843L87.4726 200.102V204.246Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 211.905L82.7266 214.645V210.501L87.4726 207.748V211.905Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 273.618L82.7266 276.359V272.215L87.4726 269.474V273.618Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 265.972L82.7266 268.713V264.569L87.4726 261.815V265.972Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 320.04L82.7266 322.781V318.637L87.4726 315.883V320.04Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 312.395L82.7266 315.136V310.992L87.4726 308.238V312.395Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 335.331L82.7266 338.072V333.928L87.4726 331.187V335.331Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 327.686L82.7266 330.426V326.282L87.4726 323.542V327.686Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 304.212L82.7266 306.953V302.809L87.4726 300.055V304.212Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 173.652L82.7266 176.406V172.262L87.4726 169.508V173.652Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 281.263L82.7266 284.004V279.86L87.4726 277.119V281.263Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 288.908L82.7266 291.662V287.505L87.4726 284.764V288.908Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 296.567L82.7266 299.308V295.164L87.4726 292.41V296.567Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 356.326L72.8677 359.08V354.923L77.6137 352.182V356.326Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 342.976L82.7266 345.73V341.573L87.4726 338.832V342.976Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 309.903L72.8677 312.657V308.5L77.6137 305.759V309.903Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 226.526L194.913 229.28V225.123L199.672 222.382V226.526Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 318.086L72.8677 320.827V316.683L77.6137 313.942V318.086Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 341.035L72.8677 343.776V339.632L77.6137 336.891V341.035Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 325.732L72.8677 328.486V324.329L77.6137 321.588V325.732Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 333.39L72.8677 336.131V331.987L77.6137 329.233V333.39Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 142.022L82.7266 144.762V140.618L87.4726 137.865V142.022Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 135.124L82.7266 137.865V133.721L87.4726 130.98V135.124Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 166.007L82.7266 168.76V164.603L87.4726 161.863V166.007Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 158.361L82.7266 161.102V156.958L87.4726 154.217V158.361Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 149.667L82.7266 152.408V148.264L87.4726 145.523V149.667Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 348.681L72.8677 351.421V347.278L77.6137 344.537V348.681Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 260.268L92.5728 263.009V258.865L97.3318 256.124V260.268Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 267.913L92.5728 270.667V266.51L97.3318 263.769V267.913Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 275.559L92.5728 278.312V274.169L97.3318 271.415V275.559Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 290.862L92.5728 293.603V289.459L97.3318 286.718V290.862Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 283.217L92.5728 285.958V281.814L97.3318 279.06V283.217Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 244.977L92.5728 247.718V243.574L97.3318 240.82V244.977Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 229.674L92.5728 232.414V228.271L97.3318 225.53V229.674Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 252.623L92.5728 255.363V251.22L97.3318 248.466V252.623Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 237.319L92.5728 240.073V235.916L97.3318 233.175V237.319Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 298.508L92.5728 301.248V297.104L97.3318 294.364V298.508Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 352.575L92.5728 355.329V351.172L97.3318 348.432V352.575Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 221.491L92.5728 224.245V220.088L97.3318 217.347V221.491Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 344.93L92.5728 347.671V343.527L97.3318 340.786V344.93Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 321.981L92.5728 324.735V320.578L97.3318 317.837V321.981Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 337.285L92.5728 340.026V335.882L97.3318 333.128V337.285Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 314.336L92.5728 317.077V312.933L97.3318 310.192V314.336Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 306.691L92.5728 309.431V305.287L97.3318 302.547V306.691Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 329.626L92.5728 332.38V328.236L97.3318 325.483V329.626Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 129.419L92.5728 132.173V128.016L97.3318 125.275V129.419Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4726 350.635L82.7266 353.375V349.231L87.4726 346.478V350.635Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 213.845L92.5728 216.599V212.442L97.3318 209.702V213.845Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 183.251L92.5728 186.005V181.848L97.3318 179.107V183.251Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 190.91L92.5728 193.65V189.506L97.3318 186.753V190.91Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 198.555L92.5728 201.296V197.152L97.3318 194.398V198.555Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 175.606L92.5728 178.347V174.203L97.3318 171.462V175.606Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 206.2L92.5728 208.941V204.797L97.3318 202.056V206.2Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 160.315L92.5728 163.056V158.912L97.3318 156.158V160.315Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 167.961L92.5728 170.701V166.557L97.3318 163.817V167.961Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 152.657L92.5728 155.411V151.254L97.3318 148.513V152.657Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 143.962L92.5728 146.716V142.559L97.3318 139.818V143.962Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3318 136.317L92.5728 139.058V134.914L97.3318 132.173V136.317Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 192.706L63.0088 195.447V191.303L67.7679 188.562V192.706Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 153.417L63.0088 156.158V152.014L67.7679 149.273V153.417Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 161.063L63.0088 163.803V159.66L67.7679 156.919V161.063Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 177.416L63.0088 180.156V176.012L67.7679 173.258V177.416Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 185.061L63.0088 187.802V183.658L67.7679 180.904V185.061Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 169.757L63.0088 172.511V168.354L67.7679 165.613V169.757Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 277.368L63.0088 280.109V275.965L67.7679 273.224V277.368Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 146.52L63.0088 149.273V145.116L67.7679 142.376V146.52Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 246.774L63.0088 249.515V245.371L67.7679 242.63V246.774Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 254.419L63.0088 257.173V253.016L67.7679 250.275V254.419Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 262.078L63.0088 264.818V260.675L67.7679 257.921V262.078Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 238.591L63.0088 241.345V237.188L67.7679 234.447V238.591Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 269.723L63.0088 272.464V268.32L67.7679 265.566V269.723Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 207.997L63.0088 210.751V206.607L67.7679 203.853V207.997Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 200.351L63.0088 203.105V198.948L67.7679 196.207V200.351Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 215.655L63.0088 218.396V214.252L67.7679 211.498V215.655Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 230.946L63.0088 233.686V229.543L67.7679 226.802V230.946Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 223.3L63.0088 226.041V221.897L67.7679 219.156V223.3Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 272.949L194.913 275.69V271.546L199.672 268.805V272.949Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 280.594L194.913 283.348V279.191L199.672 276.45V280.594Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 295.898L194.913 298.639V294.495L199.672 291.741V295.898Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 288.253L194.913 290.993V286.85L199.672 284.096V288.253Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 303.543L194.913 306.284V302.14L199.672 299.399V303.543Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 242.355L194.913 245.109V240.952L199.672 238.211V242.355Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 234.172L194.913 236.926V232.782L199.672 230.028V234.172Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 250L194.913 252.754V248.597L199.672 245.856V250Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 257.658L194.913 260.399V256.255L199.672 253.501V257.658Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 265.304L194.913 268.044V263.901L199.672 261.16V265.304Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 302.258L72.8677 305.012V300.855L77.6137 298.114V302.258Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 349.966L194.913 352.707V348.563L199.672 345.822V349.966Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 311.189L194.913 313.942V309.785L199.672 307.045V311.189Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 319.372L194.913 322.112V317.968L199.672 315.228V319.372Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 327.017L194.913 329.758V325.614L199.672 322.873V327.017Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 334.662L194.913 337.416V333.259L199.672 330.518V334.662Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.672 342.321L194.913 345.061V340.917L199.672 338.163V342.321Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 187.002L72.8677 189.756V185.598L77.6137 182.858V187.002Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 194.66L72.8677 197.401V193.257L77.6137 190.503V194.66Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 209.951L72.8677 212.691V208.547L77.6137 205.807V209.951Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 179.356L72.8677 182.097V177.953L77.6137 175.212V179.356Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 202.305L72.8677 205.046V200.902L77.6137 198.161V202.305Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 147.713L72.8677 150.467V146.31L77.6137 143.569V147.713Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 217.596L72.8677 220.35V216.193L77.6137 213.452V217.596Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 155.371L72.8677 158.112V153.968L77.6137 151.214V155.371Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 171.711L72.8677 174.452V170.308L77.6137 167.567V171.711Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 164.066L72.8677 166.807V162.663L77.6137 159.909V164.066Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 248.728L72.8677 251.469V247.325L77.6137 244.571V248.728Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 271.664L72.8677 274.418V270.261L77.6137 267.52V271.664Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 279.322L72.8677 282.063V277.919L77.6137 275.165V279.322Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 264.019L72.8677 266.759V262.615L77.6137 259.875V264.019Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 286.968L72.8677 289.708V285.564L77.6137 282.81V286.968Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 294.613L72.8677 297.354V293.21L77.6137 290.469V294.613Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 225.241L72.8677 227.995V223.851L77.6137 221.097V225.241Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 256.373L72.8677 259.114V254.97L77.6137 252.229V256.373Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 232.9L72.8677 235.64V231.497L77.6137 228.743V232.9Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 241.07L72.8677 243.823V239.666L77.6137 236.926V241.07Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6137 140.828L72.8677 143.569V139.425L77.6137 136.671V140.828Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 339.081L63.0088 341.835V337.678L67.7679 334.938V339.081Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 331.436L63.0088 334.177V330.033L67.7679 327.292V331.436Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 285.014L63.0088 287.754V283.61L67.7679 280.87V285.014Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 323.791L63.0088 326.532V322.388L67.7679 319.634V323.791Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 354.385L63.0088 357.126V352.982L67.7679 350.228V354.385Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 346.727L63.0088 349.481V345.324L67.7679 342.583V346.727Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 292.659L63.0088 295.413V291.256L67.7679 288.515V292.659Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 300.317L63.0088 303.058V298.914L67.7679 296.16V300.317Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 315.608L63.0088 318.349V314.205L67.7679 311.464V315.608Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7679 307.963L63.0088 310.703V306.559L67.7679 303.819V307.963Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 316.408L317.627 319.162V315.018L322.373 312.264V316.408Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 355.893L505.723 358.647V354.503L510.482 351.749V355.893Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 73.804L515.582 76.5448V72.4008L520.341 69.6601V73.804Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 317.654L505.723 320.408V316.25L510.482 313.51V317.654Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 81.4493L515.582 84.1901V80.0461L520.341 77.3054V81.4493Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 325.312L505.723 328.053V323.909L510.482 321.155V325.312Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 310.008L505.723 312.749V308.605L510.482 305.864V310.008Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 340.603L505.723 343.343V339.2L510.482 336.459V340.603Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 348.248L505.723 351.002V346.845L510.482 344.104V348.248Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 332.957L505.723 335.698V331.554L510.482 328.8V332.957Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 142.638L515.582 145.379V141.235L520.341 138.494V142.638Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 134.993L515.582 137.733V133.589L520.341 130.836V134.993Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 150.283L515.582 153.024V148.88L520.341 146.139V150.283Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 127.334L515.582 130.088V125.931L520.341 123.19V127.334Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 157.929L515.582 160.682V156.525L520.341 153.785V157.929Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 119.689L515.582 122.43V118.286L520.341 115.545V119.689Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 96.7399L515.582 99.4938V95.3499L520.341 92.596V96.7399Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 89.0946L515.582 91.8485V87.6915L520.341 84.9507V89.0946Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 104.398L515.582 107.139V102.995L520.341 100.241V104.398Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 112.044L515.582 114.784V110.64L520.341 107.9V112.044Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 178.924L505.723 181.677V177.52L510.482 174.78V178.924Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 186.582L505.723 189.323V185.179L510.482 182.425V186.582Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 194.227L505.723 196.968V192.824L510.482 190.07V194.227Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 165.574L515.582 168.328V164.184L520.341 161.43V165.574Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 201.873L505.723 204.613V200.469L510.482 197.729V201.873Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 302.363L505.723 305.104V300.96L510.482 298.219V302.363Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 217.701L505.723 220.442V216.298L510.482 213.557V217.701Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 171.278L505.723 174.019V169.875L510.482 167.134V171.278Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 148.329L505.723 151.083V146.939L510.482 144.185V148.329Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 155.988L505.723 158.728V154.585L510.482 151.831V155.988Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 163.633L505.723 166.374V162.23L510.482 159.489V163.633Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 209.518L505.723 212.272V208.115L510.482 205.374V209.518Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 278.889L505.723 281.63V277.486L510.482 274.732V278.889Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 271.244L505.723 273.985V269.841L510.482 267.087V271.244Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 286.535L505.723 289.276V285.132L510.482 282.391V286.535Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 225.346L505.723 228.087V223.943L510.482 221.202V225.346Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 263.586L505.723 266.34V262.183L510.482 259.442V263.586Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 294.718L505.723 297.459V293.315L510.482 290.561V294.718Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 240.65L505.723 243.391V239.247L510.482 236.493V240.65Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 232.991L505.723 235.745V231.588L510.482 228.848V232.991Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 255.94L505.723 258.681V254.537L510.482 251.797V255.94Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 248.295L505.723 251.036V246.892L510.482 244.151V248.295Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 144.762L398.138 147.516V143.359L402.884 140.618V144.762Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 60.6378L398.138 63.3786V59.2347L402.884 56.4939V60.6378Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 52.9925L398.138 55.7333V51.5894L402.884 48.8355V52.9925Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 68.2831L398.138 71.0239V66.88L402.884 64.1392V68.2831Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 83.5869L398.138 86.3276V82.1837L402.884 79.4298V83.5869Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 75.9284L398.138 78.6823V74.5253L402.884 71.7845V75.9284Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 45.3341L398.138 48.088V43.9441L402.884 41.1902V45.3341Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 350.202L515.582 352.943V348.799L520.341 346.058V350.202Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 342.557L515.582 345.297V341.153L520.341 338.4V342.557Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 137.117L398.138 139.858V135.714L402.884 132.973V137.117Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 140.684L505.723 143.438V139.281L510.482 136.54V140.684Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 160.669L398.138 163.423V159.279L402.884 156.525V160.669Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 173.232L515.582 175.973V171.829L520.341 169.075V173.232Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 91.2322L398.138 93.9729V89.829L402.884 87.0882V91.2322Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 153.024L398.138 155.778V151.621L402.884 148.88V153.024Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 121.826L398.138 124.567V120.423L402.884 117.669V121.826Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 106.523L398.138 109.277V105.12L402.884 102.379V106.523Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 98.8775L398.138 101.618V97.4743L402.884 94.7335V98.8775Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 114.168L398.138 116.922V112.778L402.884 110.024V114.168Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 129.472L398.138 132.213V128.069L402.884 125.328V129.472Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 211.996L515.582 214.75V210.593L520.341 207.852V211.996Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 227.3L515.582 230.041V225.897L520.341 223.143V227.3Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 219.655L515.582 222.396V218.252L520.341 215.498V219.655Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 234.945L515.582 237.686V233.542L520.341 230.801V234.945Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 242.591L515.582 245.345V241.188L520.341 238.447V242.591Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 203.827L515.582 206.567V202.423L520.341 199.669V203.827Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 180.878L515.582 183.618V179.474L520.341 176.734V180.878Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 188.523L515.582 191.264V187.12L520.341 184.379V188.523Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 196.168L515.582 198.922V194.765L520.341 192.024V196.168Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 250.236L515.582 252.99V248.833L520.341 246.092V250.236Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 327.253L515.582 329.994V325.85L520.341 323.109V327.253Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 304.304L515.582 307.058V302.914L520.341 300.16V304.304Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 311.962L515.582 314.703V310.559L520.341 307.805V311.962Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 296.659L515.582 299.412V295.255L520.341 292.515V296.659Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 334.898L515.582 337.652V333.495L520.341 330.754V334.898Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 319.608L515.582 322.348V318.204L520.341 315.464V319.608Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 280.83L515.582 283.584V279.427L520.341 276.686V280.83Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 289.013L515.582 291.754V287.61L520.341 284.869V289.013Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 273.185L515.582 275.926V271.782L520.341 269.041V273.185Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 265.54L515.582 268.28V264.137L520.341 261.396V265.54Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 257.894L515.582 260.635V256.491L520.341 253.737V257.894Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 302.206L578.118 299.465V295.308L582.877 298.062V302.206Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 327.633L568.259 324.879V320.735L573.018 323.489V327.633Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 296.501L568.259 293.76V289.617L573.018 292.357V296.501Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 319.988L568.259 317.234V313.09L573.018 315.831V319.988Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 311.805L568.259 309.064V304.907L573.018 307.661V311.805Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 242.971L568.259 240.23V236.073L573.018 238.827V242.971Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 250.616L568.259 247.876V243.719L573.018 246.472V250.616Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 258.262L568.259 255.521V251.377L573.018 254.118V258.262Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 273.565L568.259 270.811V266.668L573.018 269.408V273.565Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 265.92L568.259 263.166V259.022L573.018 261.763V265.92Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 281.211L568.259 278.47V274.313L573.018 277.067V281.211Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 304.16L568.259 301.406V297.262L573.018 300.003V304.16Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 335.278L568.259 332.538V328.381L573.018 331.135V335.278Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 350.569L568.259 347.828V343.684L573.018 346.425V350.569Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 342.924L568.259 340.183V336.039L573.018 338.78V342.924Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 358.228L568.259 355.474V351.33L573.018 354.07V358.228Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 288.856L568.259 286.115V281.971L573.018 284.712V288.856Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 142.402L568.259 139.648V135.504L573.018 138.258V142.402Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 150.047L568.259 147.306V143.149L573.018 145.903V150.047Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 134.757L568.259 132.003V127.859L573.018 130.6V134.757Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 181.258L568.259 178.504V174.36L573.018 177.101V181.258Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 211.839L568.259 209.098V204.954L573.018 207.695V211.839Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 204.194L568.259 201.453V197.309L573.018 200.05V204.194Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 227.143L568.259 224.402V220.245L573.018 222.999V227.143Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 196.548L568.259 193.808V189.651L573.018 192.405V196.548Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 219.497L568.259 216.744V212.6L573.018 215.34V219.497Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 165.954L568.259 163.213V159.069L573.018 161.81V165.954Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 173.599L568.259 170.859V166.715L573.018 169.455V173.599Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 157.693L568.259 154.952V150.808L573.018 153.549V157.693Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 234.788L568.259 232.047V227.903L573.018 230.644V234.788Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.018 188.903L568.259 186.149V182.005L573.018 184.759V188.903Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 217.544L578.118 214.803V210.659L582.877 213.4V217.544Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 348.628L578.118 345.888V341.73L582.877 344.484V348.628Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 340.983L578.118 338.229V334.085L582.877 336.826V340.983Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 356.273L578.118 353.533V349.389L582.877 352.13V356.273Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 333.325L578.118 330.584V326.44L582.877 329.181V333.325Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 325.679L578.118 322.938V318.795L582.877 321.535V325.679Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 168.328L398.138 171.068V166.925L402.884 164.171V168.328Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 309.851L578.118 307.11V302.966L582.877 305.707V309.851Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 317.509L578.118 314.756V310.612L582.877 313.352V317.509Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 125.393L505.723 128.134V123.99L510.482 121.249V125.393Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 110.09L505.723 112.844V108.687L510.482 105.946V110.09Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 117.748L505.723 120.489V116.345L510.482 113.591V117.748Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 294.56L578.118 291.82V287.663L582.877 290.416V294.56Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 94.7991L505.723 97.5399V93.3959L510.482 90.6552V94.7991Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 102.444L505.723 105.185V101.041L510.482 98.3004V102.444Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 87.1538L505.723 89.8946V85.7506L510.482 82.9967V87.1538Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 79.4954L505.723 82.2493V78.1053L510.482 75.3514V79.4954Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.341 66.2505L515.582 68.9913V64.8474L520.341 62.1066V66.2505Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 71.9419L505.723 74.6957V70.5518L510.482 67.7979V71.9419Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 271.611L578.118 268.871V264.727L582.877 267.467V271.611Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 163.397L578.118 160.656V156.499L582.877 159.253V163.397Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 171.659L578.118 168.905V164.761L582.877 167.515V171.659Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 179.304L578.118 176.563V172.406L582.877 175.16V179.304Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 194.594L578.118 191.854V187.71L582.877 190.451V194.594Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 186.949L578.118 184.208V180.064L582.877 182.805V186.949Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 202.253L578.118 199.499V195.355L582.877 198.096V202.253Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 140.448L578.118 137.707V133.563L582.877 136.304V140.448Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 155.752L578.118 152.998V148.854L582.877 151.595V155.752Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 148.093L578.118 145.352V141.209L582.877 143.949V148.093Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 240.493L578.118 237.739V233.595L582.877 236.349V240.493Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 248.662L578.118 245.922V241.778L582.877 244.518V248.662Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 263.966L578.118 261.225V257.068L582.877 259.822V263.966Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 256.321L578.118 253.567V249.423L582.877 252.164V256.321Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 209.898L578.118 207.157V203L582.877 205.754V209.898Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 279.257L578.118 276.516V272.372L582.877 275.113V279.257Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.482 133.039L505.723 135.779V131.636L510.482 128.895V133.039Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 225.189L578.118 222.448V218.304L582.877 221.045V225.189Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 232.847L578.118 230.093V225.949L582.877 228.69V232.847Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.877 286.915L578.118 284.161V280.017L582.877 282.758V286.915Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 185.336L317.627 188.077V183.933L322.373 181.179V185.336Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 318.598L417.843 321.339V317.195L422.602 314.454V318.598Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 91.0748L307.768 93.8156V89.6716L312.527 86.9308V91.0748Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 341.547L417.843 344.288V340.144L422.602 337.39V341.547Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 326.243L417.843 328.997V324.84L422.602 322.099V326.243Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 333.902L417.843 336.642V332.498L422.602 329.744V333.902Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 349.192L417.843 351.933V347.789L422.602 345.048V349.192Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 106.903L307.768 109.644V105.5L312.527 102.759V106.903Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 99.2578L307.768 101.999V97.8546L312.527 95.1007V99.2578Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 160.433L307.768 163.187V159.03L312.527 156.289V160.433Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 168.092L307.768 170.832V166.689L312.527 163.935V168.092Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 152.788L307.768 155.542V151.385L312.527 148.644V152.788Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 183.382L307.768 186.123V181.979L312.527 179.238V183.382Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 114.548L307.768 117.289V113.145L312.527 110.404V114.548Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 175.973L398.138 178.714V174.57L402.884 171.829V175.973Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 122.194L307.768 124.948V120.79L312.527 118.05V122.194Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 129.852L307.768 132.593V128.449L312.527 125.695V129.852Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 137.497L307.768 140.238V136.094L312.527 133.353V137.497Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 145.143L307.768 147.883V143.739L312.527 140.999V145.143Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 226.29L417.843 229.031V224.887L422.602 222.146V226.29Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 195.172L417.843 197.912V193.768L422.602 191.014V195.172Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 202.817L417.843 205.558V201.414L422.602 198.66V202.817Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 210.462L417.843 213.203V209.059L422.602 206.318V210.462Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 218.645L417.843 221.386V217.242L422.602 214.488V218.645Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 149.273L417.843 152.027V147.87L422.602 145.13V149.273Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 187.513L417.843 190.267V186.11L422.602 183.369V187.513Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 164.577L417.843 167.318V163.174L422.602 160.42V164.577Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 310.953L417.843 313.693V309.549L422.602 306.809V310.953Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 172.222L417.843 174.963V170.819L422.602 168.079V172.222Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 179.868L417.843 182.609V178.465L422.602 175.724V179.868Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 156.919L417.843 159.673V155.516L422.602 152.775V156.919Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 287.479L417.843 290.22V286.076L422.602 283.322V287.479Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 279.821L417.843 282.574V278.431L422.602 275.677V279.821Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 303.307L417.843 306.048V301.904L422.602 299.15V303.307Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 295.649L417.843 298.403V294.246L422.602 291.505V295.649Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 272.175L417.843 274.929V270.772L422.602 268.031V272.175Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 249.239L417.843 251.98V247.836L422.602 245.082V249.239Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 264.53L417.843 267.271V263.127L422.602 260.386V264.53Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 241.581L417.843 244.335V240.178L422.602 237.437V241.581Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 233.936L417.843 236.676V232.533L422.602 229.792V233.936Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 256.885L417.843 259.625V255.482L422.602 252.741V256.885Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 191.028L307.768 193.781V189.624L312.527 186.884V191.028Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 116.502L317.627 119.243V115.099L322.373 112.345V116.502Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 147.097L317.627 149.837V145.693L322.373 142.94V147.097Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 124.148L317.627 126.888V122.744L322.373 120.004V124.148Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 139.438L317.627 142.192V138.035L322.373 135.294V139.438Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 131.793L317.627 134.534V130.39L322.373 127.649V131.793Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 108.844L317.627 111.598V107.454L322.373 104.7V108.844Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 85.3703L317.627 88.1242V83.9671L322.373 81.2264V85.3703Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 93.5533L317.627 96.294V92.1501L322.373 89.4093V93.5533Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 101.199L317.627 103.952V99.7954L322.373 97.0546V101.199Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 192.982L317.627 195.722V191.578L322.373 188.838V192.982Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 154.742L317.627 157.483V153.339L322.373 150.598V154.742Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 208.272L317.627 211.026V206.869L322.373 204.128V208.272Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 216.455L317.627 219.196V215.052L322.373 212.311V216.455Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 224.1L317.627 226.854V222.697L322.373 219.956V224.1Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 200.627L317.627 203.368V199.224L322.373 196.483V200.627Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 231.759L317.627 234.5V230.356L322.373 227.602V231.759Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 170.032L317.627 172.786V168.629L322.373 165.889V170.032Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 162.387L317.627 165.128V160.984L322.373 158.243V162.387Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.373 177.678L317.627 180.432V176.288L322.373 173.534V177.678Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 345.061L307.768 347.802V343.658L312.527 340.917V345.061Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 252.754L307.768 255.495V251.351L312.527 248.597V252.754Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 245.095L307.768 247.849V243.692L312.527 240.952V245.095Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 268.044L307.768 270.785V266.641L312.527 263.901V268.044Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 237.45L307.768 240.204V236.047L312.527 233.306V237.45Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 260.399L307.768 263.14V258.996L312.527 256.255V260.399Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 206.331L307.768 209.072V204.928L312.527 202.187V206.331Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 213.977L307.768 216.717V212.573L312.527 209.833V213.977Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 275.69L307.768 278.444V274.287L312.527 271.546V275.69Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 222.16L307.768 224.9V220.756L312.527 218.003V222.16Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 229.805L307.768 232.546V228.402L312.527 225.661V229.805Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 198.686L307.768 201.427V197.283L312.527 194.529V198.686Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 329.758L307.768 332.511V328.354L312.527 325.614V329.758Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 337.416L307.768 340.157V336.013L312.527 333.259V337.416Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 283.348L307.768 286.089V281.945L312.527 279.191V283.348Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 352.707L307.768 355.447V351.303L312.527 348.563V352.707Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 322.112L307.768 324.853V320.709L312.527 317.968V322.112Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 299.163L307.768 301.917V297.773L312.527 295.019V299.163Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 314.467L307.768 317.208V313.064L312.527 310.323V314.467Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 290.993L307.768 293.734V289.59L312.527 286.836V290.993Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 306.822L307.768 309.562V305.419L312.527 302.665V306.822Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.527 175.737L307.768 178.478V174.334L312.527 171.593V175.737Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 70.2371L407.984 72.9779V68.8339L412.743 66.08V70.2371Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 39.6428L407.984 42.3835V38.2396L412.743 35.4988V39.6428Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 47.2881L407.984 50.0288V45.8849L412.743 43.1441V47.2881Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 62.5787L407.984 65.3326V61.1886L412.743 58.4347V62.5787Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 54.9334L407.984 57.6872V53.5302L412.743 50.7894V54.9334Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 345.297L398.138 348.038V343.894L402.884 341.153V345.297Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 352.943L398.138 355.683V351.539L402.884 348.799V352.943Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 116.122L407.984 118.863V114.719L412.743 111.978V116.122Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 131.413L407.984 134.166V130.023L412.743 127.269V131.413Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 123.767L407.984 126.521V122.364L412.743 119.623V123.767Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 147.333L407.984 150.073V145.929L412.743 143.176V147.333Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 139.071L407.984 141.812V137.668L412.743 134.914V139.071Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 93.173L407.984 95.9269V91.7698L412.743 89.0291V93.173Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 85.5277L407.984 88.2684V84.1245L412.743 81.3837V85.5277Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 77.8824L407.984 80.6232V76.4792L412.743 73.7384V77.8824Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 100.831L407.984 103.572V99.4282L412.743 96.6743V100.831Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 108.477L407.984 111.217V107.074L412.743 104.333V108.477Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 237.686L398.138 240.44V236.283L402.884 233.542V237.686Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 214.213L398.138 216.953V212.809L402.884 210.069V214.213Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 252.99L398.138 255.731V251.587L402.884 248.833V252.99Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 221.858L398.138 224.612V220.455L402.884 217.714V221.858Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 154.978L407.984 157.719V153.575L412.743 150.834V154.978Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 245.332L398.138 248.085V243.928L402.884 241.188V245.332Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 230.041L398.138 232.782V228.638L402.884 225.897V230.041Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 183.618L398.138 186.359V182.215L402.884 179.474V183.618Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 206.567L398.138 209.308V205.164L402.884 202.423V206.567Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 191.264L398.138 194.017V189.86L402.884 187.12V191.264Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 198.922L398.138 201.663V197.519L402.884 194.765V198.922Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 298.875L398.138 301.616V297.472L402.884 294.731V298.875Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 307.058L398.138 309.799V305.655L402.884 302.901V307.058Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 337.652L398.138 340.393V336.249L402.884 333.495V337.652Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 260.635L398.138 263.376V259.232L402.884 256.491V260.635Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 322.348L398.138 325.089V320.945L402.884 318.204V322.348Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 329.994L398.138 332.748V328.59L402.884 325.85V329.994Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 314.703L398.138 317.444V313.3L402.884 310.559V314.703Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 291.229L398.138 293.97V289.826L402.884 287.072V291.229Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 268.28L398.138 271.021V266.877L402.884 264.137V268.28Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 275.926L398.138 278.68V274.523L402.884 271.782V275.926Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.884 283.584L398.138 286.325V282.181L402.884 279.427V283.584Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 193.218L407.984 195.958V191.814L412.743 189.074V193.218Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 33.9383L417.843 36.6922V32.5351L422.602 29.7944V33.9383Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 41.5836L417.843 44.3375V40.1804L422.602 37.4397V41.5836Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 49.242L417.843 51.9828V47.8389L422.602 45.085V49.242Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 56.8873L417.843 59.6281V55.4841L422.602 52.7434V56.8873Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 339.593L407.984 342.347V338.19L412.743 335.449V339.593Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 347.238L407.984 349.992V345.835L412.743 343.094V347.238Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 354.897L407.984 357.637V353.493L412.743 350.74V354.897Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 110.418L417.843 113.171V109.014L422.602 106.274V110.418Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 102.772L417.843 105.526V101.369L422.602 98.6283V102.772Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 118.076L417.843 120.817V116.673L422.602 113.919V118.076Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 331.948L407.984 334.688V330.544L412.743 327.804V331.948Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 133.367L417.843 136.107V131.963L422.602 129.223V133.367Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 125.721L417.843 128.462V124.318L422.602 121.577V125.721Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 64.5326L417.843 67.2734V63.1294L422.602 60.3887V64.5326Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 72.1779L417.843 74.9318V70.7747L422.602 68.034V72.1779Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 79.8363L417.843 82.5771V78.4332L422.602 75.6793V79.8363Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 87.4816L417.843 90.2224V86.0785L422.602 83.3246V87.4816Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 95.1269L417.843 97.8677V93.7237L422.602 90.983V95.1269Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 185.572L407.984 188.313V184.169L412.743 181.415V185.572Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 208.508L407.984 211.262V207.105L412.743 204.364V208.508Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 239.64L407.984 242.381V238.237L412.743 235.483V239.64Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 224.336L407.984 227.09V222.933L412.743 220.192V224.336Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 200.863L407.984 203.617V199.46L412.743 196.719V200.863Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 231.995L407.984 234.736V230.592L412.743 227.838V231.995Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 216.167L407.984 218.907V214.763L412.743 212.01V216.167Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 170.269L407.984 173.022V168.865L412.743 166.125V170.269Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.602 141.628L417.843 144.369V140.225L422.602 137.484V141.628Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 177.927L407.984 180.668V176.524L412.743 173.77V177.927Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 162.623L407.984 165.364V161.22L412.743 158.479V162.623Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 285.525L407.984 288.266V284.122L412.743 281.381V285.525Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 324.302L407.984 327.043V322.899L412.743 320.145V324.302Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 293.17L407.984 295.924V291.767L412.743 289.026V293.17Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 301.353L407.984 304.094V299.95L412.743 297.209V301.353Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 308.999L407.984 311.752V307.595L412.743 304.855V308.999Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 316.657L407.984 319.398V315.254L412.743 312.5V316.657Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 262.576L407.984 265.33V261.186L412.743 258.432V262.576Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 247.285L407.984 250.026V245.882L412.743 243.141V247.285Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 277.88L407.984 280.62V276.477L412.743 273.736V277.88Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 254.931L407.984 257.685V253.528L412.743 250.787V254.931Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.743 270.234L407.984 272.975V268.831L412.743 266.077V270.234Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.381 124.475L600.97 105.08L617.764 114.771L584.175 134.166L567.381 124.475Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.627 46.9209L494.631 30.7648L528.22 50.16L500.203 66.3161L466.627 46.9209Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.207 77.7513V97.1333L545.002 87.4554L528.207 77.7513Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.69 19.3952L388.279 0L427.453 22.6212L393.864 42.0164L354.69 19.3952Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.401 41.8721L186.771 12.7728L209.164 25.716L158.78 54.8022L136.401 41.8721Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4639 124.921L69.223 99.0479L102.838 118.456L58.0922 144.33L24.4639 124.921Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.329 71.1157L298.721 58.1856L326.712 74.3417L304.319 87.2849L276.329 71.1157Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.164 55.9169L231.557 42.9737L253.949 55.9038L231.557 68.847L209.164 55.9169Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.453 106.549V125.931L444.248 116.24L427.453 106.549Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.401 159.66V140.277L119.606 149.955L136.401 159.66Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7266 255.836C-31.2422 330.453 -31.2422 451.427 93.7266 526.044C218.696 600.661 421.304 600.661 546.273 526.044C671.242 451.427 671.242 330.453 546.273 255.836C421.304 181.218 218.696 181.218 93.7266 255.836Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.644 292.541L75.6079 332.997L39.8032 312.316L109.839 271.874L145.644 292.541Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.146 483.477L502.052 531.46C497.319 534.187 489.046 533.846 483.579 530.699L468.554 522.018C463.087 518.857 462.497 514.084 467.23 511.356L550.324 463.373C555.057 460.646 563.33 460.987 568.797 464.134L583.821 472.815C589.289 475.976 589.879 480.749 585.146 483.477Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.431 530.607L381.934 557.464C386.667 560.192 394.939 559.851 400.406 556.704L415.431 548.022C420.898 544.862 421.488 540.089 416.755 537.361L370.252 510.504C365.519 507.776 357.247 508.117 351.78 511.265L336.755 519.946C331.288 523.106 330.698 527.88 335.431 530.607Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.106 487.87C475.805 475.569 510.521 456.436 532.625 438.457C538.289 433.749 536.795 429.068 531.747 426.157C526.699 423.245 518.23 423.39 512.855 426.511L426.955 476.146C421.567 479.254 421.305 484.145 426.352 487.057C431.4 489.968 439.397 490.899 447.106 487.883V487.87Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.785 267.284L104.412 324.997C90.2525 333.141 91.9306 347.343 108.174 356.706L259.482 443.795C340.715 490.833 476.303 393.149 411.367 356.733L252.481 264.884C236.237 255.508 218.932 259.14 204.772 267.284H204.785Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.418 551.458C229.381 560.139 188.306 550.055 152.698 528.929L98.3416 496.643C62.7205 475.517 45.441 451.702 59.7445 443.44C74.048 435.179 114.703 445.276 150.561 465.983L206.726 498.23C242.583 518.936 259.469 542.764 244.418 551.458Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.024 374.646C507.899 347.33 455.51 316.985 409.925 283.348C405.218 279.44 406.463 275.559 410.659 273.133C414.854 270.707 421.868 270.838 426.339 273.421L584.752 364.902C589.223 367.486 589.446 371.538 585.251 373.964C581.055 376.39 574.421 377.151 568.024 374.646Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.913 172.655L502.746 168.997C502.117 166.046 514.152 172.996 514.782 175.947L510.901 186.385C510.757 186.726 510.521 186.975 510.245 187.146C509.393 187.67 506.26 189.441 505.985 189.611C505.119 190.136 503.861 189.808 503.507 188.693L498.485 171.462C498.171 170.006 500.95 170.964 503.913 172.655Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.551 102.458L533.32 128.869C534.172 129.367 534.867 130.56 534.867 131.544V185.782C534.867 186.766 534.172 187.959 533.307 188.444L530.475 190.044C529.61 190.529 528.233 190.516 527.368 190.031L481.599 163.62C480.747 163.122 480.052 161.928 480.052 160.945V106.706C480.052 105.723 480.747 104.53 481.612 104.044L484.444 102.445C485.31 101.959 486.686 101.972 487.551 102.458Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.613 105.815L527.381 132.226C528.233 132.724 528.928 133.917 528.928 134.901V189.139C528.928 190.123 528.233 190.529 527.381 190.031L509.866 179.92L506.654 188.851C506.037 190.267 503.992 190.162 503.52 188.693L499.246 173.796L481.626 163.633C480.773 163.135 480.079 161.941 480.079 160.958V106.719C480.079 105.736 480.773 105.329 481.626 105.828L481.613 105.815Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M481.613 105.815L527.381 132.226C528.233 132.724 528.928 133.917 528.928 134.901V189.139C528.928 190.123 528.233 190.529 527.381 190.031L509.866 179.92L506.654 188.851C506.037 190.267 503.992 190.162 503.52 188.693L499.246 173.796L481.626 163.633C480.773 163.135 480.079 161.941 480.079 160.958V106.719C480.079 105.736 480.773 105.329 481.626 105.828L481.613 105.815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.079 106.431C480.197 105.657 480.839 105.369 481.612 105.815L527.368 132.226C527.801 132.475 528.181 132.894 528.456 133.38L534.369 129.97C534.094 129.511 533.713 129.105 533.307 128.869L487.538 102.457C486.686 101.959 485.296 101.959 484.431 102.444L481.599 104.044C480.826 104.49 480.17 105.513 480.065 106.431H480.079Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M480.079 106.431C480.197 105.657 480.839 105.369 481.612 105.815L527.368 132.226C527.801 132.475 528.181 132.894 528.456 133.38L534.369 129.97C534.094 129.511 533.713 129.105 533.307 128.869L487.538 102.457C486.686 101.959 485.296 101.959 484.431 102.444L481.599 104.044C480.826 104.49 480.17 105.513 480.065 106.431H480.079Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.229 139.727C517.378 144.159 520.092 158.02 516.958 164.354C514.349 169.626 508.332 169.993 505.775 167.108C505.264 156.775 510.298 148.277 515.005 144.998C509.158 146.611 503.73 153.09 503.428 165.351C500.059 161.666 499.049 152.172 504.477 145.811C510.757 138.468 522.229 139.727 522.229 139.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.935 124.843L488.718 135.583L492.612 144.736L489.426 157.43L497.384 144.789L493.425 135.439L497.935 124.843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.624 379.642L542.144 382.829L630.259 332.013L624.753 328.813L536.624 379.642Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.624 379.642L542.144 382.829V384.481L536.624 381.295V379.642Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.259 332.013V333.652L542.144 384.481V382.829L630.259 332.013Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.53 354.765L499.049 357.965L587.165 307.136L581.658 303.937L493.53 354.765Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.53 354.766L499.049 357.965V359.618L493.53 356.418V354.766Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.165 307.136V308.789L499.049 359.618V357.965L587.165 307.136Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.921 340.642C610.737 340.642 610.554 340.59 610.396 340.498L567.014 315.437C566.647 315.228 566.45 314.821 566.489 314.401L572.14 263.533C572.73 258.262 575.64 255.049 579.678 255.114L597.509 255.429C602.071 255.508 606.974 262.051 607.394 268.635L611.956 339.514C611.983 339.908 611.786 340.275 611.458 340.485C611.288 340.59 611.091 340.642 610.908 340.642H610.921ZM568.666 313.969L609.741 337.691L605.296 268.792C604.942 263.389 600.931 257.619 597.482 257.567L579.652 257.252C579.652 257.252 579.587 257.252 579.56 257.252C576.689 257.252 574.696 259.691 574.238 263.796L568.653 313.982L568.666 313.969Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M610.921 340.642C610.737 340.642 610.554 340.59 610.396 340.498L567.014 315.437C566.647 315.228 566.45 314.821 566.489 314.401L572.14 263.533C572.73 258.262 575.64 255.049 579.678 255.114L597.509 255.429C602.071 255.508 606.974 262.051 607.394 268.635L611.956 339.514C611.983 339.908 611.786 340.275 611.458 340.485C611.288 340.59 611.091 340.642 610.908 340.642H610.921ZM568.666 313.969L609.741 337.691L605.296 268.792C604.942 263.389 600.931 257.619 597.482 257.567L579.652 257.252C579.652 257.252 579.587 257.252 579.56 257.252C576.689 257.252 574.696 259.691 574.238 263.796L568.653 313.982L568.666 313.969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.407 349.009C596.224 349.009 596.04 348.956 595.883 348.864L552.501 323.804C552.134 323.594 551.937 323.188 551.976 322.768L557.627 271.9C558.204 266.694 561.035 263.481 565.034 263.481C565.074 263.481 565.126 263.481 565.165 263.481L582.995 263.796C587.558 263.874 592.461 270.418 592.881 277.001L597.443 347.868C597.469 348.261 597.273 348.628 596.945 348.838C596.775 348.943 596.578 348.995 596.394 348.995L596.407 349.009ZM554.152 322.335L595.228 346.058L590.783 277.158C590.403 271.284 586.103 265.986 582.969 265.933L565.139 265.618C565.139 265.618 565.073 265.618 565.047 265.618C562.176 265.618 560.183 268.058 559.724 272.162L554.139 322.348L554.152 322.335Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M596.407 349.009C596.224 349.009 596.04 348.956 595.883 348.864L552.501 323.804C552.134 323.594 551.937 323.188 551.976 322.768L557.627 271.9C558.204 266.694 561.035 263.481 565.034 263.481C565.074 263.481 565.126 263.481 565.165 263.481L582.995 263.796C587.558 263.874 592.461 270.418 592.881 277.001L597.443 347.868C597.469 348.261 597.273 348.628 596.945 348.838C596.775 348.943 596.578 348.995 596.394 348.995L596.407 349.009ZM554.152 322.335L595.228 346.058L590.783 277.158C590.403 271.284 586.103 265.986 582.969 265.933L565.139 265.618C565.139 265.618 565.073 265.618 565.047 265.618C562.176 265.618 560.183 268.058 559.724 272.162L554.139 322.348L554.152 322.335Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.641 360.667C575.457 360.667 575.274 360.614 575.116 360.522L531.734 335.462C531.367 335.252 531.17 334.846 531.21 334.426L536.86 283.558C537.45 278.286 540.361 275.086 544.399 275.139L562.229 275.454C566.791 275.532 571.695 282.076 572.114 288.659L576.677 359.526C576.703 359.919 576.506 360.286 576.178 360.496C576.008 360.601 575.811 360.653 575.628 360.653L575.641 360.667ZM533.386 333.98L574.461 357.703L570.017 288.803C569.636 282.928 565.336 277.631 562.203 277.578L544.372 277.263C544.372 277.263 544.307 277.263 544.281 277.263C541.409 277.263 539.417 279.703 538.958 283.807L533.373 333.993L533.386 333.98Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M575.641 360.667C575.457 360.667 575.274 360.614 575.116 360.522L531.734 335.462C531.367 335.252 531.17 334.846 531.21 334.426L536.86 283.558C537.45 278.286 540.361 275.086 544.399 275.139L562.229 275.454C566.791 275.532 571.695 282.076 572.114 288.659L576.677 359.526C576.703 359.919 576.506 360.286 576.178 360.496C576.008 360.601 575.811 360.653 575.628 360.653L575.641 360.667ZM533.386 333.98L574.461 357.703L570.017 288.803C569.636 282.928 565.336 277.631 562.203 277.578L544.372 277.263C544.372 277.263 544.307 277.263 544.281 277.263C541.409 277.263 539.417 279.703 538.958 283.807L533.373 333.993L533.386 333.98Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.493 317.916L547.401 317.732C544.084 310.73 541.803 303.281 540.636 295.623L536.493 268.346C536.414 267.861 536.178 266.274 534.828 267.1C533.517 267.9 533.609 268.372 533.674 268.857L537.765 295.832C539.049 304.265 541.671 312.434 545.565 320.027C545.919 320.368 546.627 320.473 547.348 319.817C548.069 319.175 547.794 318.545 547.479 317.89L547.493 317.916Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M547.493 317.916L547.401 317.732C544.084 310.73 541.803 303.281 540.636 295.623L536.493 268.346C536.414 267.861 536.178 266.274 534.828 267.1C533.517 267.9 533.609 268.372 533.674 268.857L537.765 295.832C539.049 304.265 541.671 312.434 545.565 320.027C545.919 320.368 546.627 320.473 547.348 319.817C548.069 319.175 547.794 318.545 547.479 317.89L547.493 317.916Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.751 282.889L546.837 281.84C542.131 279.283 537.712 278.103 533.806 278.142C533.688 278.142 533.583 278.142 533.465 278.142C532.783 278.168 532.101 278.221 531.446 278.312C525.323 279.112 521.482 281.053 517.994 285.774C513.996 290.797 513.301 297.458 513.76 303.792C514.232 322.65 528.037 345.245 544.609 354.254L546.523 355.303C551.229 357.86 555.648 359.041 559.554 359.001C559.554 359.001 559.633 359.001 559.673 359.001C559.725 359.001 559.777 359.001 559.83 359.001C560.092 359.001 560.341 358.975 560.59 358.962C560.682 358.962 560.761 358.962 560.839 358.949C561.062 358.936 561.272 358.909 561.495 358.883C561.613 358.883 561.718 358.857 561.823 358.844C561.875 358.844 561.941 358.831 561.993 358.818C568.325 357.965 572.298 355.815 575.759 350.818C575.903 350.608 576.047 350.385 576.192 350.176C576.205 350.149 576.231 350.123 576.244 350.097C576.401 349.848 576.533 349.559 576.716 349.31C578.591 346.792 579.784 341.298 579.64 335.514L579.587 333.338C579.115 314.48 565.31 291.885 548.738 282.876L548.751 282.889ZM545.5 351.789C529.872 343.278 516.841 321.955 516.395 304.173C515.949 286.377 528.26 278.85 543.888 287.361C559.515 295.872 572.547 317.195 572.993 334.977C573.438 352.772 561.128 360.299 545.5 351.789Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.766 284.869L542.851 283.82C534.657 279.362 527.329 279.06 522.071 282.181C514.743 286.561 513.301 295.95 513.786 303.819C514.258 322.676 528.063 345.271 544.634 354.28L546.549 355.329C551.36 357.952 555.87 359.132 559.843 359.027C560.105 359.027 560.354 359.001 560.603 358.988C560.695 358.988 560.773 358.988 560.852 358.975C561.075 358.962 561.285 358.936 561.508 358.909C561.626 358.909 561.731 358.883 561.835 358.87C562.058 358.844 562.268 358.804 562.478 358.765C562.674 358.739 562.871 358.7 563.055 358.647C563.238 358.608 563.422 358.568 563.605 358.516C563.959 358.424 564.3 358.319 564.641 358.201C564.785 358.162 564.929 358.109 565.074 358.057C565.231 357.991 565.388 357.939 565.546 357.873C565.677 357.821 565.808 357.768 565.939 357.703C566.227 357.585 566.503 357.454 566.765 357.296C566.896 357.231 567.04 357.152 567.171 357.073C567.211 357.047 567.237 357.034 567.276 357.008C567.329 356.982 567.381 356.955 567.434 356.916C567.525 356.877 567.604 356.811 567.696 356.772C572.861 353.507 575.929 346.845 575.706 337.521L575.654 335.344C575.182 316.486 561.363 293.892 544.805 284.882L544.766 284.869ZM545.5 351.789C529.872 343.278 516.84 321.955 516.395 304.173C515.949 286.377 528.26 278.85 543.887 287.361C559.515 295.872 572.547 317.195 572.992 334.977C573.438 352.772 561.127 360.299 545.5 351.789Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.136 346.714C561.862 352.077 554.232 353.021 545.421 348.222C531.524 340.655 519.948 321.706 519.541 305.891C519.358 298.822 521.456 293.577 525.061 290.613C522.57 293.708 521.193 298.272 521.351 304.068C521.744 319.883 533.334 338.832 547.231 346.399C554.913 350.582 561.691 350.399 566.149 346.727L566.136 346.714Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M566.136 346.714C561.862 352.077 554.232 353.021 545.421 348.222C531.524 340.655 519.948 321.706 519.541 305.891C519.358 298.822 521.456 293.577 525.061 290.613C522.57 293.708 521.193 298.272 521.351 304.068C521.744 319.883 533.334 338.832 547.231 346.399C554.913 350.582 561.691 350.399 566.149 346.727L566.136 346.714Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.874 287.361C528.246 278.85 515.936 286.377 516.381 304.173C516.827 321.968 529.859 343.291 545.487 351.789C561.114 360.299 573.425 352.772 572.979 334.977C572.533 317.182 559.502 295.859 543.874 287.361ZM545.408 348.209C531.511 340.642 519.934 321.693 519.528 305.877C519.135 290.062 530.069 283.374 543.966 290.941C557.863 298.508 569.439 317.457 569.846 333.272C570.239 349.087 559.305 355.775 545.408 348.209Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M543.874 287.361C528.246 278.85 515.936 286.377 516.381 304.173C516.827 321.968 529.859 343.291 545.487 351.789C561.114 360.299 573.425 352.772 572.979 334.977C572.533 317.182 559.502 295.859 543.874 287.361ZM545.408 348.209C531.511 340.642 519.934 321.693 519.528 305.877C519.135 290.062 530.069 283.374 543.966 290.941C557.863 298.508 569.439 317.457 569.846 333.272C570.239 349.087 559.305 355.775 545.408 348.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.81 325.43C568.745 325.155 568.679 324.879 568.614 324.591L544.687 319.214L566.123 317.142C566.018 316.893 565.926 316.657 565.821 316.408L544.687 319.214L562.006 309.077C561.875 308.854 561.731 308.644 561.599 308.435L544.687 319.227L556.762 301.773C556.591 301.576 556.421 301.366 556.25 301.17L544.687 319.227L550.757 295.688C550.534 295.505 550.324 295.321 550.102 295.137L544.687 319.227L544.359 291.177C544.228 291.098 544.097 291.02 543.966 290.954C543.835 290.888 543.704 290.823 543.586 290.757L544.687 319.227L537.987 288.515C537.712 288.436 537.437 288.371 537.162 288.318L544.687 319.227L532.035 287.899C531.773 287.925 531.511 287.951 531.249 287.99L544.7 319.24L526.909 289.407C526.686 289.525 526.463 289.656 526.254 289.787L544.7 319.24L522.924 292.908C522.766 293.118 522.622 293.341 522.478 293.564L544.7 319.24L520.406 298.258C520.328 298.534 520.262 298.796 520.197 299.071L544.7 319.227L519.554 305.104C519.554 305.366 519.554 305.628 519.554 305.904C519.554 305.93 519.554 305.956 519.554 305.982L544.7 319.24L520.419 312.985C520.472 313.26 520.537 313.536 520.603 313.811L544.7 319.227L522.989 321.339C523.094 321.588 523.199 321.824 523.291 322.073L544.7 319.227L527.08 329.561C527.211 329.784 527.342 329.994 527.473 330.217L544.7 319.227L532.363 337.075C532.534 337.285 532.704 337.482 532.874 337.678L544.7 319.227L538.486 343.356C538.709 343.54 538.918 343.737 539.141 343.92L544.7 319.227L545.041 348.012C545.172 348.091 545.303 348.169 545.434 348.235C545.565 348.3 545.696 348.366 545.828 348.432L544.713 319.227L551.596 350.713C551.871 350.792 552.147 350.844 552.422 350.91L544.713 319.227L557.666 351.264C557.928 351.238 558.191 351.212 558.453 351.172L544.713 319.227L562.845 349.625C563.068 349.494 563.278 349.363 563.487 349.218L544.713 319.24L566.778 345.914C566.922 345.691 567.08 345.481 567.211 345.245L544.713 319.24L569.177 340.367C569.243 340.091 569.308 339.816 569.361 339.527L544.713 319.24L569.872 333.377C569.872 333.377 569.872 333.324 569.872 333.298C569.872 333.023 569.846 332.761 569.833 332.485L544.713 319.24L568.836 325.456L568.81 325.43Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.683 311.936C543.953 310.992 542.419 310.966 541.331 311.687C541.108 311.831 540.832 311.962 540.544 312.146C540.465 312.198 540.387 312.251 540.321 312.303C540.308 312.303 540.295 312.316 540.282 312.329C540.282 312.329 540.282 312.329 540.269 312.329C540.164 312.408 540.072 312.487 539.98 312.579C539.954 312.605 539.941 312.618 539.915 312.644C539.836 312.723 539.757 312.815 539.679 312.92C539.653 312.959 539.626 312.998 539.6 313.024C539.535 313.116 539.482 313.208 539.417 313.3C539.39 313.352 539.364 313.405 539.325 313.47C539.272 313.562 539.233 313.654 539.194 313.746C539.167 313.824 539.141 313.903 539.115 313.969C539.089 314.06 539.049 314.152 539.023 314.244C538.997 314.336 538.971 314.441 538.958 314.546C538.945 314.637 538.918 314.716 538.905 314.808C538.879 314.939 538.866 315.07 538.853 315.201C538.853 315.28 538.84 315.346 538.827 315.424C538.813 315.634 538.813 315.857 538.813 316.093C538.905 319.935 541.724 324.525 545.093 326.361C545.303 326.479 545.513 326.571 545.723 326.663C545.841 326.715 545.959 326.755 546.09 326.794C546.168 326.82 546.26 326.859 546.339 326.886C546.418 326.912 546.496 326.925 546.588 326.951C546.706 326.977 546.824 327.017 546.929 327.043C546.968 327.043 547.021 327.043 547.06 327.056C547.204 327.082 547.348 327.095 547.493 327.109C547.493 327.109 547.506 327.109 547.519 327.109C548.266 327.148 548.922 326.964 549.472 326.597C549.761 326.414 550.01 326.282 550.338 326.086C551.373 325.417 551.989 324.066 551.95 322.191C551.858 318.362 549.04 313.759 545.67 311.923L545.683 311.936ZM544.254 323.542C543.205 322.768 541.698 320.368 541.095 319.017C541.409 319.214 541.776 319.45 542.157 319.634C543.743 320.407 543.677 319.306 544.333 320.053C544.962 320.762 544.91 322.663 544.438 323.647C544.372 323.62 544.32 323.594 544.254 323.542ZM547.126 316.329C547.034 316.368 546.942 316.408 546.876 316.447C546.706 316.552 546.037 316.945 545.972 316.998C545.749 317.129 545.605 317.3 545.526 317.47C544.726 316.696 543.769 314.205 543.809 313.011C545.172 313.444 547.453 315.254 547.82 315.962C547.86 316.028 547.873 316.08 547.886 316.132C547.65 316.172 547.388 316.224 547.139 316.316L547.126 316.329ZM542.537 315.66C543.087 317.47 543.861 317.719 543.913 318.322C542.72 318.165 540.78 317.063 540.61 315.923C540.465 314.86 541.003 313.575 541.567 312.841C542.078 313.051 542.065 314.192 542.524 315.66H542.537ZM546.182 325.102C545.539 324.551 546.221 323.974 546.509 322.781C546.693 322.047 546.562 321.483 546.444 321.063C547.702 322.007 549.616 324.512 549.158 325.273C549.144 325.299 549.118 325.325 549.105 325.351C548.083 325.653 546.627 325.509 546.182 325.102ZM549.013 321.076C547.663 319.358 547.165 319.975 546.824 319.057C546.654 318.611 546.85 318.152 547.217 317.798C547.912 317.575 548.699 317.667 549.131 318.388C549.8 319.503 550.206 321.562 550.272 322.847C549.944 322.388 549.538 321.732 549.026 321.089L549.013 321.076Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M545.683 311.936C543.953 310.992 542.419 310.966 541.331 311.687C541.108 311.831 540.832 311.962 540.544 312.146C540.465 312.198 540.387 312.251 540.321 312.303C540.308 312.303 540.295 312.316 540.282 312.329C540.282 312.329 540.282 312.329 540.269 312.329C540.164 312.408 540.072 312.487 539.98 312.579C539.954 312.605 539.941 312.618 539.915 312.644C539.836 312.723 539.757 312.815 539.679 312.92C539.653 312.959 539.626 312.998 539.6 313.024C539.535 313.116 539.482 313.208 539.417 313.3C539.39 313.352 539.364 313.405 539.325 313.47C539.272 313.562 539.233 313.654 539.194 313.746C539.167 313.824 539.141 313.903 539.115 313.969C539.089 314.06 539.049 314.152 539.023 314.244C538.997 314.336 538.971 314.441 538.958 314.546C538.945 314.637 538.918 314.716 538.905 314.808C538.879 314.939 538.866 315.07 538.853 315.201C538.853 315.28 538.84 315.346 538.827 315.424C538.813 315.634 538.813 315.857 538.813 316.093C538.905 319.935 541.724 324.525 545.093 326.361C545.303 326.479 545.513 326.571 545.723 326.663C545.841 326.715 545.959 326.755 546.09 326.794C546.168 326.82 546.26 326.859 546.339 326.886C546.418 326.912 546.496 326.925 546.588 326.951C546.706 326.977 546.824 327.017 546.929 327.043C546.968 327.043 547.021 327.043 547.06 327.056C547.204 327.082 547.348 327.095 547.493 327.109C547.493 327.109 547.506 327.109 547.519 327.109C548.266 327.148 548.922 326.964 549.472 326.597C549.761 326.414 550.01 326.282 550.338 326.086C551.373 325.417 551.989 324.066 551.95 322.191C551.858 318.362 549.04 313.759 545.67 311.923L545.683 311.936ZM544.254 323.542C543.205 322.768 541.698 320.368 541.095 319.017C541.409 319.214 541.776 319.45 542.157 319.634C543.743 320.407 543.677 319.306 544.333 320.053C544.962 320.762 544.91 322.663 544.438 323.647C544.372 323.62 544.32 323.594 544.254 323.542ZM547.126 316.329C547.034 316.368 546.942 316.408 546.876 316.447C546.706 316.552 546.037 316.945 545.972 316.998C545.749 317.129 545.605 317.3 545.526 317.47C544.726 316.696 543.769 314.205 543.809 313.011C545.172 313.444 547.453 315.254 547.82 315.962C547.86 316.028 547.873 316.08 547.886 316.132C547.65 316.172 547.388 316.224 547.139 316.316L547.126 316.329ZM542.537 315.66C543.087 317.47 543.861 317.719 543.913 318.322C542.72 318.165 540.78 317.063 540.61 315.923C540.465 314.86 541.003 313.575 541.567 312.841C542.078 313.051 542.065 314.192 542.524 315.66H542.537ZM546.182 325.102C545.539 324.551 546.221 323.974 546.509 322.781C546.693 322.047 546.562 321.483 546.444 321.063C547.702 322.007 549.616 324.512 549.158 325.273C549.144 325.299 549.118 325.325 549.105 325.351C548.083 325.653 546.627 325.509 546.182 325.102ZM549.013 321.076C547.663 319.358 547.165 319.975 546.824 319.057C546.654 318.611 546.85 318.152 547.217 317.798C547.912 317.575 548.699 317.667 549.131 318.388C549.8 319.503 550.206 321.562 550.272 322.847C549.944 322.388 549.538 321.732 549.026 321.089L549.013 321.076Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.766 312.487C541.396 310.651 538.735 312.277 538.84 316.119C538.932 319.962 541.75 324.551 545.12 326.387C548.489 328.223 551.138 326.597 551.046 322.755C550.954 318.926 548.148 314.323 544.779 312.487H544.766ZM543.284 312.933C544.477 312.92 547.388 315.162 547.807 315.975C548.227 316.788 547.165 316.513 546.221 316.88C545.015 317.339 545.618 318.506 544.897 318.231C543.835 317.824 542.104 312.946 543.284 312.933ZM541.488 312.788C542.104 312.88 542.065 314.074 542.537 315.647C543.14 317.64 544.019 317.745 543.914 318.506C543.756 319.608 539.928 318.06 539.705 316.447C539.482 314.834 540.872 312.697 541.475 312.788H541.488ZM543.35 324.079C542.026 323.096 539.967 319.529 539.928 318.768C539.889 318.008 540.924 319.031 542.17 319.634C543.756 320.407 543.691 319.306 544.346 320.053C545.316 321.142 544.687 325.063 543.35 324.079ZM549.158 325.273C548.555 326.269 545.906 326.204 545.264 325.653C544.622 325.089 545.303 324.525 545.605 323.319C545.972 321.798 545.054 321.011 545.566 320.722C546.313 320.289 549.748 324.263 549.158 325.273ZM548.109 321.614C546.759 319.909 546.26 320.512 545.92 319.594C545.421 318.244 548.175 316.775 549.132 318.375C550.089 319.975 550.508 323.515 550.154 323.922C549.8 324.342 549.184 322.965 548.122 321.614H548.109Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.779 322.86C546.378 323.725 547.624 322.965 547.584 321.142C547.545 319.332 546.208 317.155 544.622 316.29C543.022 315.424 541.777 316.185 541.816 318.008C541.855 319.817 543.192 321.994 544.779 322.86Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.423 288.489L558.139 289.669C555.176 286.981 552.016 284.673 548.751 282.902L546.837 281.853C542.131 279.283 537.712 278.103 533.819 278.155C533.701 278.155 533.596 278.155 533.478 278.168C532.796 278.181 532.114 278.234 531.459 278.339C525.336 279.139 521.495 281.079 518.007 285.8C514.009 290.81 513.314 297.485 513.773 303.819C513.93 310.048 515.543 316.683 518.23 323.096L517.155 323.909C517.155 323.909 511.492 312.854 510.495 300.422C509.499 287.99 515.739 277.945 528.758 275.191C541.764 272.424 559.423 288.476 559.423 288.476V288.489Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M559.423 288.489L558.139 289.669C555.176 286.981 552.016 284.673 548.751 282.902L546.837 281.853C542.131 279.283 537.712 278.103 533.819 278.155C533.701 278.155 533.596 278.155 533.478 278.168C532.796 278.181 532.114 278.234 531.459 278.339C525.336 279.139 521.495 281.079 518.007 285.8C514.009 290.81 513.314 297.485 513.773 303.819C513.93 310.048 515.543 316.683 518.23 323.096L517.155 323.909C517.155 323.909 511.492 312.854 510.495 300.422C509.499 287.99 515.739 277.945 528.758 275.191C541.764 272.424 559.423 288.476 559.423 288.476V288.489Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.809 288.646C560.852 289.866 559.528 290.862 558.099 291.597C558.06 291.623 556.29 292.37 556.25 292.383C552.566 288.712 548.056 285.197 543.94 282.824C525.729 272.398 511.229 278.221 511.727 301.353C511.872 308.33 514.1 317.155 517.142 323.935C516.237 323.856 515.516 323.515 514.795 323.043C511.898 316.001 510.141 308.749 509.971 301.93C509.446 294.783 510.259 287.282 514.848 281.683C518.663 276.608 522.897 274.496 529.61 273.618C530.331 273.513 531.078 273.447 531.839 273.421C531.97 273.421 532.088 273.421 532.219 273.408C536.559 273.369 541.462 274.68 546.693 277.526L548.817 278.68C553.392 281.171 557.771 284.594 561.796 288.659L561.809 288.646Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.099 291.584C558.099 291.584 556.29 292.357 556.25 292.37C552.566 288.699 548.056 285.184 543.94 282.81C525.729 272.385 511.229 278.208 511.727 301.34C511.871 308.317 514.1 317.142 517.142 323.922C516.237 323.843 515.516 323.502 514.795 323.03C511.898 315.988 510.141 308.736 509.97 301.917C509.433 293.183 511.032 282.745 519.174 277.88C525.021 274.418 533.163 274.746 542.275 279.703L544.398 280.87C549.249 283.505 553.877 287.204 558.099 291.584Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.52 226.644L443.605 225.595C438.899 223.038 434.481 221.858 430.574 221.897C430.456 221.897 430.351 221.897 430.233 221.897C429.551 221.923 428.869 221.976 428.214 222.068C422.078 222.868 418.25 224.808 414.762 229.529C410.764 234.552 410.069 241.214 410.528 247.548C411 266.405 424.805 289 441.377 298.009L443.291 299.058C447.997 301.616 452.416 302.796 456.323 302.756C456.323 302.756 456.401 302.756 456.441 302.756C456.493 302.756 456.545 302.756 456.598 302.756C456.86 302.756 457.109 302.743 457.358 302.717C457.45 302.717 457.529 302.717 457.607 302.704C457.83 302.691 458.04 302.665 458.263 302.638C458.381 302.638 458.486 302.612 458.591 302.599C458.643 302.599 458.709 302.586 458.761 302.573C465.093 301.72 469.066 299.57 472.527 294.573C472.671 294.364 472.816 294.141 472.96 293.931C472.973 293.905 472.999 293.878 473.012 293.852C473.169 293.603 473.301 293.315 473.484 293.065C475.359 290.548 476.552 285.053 476.408 279.27L476.355 277.093C475.883 258.235 462.078 235.64 445.506 226.631L445.52 226.644ZM442.268 295.557C426.64 287.046 413.609 265.723 413.163 247.928C412.717 230.133 425.028 222.605 440.656 231.116C456.283 239.627 469.315 260.95 469.761 278.745C470.207 296.541 457.896 304.068 442.268 295.557Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.534 228.625L439.62 227.575C431.426 223.117 424.097 222.815 418.839 225.936C411.511 230.316 410.069 239.706 410.554 247.574C411.026 266.431 424.831 289.026 441.403 298.036L443.317 299.085C448.128 301.707 452.638 302.888 456.611 302.783C456.873 302.783 457.122 302.77 457.371 302.743C457.463 302.743 457.542 302.743 457.62 302.73C457.843 302.717 458.053 302.691 458.276 302.665C458.394 302.665 458.499 302.638 458.603 302.625C458.826 302.599 459.036 302.56 459.246 302.52C459.443 302.494 459.639 302.455 459.823 302.402C460.019 302.363 460.203 302.324 460.373 302.271C460.727 302.179 461.068 302.075 461.409 301.957C461.553 301.917 461.698 301.865 461.842 301.812C461.999 301.76 462.156 301.694 462.314 301.629C462.445 301.576 462.576 301.524 462.707 301.458C462.995 301.34 463.271 301.209 463.533 301.052C463.664 300.986 463.808 300.907 463.939 300.829C463.979 300.803 464.005 300.789 464.044 300.763C464.097 300.737 464.149 300.711 464.202 300.671C464.293 300.632 464.372 300.566 464.464 300.527C469.629 297.262 472.71 290.6 472.474 281.276L472.422 279.099C471.95 260.242 458.132 237.647 441.573 228.638L441.534 228.625ZM442.268 295.557C426.64 287.046 413.608 265.723 413.163 247.928C412.717 230.133 425.028 222.605 440.655 231.116C456.283 239.627 469.315 260.95 469.76 278.745C470.206 296.541 457.896 304.068 442.268 295.557Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.904 290.469C458.63 295.832 451 296.777 442.189 291.977C428.292 284.41 416.716 265.461 416.309 249.646C416.126 242.578 418.224 237.332 421.829 234.368C419.338 237.463 417.961 242.027 418.119 247.823C418.512 263.638 430.102 282.588 443.999 290.154C451.681 294.337 458.46 294.154 462.917 290.482L462.904 290.469Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M462.904 290.469C458.63 295.832 451 296.777 442.189 291.977C428.292 284.41 416.716 265.461 416.309 249.646C416.126 242.578 418.224 237.332 421.829 234.368C419.338 237.463 417.961 242.027 418.119 247.823C418.512 263.638 430.102 282.588 443.999 290.154C451.681 294.337 458.46 294.154 462.917 290.482L462.904 290.469Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.656 231.116C425.028 222.605 412.717 230.133 413.163 247.928C413.609 265.723 426.641 287.046 442.268 295.557C457.896 304.068 470.207 296.541 469.761 278.745C469.315 260.95 456.283 239.627 440.656 231.116ZM442.19 291.977C428.293 284.41 416.716 265.461 416.31 249.646C415.916 233.831 426.85 227.143 440.747 234.709C454.645 242.276 466.221 261.225 466.628 277.04C467.021 292.856 456.087 299.544 442.19 291.977Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M440.656 231.116C425.028 222.605 412.717 230.133 413.163 247.928C413.609 265.723 426.641 287.046 442.268 295.557C457.896 304.068 470.207 296.541 469.761 278.745C469.315 260.95 456.283 239.627 440.656 231.116ZM442.19 291.977C428.293 284.41 416.716 265.461 416.31 249.646C415.916 233.831 426.85 227.143 440.747 234.709C454.645 242.276 466.221 261.225 466.628 277.04C467.021 292.856 456.087 299.544 442.19 291.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.578 269.185C465.513 268.91 465.447 268.635 465.382 268.346L441.455 262.969L462.891 260.897C462.786 260.648 462.694 260.412 462.589 260.163L441.455 262.969L458.774 252.819C458.643 252.596 458.499 252.387 458.368 252.177L441.455 262.969L453.53 245.515C453.359 245.305 453.189 245.109 453.018 244.912L441.455 262.969L447.525 239.43C447.302 239.247 447.093 239.063 446.87 238.88L441.455 262.969L441.127 234.919C440.996 234.84 440.865 234.762 440.734 234.696C440.603 234.631 440.472 234.565 440.354 234.5L441.455 262.969L434.756 232.257C434.48 232.178 434.205 232.113 433.93 232.06L441.468 262.983L428.803 231.641C428.541 231.667 428.279 231.693 428.017 231.733L441.468 262.983L423.677 233.136C423.454 233.254 423.231 233.385 423.022 233.516L441.468 262.969L419.692 236.637C419.534 236.847 419.39 237.07 419.246 237.293L441.468 262.969L417.174 241.987C417.096 242.263 417.03 242.525 416.965 242.801L441.468 262.956L416.322 248.833C416.322 249.095 416.322 249.357 416.322 249.633C416.322 249.659 416.322 249.685 416.322 249.711L441.468 262.969L417.188 256.714C417.24 256.99 417.306 257.265 417.371 257.54L441.468 262.956L419.757 265.068C419.862 265.317 419.967 265.553 420.059 265.802L441.468 262.956L423.848 273.29C423.979 273.513 424.11 273.723 424.241 273.946L441.481 262.956L429.144 280.804C429.315 281.014 429.485 281.211 429.656 281.407L441.481 262.956L435.267 287.086C435.49 287.269 435.7 287.466 435.922 287.649L441.481 262.956L441.822 291.741C441.953 291.82 442.084 291.885 442.215 291.964C442.347 292.029 442.478 292.095 442.596 292.161L441.481 262.956L448.364 294.455C448.64 294.534 448.915 294.587 449.19 294.652L441.481 262.969L454.434 295.006C454.697 294.98 454.959 294.954 455.221 294.914L441.481 262.969L459.613 293.367C459.836 293.236 460.046 293.105 460.255 292.96L441.481 262.969L463.546 289.643C463.69 289.42 463.848 289.21 463.979 288.974L441.481 262.969L465.945 284.096C466.011 283.82 466.076 283.545 466.129 283.256L441.481 262.969L466.64 277.106C466.64 277.106 466.64 277.054 466.64 277.027C466.64 276.752 466.614 276.49 466.601 276.214L441.481 262.969L465.605 269.185H465.578Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.451 255.691C440.721 254.747 439.187 254.721 438.099 255.442C437.876 255.586 437.601 255.718 437.312 255.901C437.233 255.954 437.155 256.006 437.089 256.058C437.076 256.058 437.063 256.072 437.05 256.085C437.05 256.085 437.05 256.085 437.037 256.085C436.932 256.163 436.84 256.242 436.748 256.334C436.722 256.36 436.709 256.373 436.683 256.399C436.604 256.478 436.526 256.57 436.447 256.675C436.421 256.714 436.394 256.754 436.368 256.78C436.303 256.872 436.25 256.963 436.185 257.055C436.158 257.108 436.132 257.16 436.093 257.226C436.054 257.317 436.001 257.409 435.962 257.501C435.936 257.58 435.909 257.658 435.883 257.724C435.857 257.816 435.818 257.908 435.791 257.999C435.765 258.091 435.739 258.196 435.726 258.301C435.713 258.393 435.686 258.471 435.673 258.563C435.647 258.694 435.634 258.825 435.621 258.957C435.621 259.035 435.608 259.101 435.595 259.18C435.582 259.389 435.582 259.612 435.582 259.848C435.673 263.691 438.492 268.28 441.861 270.116C442.071 270.234 442.281 270.326 442.491 270.418C442.609 270.47 442.727 270.51 442.858 270.549C442.937 270.575 443.028 270.615 443.107 270.641C443.186 270.667 443.264 270.68 443.356 270.707C443.474 270.733 443.592 270.772 443.697 270.798C443.736 270.798 443.789 270.798 443.828 270.811C443.972 270.838 444.116 270.851 444.261 270.864C444.261 270.864 444.274 270.864 444.287 270.864C445.034 270.903 445.69 270.72 446.24 270.352C446.529 270.169 446.778 270.038 447.106 269.841C448.141 269.172 448.758 267.822 448.718 265.946C448.626 262.104 445.808 257.514 442.438 255.678L442.451 255.691ZM441.022 267.297C439.974 266.523 438.466 264.123 437.863 262.773C438.177 262.969 438.545 263.205 438.925 263.389C440.511 264.163 440.446 263.061 441.101 263.809C441.73 264.517 441.678 266.418 441.206 267.402C441.14 267.376 441.088 267.349 441.022 267.297ZM443.894 260.084C443.802 260.124 443.71 260.163 443.645 260.202C443.474 260.307 442.805 260.701 442.74 260.753C442.517 260.884 442.373 261.055 442.294 261.225C441.494 260.452 440.537 257.96 440.577 256.767C441.94 257.199 444.221 259.009 444.588 259.717C444.615 259.783 444.641 259.835 444.654 259.888C444.418 259.927 444.156 259.98 443.907 260.071L443.894 260.084ZM439.318 259.416C439.869 261.225 440.642 261.488 440.695 262.078C439.502 261.92 437.561 260.819 437.391 259.678C437.247 258.616 437.784 257.331 438.348 256.596C438.859 256.806 438.846 257.947 439.305 259.416H439.318ZM442.95 268.857C442.307 268.307 442.989 267.73 443.277 266.536C443.461 265.802 443.33 265.238 443.212 264.818C444.47 265.763 446.385 268.267 445.926 269.041C445.913 269.067 445.886 269.094 445.86 269.12C444.838 269.421 443.382 269.277 442.937 268.871L442.95 268.857ZM445.795 264.832C444.444 263.114 443.946 263.73 443.605 262.812C443.435 262.366 443.631 261.907 443.998 261.553C444.693 261.33 445.48 261.422 445.913 262.143C446.581 263.258 446.988 265.317 447.053 266.602C446.725 266.143 446.319 265.487 445.808 264.845L445.795 264.832Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M442.451 255.691C440.721 254.747 439.187 254.721 438.099 255.442C437.876 255.586 437.601 255.718 437.312 255.901C437.233 255.954 437.155 256.006 437.089 256.058C437.076 256.058 437.063 256.072 437.05 256.085C437.05 256.085 437.05 256.085 437.037 256.085C436.932 256.163 436.84 256.242 436.748 256.334C436.722 256.36 436.709 256.373 436.683 256.399C436.604 256.478 436.526 256.57 436.447 256.675C436.421 256.714 436.394 256.754 436.368 256.78C436.303 256.872 436.25 256.963 436.185 257.055C436.158 257.108 436.132 257.16 436.093 257.226C436.054 257.317 436.001 257.409 435.962 257.501C435.936 257.58 435.909 257.658 435.883 257.724C435.857 257.816 435.818 257.908 435.791 257.999C435.765 258.091 435.739 258.196 435.726 258.301C435.713 258.393 435.686 258.471 435.673 258.563C435.647 258.694 435.634 258.825 435.621 258.957C435.621 259.035 435.608 259.101 435.595 259.18C435.582 259.389 435.582 259.612 435.582 259.848C435.673 263.691 438.492 268.28 441.861 270.116C442.071 270.234 442.281 270.326 442.491 270.418C442.609 270.47 442.727 270.51 442.858 270.549C442.937 270.575 443.028 270.615 443.107 270.641C443.186 270.667 443.264 270.68 443.356 270.707C443.474 270.733 443.592 270.772 443.697 270.798C443.736 270.798 443.789 270.798 443.828 270.811C443.972 270.838 444.116 270.851 444.261 270.864C444.261 270.864 444.274 270.864 444.287 270.864C445.034 270.903 445.69 270.72 446.24 270.352C446.529 270.169 446.778 270.038 447.106 269.841C448.141 269.172 448.758 267.822 448.718 265.946C448.626 262.104 445.808 257.514 442.438 255.678L442.451 255.691ZM441.022 267.297C439.974 266.523 438.466 264.123 437.863 262.773C438.177 262.969 438.545 263.205 438.925 263.389C440.511 264.163 440.446 263.061 441.101 263.809C441.73 264.517 441.678 266.418 441.206 267.402C441.14 267.376 441.088 267.349 441.022 267.297ZM443.894 260.084C443.802 260.124 443.71 260.163 443.645 260.202C443.474 260.307 442.805 260.701 442.74 260.753C442.517 260.884 442.373 261.055 442.294 261.225C441.494 260.452 440.537 257.96 440.577 256.767C441.94 257.199 444.221 259.009 444.588 259.717C444.615 259.783 444.641 259.835 444.654 259.888C444.418 259.927 444.156 259.98 443.907 260.071L443.894 260.084ZM439.318 259.416C439.869 261.225 440.642 261.488 440.695 262.078C439.502 261.92 437.561 260.819 437.391 259.678C437.247 258.616 437.784 257.331 438.348 256.596C438.859 256.806 438.846 257.947 439.305 259.416H439.318ZM442.95 268.857C442.307 268.307 442.989 267.73 443.277 266.536C443.461 265.802 443.33 265.238 443.212 264.818C444.47 265.763 446.385 268.267 445.926 269.041C445.913 269.067 445.886 269.094 445.86 269.12C444.838 269.421 443.382 269.277 442.937 268.871L442.95 268.857ZM445.795 264.832C444.444 263.114 443.946 263.73 443.605 262.812C443.435 262.366 443.631 261.907 443.998 261.553C444.693 261.33 445.48 261.422 445.913 262.143C446.581 263.258 446.988 265.317 447.053 266.602C446.725 266.143 446.319 265.487 445.808 264.845L445.795 264.832Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.534 256.242C438.165 254.406 435.503 256.032 435.608 259.875C435.7 263.717 438.518 268.307 441.888 270.143C445.257 271.979 447.906 270.352 447.814 266.51C447.722 262.681 444.916 258.078 441.534 256.242ZM440.052 256.688C441.245 256.675 444.156 258.917 444.576 259.73C444.995 260.543 443.933 260.268 442.989 260.635C441.783 261.094 442.386 262.261 441.665 261.986C440.603 261.579 438.872 256.701 440.052 256.688ZM438.256 256.544C438.872 256.636 438.833 257.829 439.305 259.402C439.908 261.396 440.787 261.501 440.682 262.261C440.524 263.363 436.696 261.815 436.473 260.202C436.25 258.589 437.64 256.452 438.243 256.544H438.256ZM440.118 267.835C438.794 266.851 436.735 263.284 436.696 262.524C436.657 261.763 437.693 262.786 438.938 263.389C440.524 264.163 440.459 263.061 441.114 263.809C442.085 264.897 441.455 268.818 440.118 267.835ZM445.939 269.028C445.336 270.038 442.688 269.959 442.045 269.408C441.403 268.844 442.085 268.28 442.386 267.074C442.753 265.553 441.835 264.766 442.347 264.477C443.094 264.045 446.529 268.018 445.939 269.028ZM444.89 265.369C443.54 263.664 443.028 264.268 442.701 263.35C442.203 261.999 444.956 260.53 445.913 262.13C446.87 263.73 447.289 267.271 446.935 267.677C446.568 268.097 445.965 266.707 444.903 265.369H444.89Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.547 266.615C443.146 267.481 444.392 266.72 444.353 264.897C444.313 263.087 442.976 260.911 441.39 260.045C439.79 259.18 438.545 259.94 438.584 261.763C438.623 263.573 439.961 265.75 441.547 266.615Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.191 232.244L454.907 233.424C451.944 230.736 448.784 228.428 445.519 226.658L443.605 225.608C438.899 223.038 434.48 221.858 430.574 221.91C430.456 221.91 430.351 221.91 430.233 221.923C429.551 221.937 428.869 221.989 428.214 222.094C422.091 222.894 418.25 224.835 414.762 229.556C410.764 234.565 410.069 241.24 410.528 247.574C410.685 253.803 412.298 260.438 414.985 266.851L413.91 267.664C413.91 267.664 408.246 256.609 407.25 244.177C406.254 231.746 412.494 221.701 425.513 218.934C438.518 216.167 456.191 232.218 456.191 232.218V232.244Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M456.191 232.244L454.907 233.424C451.944 230.736 448.784 228.428 445.519 226.658L443.605 225.608C438.899 223.038 434.48 221.858 430.574 221.91C430.456 221.91 430.351 221.91 430.233 221.923C429.551 221.937 428.869 221.989 428.214 222.094C422.091 222.894 418.25 224.835 414.762 229.556C410.764 234.565 410.069 241.24 410.528 247.574C410.685 253.803 412.298 260.438 414.985 266.851L413.91 267.664C413.91 267.664 408.246 256.609 407.25 244.177C406.254 231.746 412.494 221.701 425.513 218.934C438.518 216.167 456.191 232.218 456.191 232.218V232.244Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.591 232.388C457.634 233.608 456.309 234.604 454.88 235.339C454.841 235.365 453.071 236.113 453.032 236.126C449.348 232.454 444.838 228.926 440.721 226.566C422.511 216.14 408.01 221.963 408.509 245.095C408.653 252.072 410.882 260.897 413.923 267.677C413.019 267.599 412.298 267.258 411.576 266.786C408.679 259.743 406.922 252.492 406.752 245.672C406.227 238.525 407.04 231.024 411.629 225.412C415.444 220.337 419.679 218.225 426.391 217.347C427.112 217.242 427.86 217.176 428.62 217.15C428.751 217.15 428.869 217.15 429 217.137C433.34 217.098 438.256 218.409 443.474 221.255L445.598 222.409C450.174 224.9 454.553 228.323 458.577 232.388H458.591Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.88 235.339C454.88 235.339 453.071 236.113 453.032 236.126C449.348 232.454 444.838 228.926 440.721 226.566C422.51 216.14 408.01 221.963 408.509 245.095C408.653 252.072 410.882 260.897 413.923 267.677C413.019 267.599 412.297 267.258 411.576 266.786C408.679 259.743 406.922 252.492 406.752 245.672C406.214 236.939 407.814 226.5 415.955 221.635C421.803 218.173 429.944 218.501 439.056 223.458L441.18 224.625C446.031 227.261 450.659 230.959 454.88 235.339Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.756 300.737C485.336 300.724 484.969 300.409 484.903 299.976L473.248 223.156C473.169 222.671 473.51 222.212 473.995 222.133C474.481 222.055 475.988 222.146 476.054 222.632L487.709 299.452C487.788 299.937 486.398 300.645 485.913 300.724C485.86 300.724 485.795 300.724 485.742 300.724L485.756 300.737Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M485.756 300.737C485.336 300.724 484.969 300.409 484.903 299.976L473.248 223.156C473.169 222.671 473.51 222.212 473.995 222.133C474.481 222.055 475.988 222.146 476.054 222.632L487.709 299.452C487.788 299.937 486.398 300.645 485.913 300.724C485.86 300.724 485.795 300.724 485.742 300.724L485.756 300.737Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.43 236.637L522.425 261.147L524.025 258.603L477.981 233.542C476.303 232.598 475.293 235.483 477.417 236.637H477.43Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M477.43 236.637L522.425 261.147L524.025 258.603L477.981 233.542C476.303 232.598 475.293 235.483 477.417 236.637H477.43Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.743 262.707C532.389 262.261 531.734 262.183 531.288 262.537L528.692 264.582L512.488 277.329L510.954 274.024C512.606 273.264 514.166 272.385 515.621 271.388C523.199 266.208 527.997 258.144 529.872 247.43C529.977 246.866 529.597 246.328 529.033 246.236C528.469 246.145 527.617 245.725 527.512 246.289C525.729 256.439 521.232 264.045 514.126 268.897C505.919 274.509 494.277 275.926 481.77 273.434L448.115 263.087L479.777 253.934C480.328 253.777 479.593 250.328 479.056 250.498L440.183 261.92C440.183 261.92 440.105 261.96 440.079 261.973C440.039 261.986 440 262.012 439.947 262.038C439.869 262.091 439.79 262.143 439.725 262.222C439.711 262.235 439.685 262.248 439.672 262.261C439.672 262.261 439.672 262.261 439.672 262.274C439.593 262.366 439.541 262.484 439.502 262.602C439.502 262.642 439.502 262.681 439.489 262.707C439.489 262.773 439.462 262.838 439.449 262.904C439.449 262.93 439.449 262.943 439.449 262.969C439.449 263.009 439.449 263.061 439.475 263.101C439.489 263.179 439.515 263.258 439.541 263.323C439.554 263.363 439.58 263.402 439.607 263.441C439.659 263.52 439.711 263.586 439.777 263.651C439.79 263.664 439.803 263.691 439.829 263.717L484.589 300.225C484.707 300.317 484.825 300.396 484.943 300.462C485.27 300.645 485.572 300.711 485.86 300.698C486.345 300.698 486.752 300.448 487.079 300.186L529.295 266.746L532.586 264.15C533.032 263.796 533.11 263.14 532.756 262.694L532.743 262.707ZM486.018 297.485C485.546 297.852 485.27 298.101 485.139 298.009L445.231 265.461L481.298 276.581C481.298 276.581 481.363 276.595 481.403 276.608C485.703 277.473 489.951 277.84 494.015 277.735C499.036 277.604 503.782 276.752 508.043 275.205L509.918 279.362L486.018 297.485Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M532.743 262.707C532.389 262.261 531.734 262.183 531.288 262.537L528.692 264.582L512.488 277.329L510.954 274.024C512.606 273.264 514.166 272.385 515.621 271.388C523.199 266.208 527.997 258.144 529.872 247.43C529.977 246.866 529.597 246.328 529.033 246.236C528.469 246.145 527.617 245.725 527.512 246.289C525.729 256.439 521.232 264.045 514.126 268.897C505.919 274.509 494.277 275.926 481.77 273.434L448.115 263.087L479.777 253.934C480.328 253.777 479.593 250.328 479.056 250.498L440.183 261.92C440.183 261.92 440.105 261.96 440.079 261.973C440.039 261.986 440 262.012 439.947 262.038C439.869 262.091 439.79 262.143 439.725 262.222C439.711 262.235 439.685 262.248 439.672 262.261C439.672 262.261 439.672 262.261 439.672 262.274C439.593 262.366 439.541 262.484 439.502 262.602C439.502 262.642 439.502 262.681 439.489 262.707C439.489 262.773 439.462 262.838 439.449 262.904C439.449 262.93 439.449 262.943 439.449 262.969C439.449 263.009 439.449 263.061 439.475 263.101C439.489 263.179 439.515 263.258 439.541 263.323C439.554 263.363 439.58 263.402 439.607 263.441C439.659 263.52 439.711 263.586 439.777 263.651C439.79 263.664 439.803 263.691 439.829 263.717L484.589 300.225C484.707 300.317 484.825 300.396 484.943 300.462C485.27 300.645 485.572 300.711 485.86 300.698C486.345 300.698 486.752 300.448 487.079 300.186L529.295 266.746L532.586 264.15C533.032 263.796 533.11 263.14 532.756 262.694L532.743 262.707ZM486.018 297.485C485.546 297.852 485.27 298.101 485.139 298.009L445.231 265.461L481.298 276.581C481.298 276.581 481.363 276.595 481.403 276.608C485.703 277.473 489.951 277.84 494.015 277.735C499.036 277.604 503.782 276.752 508.043 275.205L509.918 279.362L486.018 297.485Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M526.581 250.459L527.446 256.19C527.8 255.272 528.141 254.327 528.443 253.357L527.433 246.695C527.197 247.994 526.909 249.252 526.581 250.459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.118 266.143C530.698 266.13 530.331 265.815 530.265 265.382L526.621 241.384C526.542 240.899 526.883 240.44 527.368 240.361C527.853 240.283 529.361 240.374 529.426 240.86L533.071 264.858C533.15 265.343 531.76 266.051 531.275 266.13C531.222 266.13 531.157 266.13 531.104 266.13L531.118 266.143Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M531.118 266.143C530.698 266.13 530.331 265.815 530.265 265.382L526.621 241.384C526.542 240.899 526.883 240.44 527.368 240.361C527.853 240.283 529.361 240.374 529.426 240.86L533.071 264.858C533.15 265.343 531.76 266.051 531.275 266.13C531.222 266.13 531.157 266.13 531.104 266.13L531.118 266.143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M530.069 245.004L529.439 240.86C529.361 240.374 527.866 240.283 527.381 240.361C526.896 240.44 526.555 240.899 526.634 241.384L527.027 243.981C527.709 244.387 529.02 244.859 530.082 245.004H530.069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.972 318.886C540.229 313.405 536.467 306.166 535.273 298.311L531.222 271.598C531.144 271.113 530.908 269.526 529.557 270.352C528.246 271.152 528.338 271.624 528.404 272.11L532.599 299.714C533.792 307.569 537.555 314.808 543.297 320.289L544.071 321.024C544.425 321.365 545.133 321.47 545.854 320.814C546.575 320.171 546.339 319.227 545.985 318.886H545.972Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M545.972 318.886C540.229 313.405 536.467 306.166 535.273 298.311L531.222 271.598C531.144 271.113 530.908 269.526 529.557 270.352C528.246 271.152 528.338 271.624 528.404 272.11L532.599 299.714C533.792 307.569 537.555 314.808 543.297 320.289L544.071 321.024C544.425 321.365 545.133 321.47 545.854 320.814C546.575 320.171 546.339 319.227 545.985 318.886H545.972Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.439 259.966C529.439 259.966 529.702 261.724 529.925 263.153C530.108 264.373 527.604 266.956 527.984 269.487C528.377 272.097 528.718 274.3 528.718 274.3C528.889 275.375 531.524 273.71 531.367 272.674L531.091 270.838C530.868 269.395 530.75 268.595 531.59 268.11L532.35 267.638C533.307 267.113 533.569 268.071 533.766 269.316L534.081 271.362C534.225 272.333 536.939 271.139 536.729 269.762C536.729 269.762 536.27 266.759 535.968 264.727C535.719 263.087 532.796 262.943 532.494 260.911L532.153 258.629C532.258 259.665 530.043 260.832 529.453 259.979L529.439 259.966Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.004 289.446C483.605 288.135 481.481 288.108 479.987 289.092C479.685 289.302 479.305 289.485 478.912 289.735C478.807 289.8 478.702 289.879 478.597 289.944C478.584 289.957 478.558 289.971 478.545 289.984C478.545 289.984 478.531 289.984 478.518 289.997C478.374 290.102 478.243 290.22 478.125 290.338C478.099 290.364 478.073 290.39 478.046 290.43C477.928 290.548 477.824 290.666 477.732 290.797C477.692 290.849 477.653 290.902 477.627 290.954C477.535 291.072 477.456 291.203 477.378 291.334C477.338 291.413 477.299 291.492 477.26 291.557C477.194 291.688 477.129 291.806 477.076 291.951C477.037 292.056 476.998 292.161 476.958 292.265C476.919 292.397 476.866 292.515 476.84 292.646C476.801 292.777 476.775 292.921 476.749 293.052C476.722 293.17 476.696 293.288 476.67 293.419C476.644 293.59 476.63 293.774 476.604 293.957C476.604 294.062 476.578 294.154 476.565 294.259C476.552 294.56 476.539 294.862 476.552 295.19C476.683 300.501 480.577 306.848 485.231 309.392C485.519 309.549 485.808 309.694 486.096 309.812C486.267 309.89 486.437 309.943 486.594 309.995C486.712 310.035 486.817 310.087 486.935 310.126C487.053 310.166 487.158 310.179 487.276 310.218C487.434 310.257 487.591 310.31 487.748 310.336C487.814 310.336 487.866 310.349 487.932 310.362C488.128 310.389 488.338 310.428 488.535 310.428C488.548 310.428 488.561 310.428 488.574 310.428C489.61 310.48 490.514 310.231 491.275 309.72C491.668 309.471 492.022 309.287 492.481 309.012C493.923 308.094 494.775 306.232 494.71 303.622C494.579 298.311 490.685 291.964 486.031 289.42L486.004 289.446ZM484.025 305.497C482.57 304.422 480.485 301.104 479.659 299.242C480.105 299.517 480.603 299.832 481.14 300.094C483.33 301.157 483.238 299.648 484.143 300.671C485.008 301.655 484.943 304.291 484.287 305.641C484.208 305.602 484.117 305.563 484.025 305.497ZM487.997 295.531C487.866 295.583 487.748 295.636 487.643 295.701C487.42 295.832 486.49 296.396 486.385 296.462C486.07 296.645 485.886 296.882 485.768 297.118C484.667 296.055 483.343 292.593 483.395 290.954C485.27 291.544 488.443 294.062 488.941 295.046C488.981 295.137 489.02 295.216 489.033 295.282C488.705 295.334 488.338 295.4 487.997 295.544V295.531ZM481.665 294.6C482.425 297.091 483.487 297.458 483.579 298.272C481.94 298.049 479.239 296.527 479.017 294.954C478.807 293.485 479.567 291.715 480.354 290.692C481.049 290.98 481.049 292.554 481.665 294.6ZM486.699 307.661C485.808 306.887 486.752 306.1 487.158 304.448C487.407 303.425 487.237 302.652 487.08 302.061C488.81 303.36 491.458 306.835 490.829 307.897C490.803 307.936 490.777 307.963 490.75 308.002C489.335 308.408 487.329 308.212 486.712 307.661H486.699ZM490.619 302.101C488.745 299.727 488.05 300.58 487.578 299.294C487.355 298.678 487.617 298.035 488.115 297.55C489.072 297.236 490.16 297.38 490.764 298.363C491.681 299.911 492.245 302.756 492.337 304.527C491.891 303.897 491.327 302.992 490.619 302.088V302.101Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M486.004 289.446C483.605 288.135 481.481 288.108 479.987 289.092C479.685 289.302 479.305 289.485 478.912 289.735C478.807 289.8 478.702 289.879 478.597 289.944C478.584 289.957 478.558 289.971 478.545 289.984C478.545 289.984 478.531 289.984 478.518 289.997C478.374 290.102 478.243 290.22 478.125 290.338C478.099 290.364 478.073 290.39 478.046 290.43C477.928 290.548 477.824 290.666 477.732 290.797C477.692 290.849 477.653 290.902 477.627 290.954C477.535 291.072 477.456 291.203 477.378 291.334C477.338 291.413 477.299 291.492 477.26 291.557C477.194 291.688 477.129 291.806 477.076 291.951C477.037 292.056 476.998 292.161 476.958 292.265C476.919 292.397 476.866 292.515 476.84 292.646C476.801 292.777 476.775 292.921 476.749 293.052C476.722 293.17 476.696 293.288 476.67 293.419C476.644 293.59 476.63 293.774 476.604 293.957C476.604 294.062 476.578 294.154 476.565 294.259C476.552 294.56 476.539 294.862 476.552 295.19C476.683 300.501 480.577 306.848 485.231 309.392C485.519 309.549 485.808 309.694 486.096 309.812C486.267 309.89 486.437 309.943 486.594 309.995C486.712 310.035 486.817 310.087 486.935 310.126C487.053 310.166 487.158 310.179 487.276 310.218C487.434 310.257 487.591 310.31 487.748 310.336C487.814 310.336 487.866 310.349 487.932 310.362C488.128 310.389 488.338 310.428 488.535 310.428C488.548 310.428 488.561 310.428 488.574 310.428C489.61 310.48 490.514 310.231 491.275 309.72C491.668 309.471 492.022 309.287 492.481 309.012C493.923 308.094 494.775 306.232 494.71 303.622C494.579 298.311 490.685 291.964 486.031 289.42L486.004 289.446ZM484.025 305.497C482.57 304.422 480.485 301.104 479.659 299.242C480.105 299.517 480.603 299.832 481.14 300.094C483.33 301.157 483.238 299.648 484.143 300.671C485.008 301.655 484.943 304.291 484.287 305.641C484.208 305.602 484.117 305.563 484.025 305.497ZM487.997 295.531C487.866 295.583 487.748 295.636 487.643 295.701C487.42 295.832 486.49 296.396 486.385 296.462C486.07 296.645 485.886 296.882 485.768 297.118C484.667 296.055 483.343 292.593 483.395 290.954C485.27 291.544 488.443 294.062 488.941 295.046C488.981 295.137 489.02 295.216 489.033 295.282C488.705 295.334 488.338 295.4 487.997 295.544V295.531ZM481.665 294.6C482.425 297.091 483.487 297.458 483.579 298.272C481.94 298.049 479.239 296.527 479.017 294.954C478.807 293.485 479.567 291.715 480.354 290.692C481.049 290.98 481.049 292.554 481.665 294.6ZM486.699 307.661C485.808 306.887 486.752 306.1 487.158 304.448C487.407 303.425 487.237 302.652 487.08 302.061C488.81 303.36 491.458 306.835 490.829 307.897C490.803 307.936 490.777 307.963 490.75 308.002C489.335 308.408 487.329 308.212 486.712 307.661H486.699ZM490.619 302.101C488.745 299.727 488.05 300.58 487.578 299.294C487.355 298.678 487.617 298.035 488.115 297.55C489.072 297.236 490.16 297.38 490.764 298.363C491.681 299.911 492.245 302.756 492.337 304.527C491.891 303.897 491.327 302.992 490.619 302.088V302.101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.733 290.207C480.065 287.676 476.394 289.918 476.525 295.229C476.656 300.54 480.55 306.887 485.204 309.431C489.859 311.962 493.53 309.72 493.399 304.422C493.267 299.111 489.387 292.764 484.719 290.22L484.733 290.207ZM482.687 290.823C484.339 290.797 488.364 293.918 488.941 295.032C489.518 296.16 488.063 295.78 486.752 296.278C485.086 296.921 485.926 298.521 484.916 298.14C483.448 297.577 481.049 290.823 482.687 290.81V290.823ZM480.209 290.639C481.062 290.757 480.996 292.423 481.665 294.6C482.504 297.354 483.723 297.511 483.579 298.547C483.369 300.081 478.072 297.931 477.758 295.701C477.443 293.472 479.357 290.508 480.209 290.639ZM482.766 306.245C480.931 304.894 478.072 299.95 478.033 298.901C477.981 297.852 479.41 299.268 481.127 300.107C483.317 301.17 483.225 299.662 484.129 300.684C485.467 302.193 484.601 307.609 482.766 306.258V306.245ZM490.816 307.897C489.99 309.287 486.319 309.195 485.427 308.422C484.549 307.648 485.493 306.861 485.899 305.196C486.411 303.097 485.139 302.009 485.847 301.602C486.883 301.012 491.642 306.507 490.816 307.897ZM489.361 302.848C487.486 300.488 486.791 301.327 486.319 300.042C485.624 298.18 489.426 296.147 490.763 298.363C492.087 300.58 492.664 305.471 492.166 306.048C491.668 306.625 490.829 304.71 489.347 302.848H489.361Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.047 302.756C486.476 303.53 487.591 302.848 487.551 301.222C487.512 299.596 486.319 297.655 484.89 296.881C483.461 296.108 482.346 296.79 482.386 298.416C482.425 300.042 483.618 301.983 485.047 302.756Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.906 313.457C476.801 313.457 476.696 313.444 476.604 313.392C476.263 313.234 476.106 312.828 476.276 312.487L481.612 300.947L484.523 299.163C484.837 298.967 485.27 299.071 485.467 299.386C485.663 299.714 485.558 300.134 485.244 300.33L482.687 301.891L477.522 313.051C477.404 313.3 477.168 313.444 476.919 313.444L476.906 313.457Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.906 313.457C476.801 313.457 476.696 313.444 476.604 313.392C476.263 313.234 476.106 312.828 476.276 312.487L481.612 300.947L484.523 299.163C484.837 298.967 485.27 299.071 485.467 299.386C485.663 299.714 485.558 300.134 485.244 300.33L482.687 301.891L477.522 313.051C477.404 313.3 477.168 313.444 476.919 313.444L476.906 313.457Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M482.229 315.831L471.793 310.153C471.491 309.982 471.124 309.995 470.822 310.179L463.415 314.703C463.127 314.887 462.943 315.201 462.956 315.555V316.041C462.982 316.382 463.166 316.696 463.468 316.867L473.917 322.558C474.218 322.729 474.585 322.716 474.887 322.532L482.281 317.995C482.569 317.811 482.753 317.496 482.74 317.142V316.657C482.714 316.316 482.53 316.001 482.229 315.831Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M482.229 315.831L471.793 310.153C471.491 309.982 471.124 309.995 470.822 310.179L463.415 314.703C463.127 314.887 462.943 315.201 462.956 315.555V316.041C462.982 316.382 463.166 316.696 463.468 316.867L473.917 322.558C474.218 322.729 474.585 322.716 474.887 322.532L482.281 317.995C482.569 317.811 482.753 317.496 482.74 317.142V316.657C482.714 316.316 482.53 316.001 482.229 315.831Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.917 320.971C474.205 321.129 474.546 321.116 474.808 320.945L482.583 316.185C482.491 316.041 482.373 315.923 482.215 315.844L478.204 313.654L471.78 310.153C471.478 309.982 471.111 309.995 470.809 310.179L469.918 310.73L463.415 314.703C463.271 314.795 463.153 314.913 463.074 315.07L473.917 320.971Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.04 223.405C485.244 220.638 481.101 216.665 481.101 216.665C481.101 216.665 470.311 202.869 458.892 209.846C456.598 211.249 455.457 213.019 455.011 215.655C454.841 216.639 454.946 217.806 454.985 218.173C455.208 219.773 455.562 220.415 456.506 221.661C458.079 223.733 462.445 225.346 467.637 226.526C468.004 226.605 468.384 226.684 468.751 226.762C470.6 227.143 472.474 227.444 474.336 227.785C476.185 228.113 478.033 228.441 479.856 228.887C480.603 229.07 481.35 229.267 482.071 229.516C482.373 229.621 482.661 229.726 482.963 229.857C483.356 230.028 483.513 230.093 483.972 230.211C484.234 230.277 484.628 230.277 484.89 230.211C485.126 230.159 485.375 230.106 485.598 230.002C485.795 229.91 485.991 229.792 486.162 229.647C486.817 229.123 487.276 228.389 487.525 227.602C487.971 226.199 487.84 224.651 487.027 223.418L487.04 223.405Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.892 209.846C455.431 211.957 453.608 215.734 456.466 219.484C458.04 221.556 462.405 223.169 467.597 224.35C472.789 225.53 481.652 226.474 483.88 228.205C486.109 229.936 489.151 226.644 487.04 223.405C485.244 220.638 481.101 216.665 481.101 216.665C481.101 216.665 470.311 202.869 458.892 209.846Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.572 198.961L552.278 195.224L561.429 189.624C561.704 189.454 562.098 189.454 562.543 189.69C563.409 190.162 564.13 191.342 564.156 192.339C564.156 192.824 564.012 193.165 563.749 193.336L563.723 193.349L554.572 198.948V198.961Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.005 197.952C555.031 198.935 554.349 199.355 553.484 198.883C552.619 198.411 551.898 197.23 551.871 196.234C551.845 195.25 552.527 194.831 553.392 195.303C554.257 195.775 554.978 196.955 555.005 197.952Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M555.005 197.952C555.031 198.935 554.349 199.355 553.484 198.883C552.619 198.411 551.898 197.23 551.871 196.234C551.845 195.25 552.527 194.831 553.392 195.303C554.257 195.775 554.978 196.955 555.005 197.952Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.969 197.65C553.969 197.807 553.943 197.952 553.877 198.03L553.628 198.201L540.452 206.253C537.882 207.813 537.096 211.432 536.702 215.235C536.676 215.498 535.942 223.654 535.64 227.143C535.182 232.349 533.097 234.46 528.587 237.214L527.473 235.404C531.681 232.834 533.15 231.247 533.517 226.959C533.805 223.458 534.605 214.685 534.683 214.095C535.182 210.082 536.244 206.331 539.338 204.43L539.547 204.299L552.737 196.234C552.868 196.207 552.999 196.234 553.169 196.312C553.602 196.562 553.969 197.139 553.982 197.637L553.969 197.65Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.242 236.795C533.202 236.178 532.757 235.562 531.904 235.103L526.411 232.113L520.892 235.483L520.97 238.722L526.464 241.712C528.142 242.617 530.724 242.604 532.245 241.673C532.993 241.214 533.347 240.624 533.307 240.034C533.307 240.034 533.268 237.398 533.242 236.795Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.411 232.1L531.904 235.09C533.583 235.995 533.701 237.489 532.167 238.421C530.646 239.352 528.05 239.365 526.385 238.46L520.892 235.47L526.411 232.1Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M526.411 232.1L531.904 235.09C533.583 235.995 533.701 237.489 532.167 238.421C530.646 239.352 528.05 239.365 526.385 238.46L520.892 235.47L526.411 232.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.366 239.443C524.366 239.64 524.326 239.784 524.221 239.876L524.064 239.981C524.064 239.981 523.225 240.453 523.186 240.479C521.534 241.424 520.223 242.001 519.108 242.027C518.649 242.027 518.23 241.961 517.85 241.778C517.692 241.712 517.535 241.62 517.404 241.528C516.342 240.755 515.988 239.286 515.791 238.04C515.332 235.011 514.585 230.395 514.284 228.467C513.838 225.661 513.274 224.074 512.579 223.772C512.199 223.589 511.596 223.877 511.15 224.153L496.65 233.031L495.536 231.221L510.036 222.343C511.321 221.556 512.461 221.386 513.471 221.858C515.28 222.697 515.935 225.385 516.368 228.152C516.67 230.067 517.417 234.696 517.889 237.739C518.138 239.378 518.518 239.784 518.715 239.876C519.266 240.125 520.629 239.483 521.743 238.88C521.835 238.827 522.714 238.329 522.792 238.289C522.871 238.25 522.976 238.184 523.041 238.145H523.068C523.199 238.08 523.356 238.093 523.553 238.198C523.972 238.434 524.326 239.011 524.339 239.509L524.366 239.443Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.869 237.568L488.574 233.831L497.725 228.231C498.001 228.061 498.394 228.061 498.84 228.297C499.705 228.769 500.426 229.949 500.452 230.946C500.452 231.431 500.308 231.772 500.046 231.942L500.033 231.955L490.882 237.555L490.869 237.568Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.301 236.558C491.327 237.542 490.646 237.962 489.78 237.489C488.915 237.017 488.194 235.837 488.168 234.84C488.142 233.857 488.823 233.437 489.689 233.909C490.554 234.382 491.275 235.562 491.301 236.558Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M491.301 236.558C491.327 237.542 490.646 237.962 489.78 237.489C488.915 237.017 488.194 235.837 488.168 234.84C488.142 233.857 488.823 233.437 489.689 233.909C490.554 234.382 491.275 235.562 491.301 236.558Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.127 369.033C560.944 369.033 560.76 368.981 560.603 368.889L517.22 343.829C516.853 343.619 516.657 343.212 516.696 342.793L522.347 291.924C522.923 286.718 525.755 283.505 529.754 283.505C529.793 283.505 529.846 283.505 529.885 283.505L547.715 283.82C552.278 283.899 557.181 290.443 557.601 297.026L562.163 367.892C562.189 368.286 561.993 368.653 561.665 368.863C561.494 368.968 561.298 369.02 561.114 369.02L561.127 369.033ZM518.872 342.347L559.947 366.069L555.503 297.17C555.123 291.295 550.822 285.997 547.689 285.945L529.859 285.63C529.859 285.63 529.793 285.63 529.767 285.63C526.896 285.63 524.903 288.069 524.444 292.174L518.859 342.36L518.872 342.347Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M561.127 369.033C560.944 369.033 560.76 368.981 560.603 368.889L517.22 343.829C516.853 343.619 516.657 343.212 516.696 342.793L522.347 291.924C522.923 286.718 525.755 283.505 529.754 283.505C529.793 283.505 529.846 283.505 529.885 283.505L547.715 283.82C552.278 283.899 557.181 290.443 557.601 297.026L562.163 367.892C562.189 368.286 561.993 368.653 561.665 368.863C561.494 368.968 561.298 369.02 561.114 369.02L561.127 369.033ZM518.872 342.347L559.947 366.069L555.503 297.17C555.123 291.295 550.822 285.997 547.689 285.945L529.859 285.63C529.859 285.63 529.793 285.63 529.767 285.63C526.896 285.63 524.903 288.069 524.444 292.174L518.859 342.36L518.872 342.347Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6079 155.135L135.038 120.817V292.082L75.6079 326.4V155.135Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M75.6079 155.135L135.038 120.817V292.082L75.6079 326.4V155.135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9312 158.191L129.715 130.023V289.013L80.9312 317.182V158.191Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5819 155.109L75.6081 326.4L48.9414 311.005V139.74L75.5819 155.109Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M75.5819 155.109L75.6081 326.4L48.9414 311.005V139.74L75.5819 155.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.038 120.817L108.384 105.408L48.9414 139.74L75.6081 155.135L135.038 120.817Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M135.038 120.817L108.384 105.408L48.9414 139.74L75.6081 155.135L135.038 120.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.235 139.517V188.667L86.3979 210.501V161.364L121.534 141.077L124.235 139.517Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.547 181.625V187.107L86.3979 207.393V161.364L109.918 147.779L121.534 141.077V170.347L121.547 181.625Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.547 181.625V187.107L86.3979 207.393V161.364L109.918 147.779L121.534 141.077V170.347L121.547 181.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121.534 141.077L109.918 147.779L86.3979 171.305V180.038L121.521 144.907V141.091L121.534 141.077ZM121.534 155.371L86.4111 190.49V205.295L121.534 170.164V155.371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.541 158.112L112.357 168.905L103.874 173.127L109.394 184.851L96.939 173.022L105.998 167.961L101.541 158.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.334 221.648V241.515L86.4111 249.567V244.033L95.536 238.748V224.415L100.334 221.648Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.549 238.748L86.4111 244.033L86.3979 229.359L95.5359 224.415L95.549 238.748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.335 221.648V241.515L95.5361 238.748V224.415L100.335 221.648Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7178 252.295V297.537C99.7178 298.062 99.5736 298.324 99.4425 298.403C99.3245 298.468 99.0492 298.468 98.6428 298.232C97.5284 297.59 96.5451 295.859 96.5451 294.521V273.172C96.5451 271.834 95.824 270.575 94.6572 269.907L92.022 268.385C91.9171 268.359 91.8122 268.346 91.6811 268.425C91.3403 268.621 91.0649 269.212 91.0649 269.736C91.0649 270.038 91.1698 270.248 91.314 270.339L93.6477 271.703C94.1721 272.005 94.4999 272.569 94.4999 273.185V294.534C94.4999 296.593 95.8765 299.006 97.6333 300.016C98.197 300.344 98.7608 300.501 99.2983 300.501C99.731 300.501 100.124 300.396 100.491 300.186C101.317 299.714 101.789 298.744 101.789 297.537V252.295H99.731H99.7178Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7552 263.232C96.7552 262.642 97.1616 262.065 97.9482 261.619C99.5346 260.727 102.052 260.727 103.599 261.619C104.359 262.065 104.739 262.642 104.739 263.232C104.739 263.507 104.739 264.596 104.739 264.871C104.739 265.461 104.346 266.051 103.56 266.497C101.999 267.402 99.4691 267.402 97.9089 266.497C97.1354 266.051 96.7421 265.461 96.7552 264.871C96.7552 264.596 96.7552 263.507 96.7552 263.232Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.599 261.619C104.359 262.065 104.739 262.642 104.739 263.232C104.739 263.822 104.346 264.412 103.56 264.858C101.999 265.763 99.4691 265.763 97.9089 264.858C97.1354 264.412 96.7421 263.822 96.7552 263.232C96.7552 262.642 97.1616 262.065 97.9482 261.619C99.5346 260.727 102.052 260.727 103.599 261.619Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2793 249.016C97.2793 248.505 97.6333 248.007 98.315 247.613C99.6916 246.84 101.881 246.84 103.218 247.613C103.887 247.994 104.215 248.505 104.215 249.003C104.215 249.239 104.215 262.707 104.215 262.943C104.215 263.455 103.874 263.966 103.192 264.359C101.842 265.146 99.6392 265.146 98.2888 264.359C97.6071 263.966 97.2793 263.455 97.2793 262.956C97.2793 262.72 97.2793 249.252 97.2793 249.016Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.655 248.479C103.166 248.78 103.429 249.161 103.415 249.554C103.415 249.948 103.153 250.341 102.629 250.643C101.58 251.246 99.8887 251.246 98.8399 250.643C98.3155 250.341 98.0533 249.948 98.0664 249.554C98.0664 249.161 98.3417 248.767 98.8661 248.466C99.9281 247.876 101.619 247.876 102.655 248.466V248.479Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9829 228.664C91.8256 229.241 91.7338 229.831 91.3798 230.316C90.7898 231.129 89.6361 231.365 89.0724 232.192C88.8888 232.467 88.7839 232.782 88.666 233.083C88.4431 233.739 88.2202 234.382 87.9973 235.037C87.958 235.142 87.9187 235.26 87.9318 235.378C87.9318 235.522 88.0104 235.654 88.076 235.772C88.2989 236.178 88.5742 236.572 88.9019 236.965C89.033 237.122 89.2559 237.227 89.4526 237.188C89.5837 237.162 89.8066 236.926 89.8721 236.821C91.3667 234.736 92.7433 232.795 94.2248 230.697C94.5919 230.172 95.0114 229.7 95.3785 229.188C95.7063 228.716 96.1127 228.1 96.152 227.523C96.152 227.405 96.152 227.274 96.0865 227.169C96.0471 227.103 96.0078 227.051 95.9554 226.999C95.6801 226.697 95.3916 226.421 95.1032 226.133C94.7492 225.792 94.2772 226.251 93.9364 226.448C93.3202 226.802 92.6909 227.169 92.3238 227.772C92.1533 228.048 92.0616 228.349 91.9698 228.664H91.9829Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.264 259.271V245.004C105.264 239.365 102.55 233.582 99.1281 229.91C97.9612 228.664 96.27 226.972 96.27 226.972C95.916 226.605 95.3522 226.526 94.9065 226.789L93.7003 227.484C93.3201 227.707 93.0317 228.061 92.9137 228.48L92.4155 230.093C92.2319 230.697 91.8255 231.208 91.2749 231.523L90.6587 231.877C89.977 232.27 89.4657 232.913 89.2166 233.673L88.6528 235.457C88.4299 236.152 88.5872 236.899 89.0461 237.463L91.9042 240.952C94.5394 244.164 95.9684 248.177 95.9684 252.321V259.271C95.9684 261.986 105.251 261.986 105.251 259.271H105.264Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7552 239.43C96.5324 238.316 95.9817 237.149 95.3917 236.178C94.7624 235.129 94.0151 234.159 93.3727 233.123C92.9008 232.375 92.4681 231.588 92.0355 230.828C91.8388 231.09 91.5897 231.326 91.2882 231.496L90.672 231.851C90.4098 231.995 90.2 232.192 89.9902 232.401C90.3835 232.978 90.7769 233.542 91.1702 234.119C92.1535 235.549 93.1367 236.978 94.12 238.407C94.2774 238.63 94.4216 238.853 94.5133 239.102C94.7755 239.863 94.4216 240.676 94.1462 241.437C94.0151 241.804 93.8709 242.171 93.766 242.551C93.7398 242.63 93.7136 242.722 93.7136 242.801C93.7136 242.945 93.766 243.076 93.8316 243.207C94.0545 243.679 94.3822 244.073 94.7493 244.453C95.1295 244.846 95.3524 244.938 95.6277 244.348C95.9817 243.574 96.3488 242.787 96.5848 241.974C96.8208 241.148 96.9257 240.283 96.7552 239.443V239.43Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.701 245.659V261.304C102.996 261.291 105.264 260.609 105.264 259.271V245.004C105.264 239.365 102.55 233.582 99.128 229.91C97.9611 228.664 96.2699 226.972 96.2699 226.972C95.9159 226.605 95.3521 226.526 94.9064 226.789L93.7002 227.484C93.5298 227.576 93.3856 227.707 93.2676 227.851C95.339 230.159 97.3056 232.559 98.7084 235.352C100.046 238.001 100.688 240.02 100.688 245.672L100.701 245.659Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4111 224.336L100.334 216.285V210.921L86.3979 218.973L86.4111 224.336Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.261 207.839V227.694L110.338 235.745V230.211L119.476 224.927V210.606L124.261 207.839Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.476 224.94L110.338 230.211V215.55L119.476 210.606V224.94Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.261 207.839V227.694L119.476 224.927V210.606L124.261 207.839Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.645 238.486V283.728C123.645 284.253 123.501 284.515 123.37 284.594C123.252 284.66 122.976 284.66 122.57 284.423C121.456 283.781 120.472 282.05 120.472 280.725V259.376C120.472 258.039 119.751 256.78 118.584 256.111L115.949 254.59C115.844 254.564 115.739 254.55 115.608 254.629C115.268 254.826 114.992 255.416 114.992 255.94C114.992 256.242 115.097 256.452 115.241 256.544L117.575 257.908C118.099 258.209 118.427 258.773 118.427 259.389V280.739C118.427 282.797 119.804 285.21 121.561 286.22C122.124 286.548 122.688 286.705 123.226 286.705C123.658 286.705 124.052 286.6 124.419 286.391C125.245 285.918 125.717 284.948 125.717 283.742V238.499H123.658L123.645 238.486Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.682 249.423C120.682 248.833 121.088 248.256 121.875 247.81C123.461 246.918 125.979 246.918 127.526 247.81C128.299 248.256 128.679 248.833 128.666 249.423C128.666 249.698 128.666 250.787 128.666 251.062C128.666 251.652 128.273 252.242 127.486 252.688C125.926 253.593 123.396 253.593 121.836 252.688C121.062 252.242 120.669 251.652 120.682 251.062C120.682 250.787 120.682 249.698 120.682 249.423Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.526 247.81C128.286 248.256 128.666 248.833 128.666 249.423C128.666 250.013 128.273 250.603 127.486 251.049C125.926 251.954 123.396 251.954 121.836 251.049C121.062 250.603 120.669 250.013 120.682 249.423C120.682 248.833 121.088 248.256 121.875 247.81C123.461 246.918 125.979 246.918 127.526 247.81Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.207 235.208C121.207 234.696 121.561 234.185 122.242 233.805C123.619 233.031 125.808 233.031 127.146 233.805C127.814 234.185 128.142 234.696 128.142 235.195C128.142 235.431 128.142 248.898 128.142 249.134C128.142 249.646 127.801 250.157 127.119 250.551C125.769 251.338 123.566 251.338 122.216 250.551C121.534 250.157 121.207 249.646 121.207 249.134C121.207 248.898 121.207 235.431 121.207 235.195V235.208Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.582 234.657C127.093 234.959 127.355 235.339 127.342 235.732C127.342 236.126 127.08 236.519 126.556 236.821C125.507 237.424 123.815 237.424 122.767 236.821C122.242 236.519 121.98 236.126 121.993 235.732C121.993 235.339 122.268 234.945 122.793 234.657C123.855 234.067 125.546 234.067 126.582 234.657Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.923 214.855C115.766 215.432 115.674 216.022 115.32 216.508C114.73 217.321 113.576 217.557 113.012 218.383C112.829 218.658 112.724 218.973 112.606 219.275C112.383 219.93 112.16 220.573 111.937 221.228C111.898 221.333 111.859 221.451 111.872 221.569C111.872 221.714 111.95 221.845 112.016 221.963C112.239 222.369 112.514 222.763 112.842 223.156C112.973 223.314 113.196 223.432 113.393 223.379C113.524 223.353 113.747 223.117 113.812 223.012C115.307 220.927 116.683 218.986 118.165 216.888C118.532 216.376 118.951 215.891 119.318 215.38C119.646 214.908 120.053 214.291 120.092 213.714C120.092 213.596 120.092 213.465 120.026 213.36C119.987 213.295 119.948 213.242 119.895 213.19C119.62 212.888 119.332 212.613 119.043 212.337C118.689 211.996 118.217 212.455 117.876 212.652C117.26 213.006 116.631 213.373 116.264 213.977C116.093 214.252 116.002 214.554 115.91 214.868L115.923 214.855Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.191 245.45V231.182C129.191 225.543 126.477 219.76 123.055 216.088C121.888 214.842 120.197 213.15 120.197 213.15C119.843 212.783 119.279 212.705 118.833 212.967L117.627 213.662C117.247 213.885 116.958 214.239 116.84 214.658L116.342 216.271C116.159 216.875 115.752 217.386 115.202 217.701L114.585 218.055C113.904 218.448 113.392 219.091 113.143 219.852L112.58 221.635C112.357 222.33 112.514 223.091 112.973 223.641L115.831 227.13C118.466 230.342 119.895 234.355 119.895 238.499V245.45C119.895 248.164 129.177 248.164 129.177 245.45H129.191Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.695 225.622C120.472 224.507 119.922 223.34 119.332 222.369C118.702 221.32 117.955 220.35 117.313 219.314C116.841 218.566 116.408 217.78 115.975 217.019C115.779 217.281 115.53 217.517 115.228 217.688L114.612 218.042C114.363 218.186 114.14 218.383 113.93 218.593C114.323 219.17 114.717 219.734 115.11 220.311C116.093 221.74 117.077 223.169 118.06 224.599C118.217 224.822 118.362 225.045 118.453 225.294C118.715 226.054 118.362 226.867 118.086 227.628C117.955 227.995 117.811 228.362 117.706 228.743C117.68 228.821 117.654 228.913 117.654 228.992C117.654 229.136 117.706 229.267 117.772 229.398C117.994 229.884 118.322 230.264 118.689 230.644C119.069 231.038 119.292 231.129 119.568 230.539C119.922 229.766 120.289 228.992 120.525 228.166C120.761 227.339 120.866 226.474 120.695 225.635V225.622Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.628 231.837V247.482C126.922 247.469 129.19 246.787 129.19 245.45V231.182C129.19 225.543 126.477 219.76 123.055 216.088C121.888 214.842 120.197 213.15 120.197 213.15C119.843 212.783 119.279 212.705 118.833 212.967L117.627 213.662C117.457 213.754 117.312 213.885 117.194 214.029C119.266 216.337 121.232 218.737 122.635 221.53C123.972 224.179 124.615 226.199 124.615 231.851L124.628 231.837Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.338 210.515L124.261 202.476V197.112L110.338 205.151V210.515Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.689 323.988L155.202 303.412L134.946 291.715L118.741 301.104L118.689 323.988Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.906 392.402V397.87L259.548 384.796L273.431 371.787L253.176 360.09L236.971 369.479V392.363L236.919 392.402H236.906Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.97 387.615L246.739 377.216L259.194 370.004C263.153 367.722 268.437 367.984 274.231 371.328C286.542 378.436 296.506 396.769 296.506 412.269C296.506 420.387 293.766 426.117 289.4 428.714L289.23 428.819C289.23 428.819 289.217 428.819 289.204 428.832L276.434 436.202L270.914 425.226C260.465 417.213 252.389 401.437 251.983 387.602L251.97 387.615Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.97 387.615L246.739 377.216L259.194 370.004C263.153 367.722 268.437 367.984 274.231 371.328C286.542 378.436 296.506 396.769 296.506 412.269C296.506 420.387 293.766 426.117 289.4 428.714L289.23 428.819C289.23 428.819 289.217 428.819 289.204 428.832L276.434 436.202L270.914 425.226C260.465 417.213 252.389 401.437 251.983 387.602L251.97 387.615Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.978 394.015C238.978 407.378 246.398 422.852 256.336 431.415C256.362 431.415 256.362 431.441 256.375 431.455C257.948 432.805 259.587 433.985 261.265 434.956C273.576 442.064 283.553 435.258 283.54 419.757C283.54 408.047 277.85 394.71 269.761 385.832C269.735 385.806 269.708 385.793 269.695 385.766C267.086 382.921 264.254 380.534 261.265 378.829C248.955 371.722 238.991 378.528 238.991 394.028L238.978 394.015Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.265 388.166C253.438 383.642 247.093 388.35 247.093 398.696C247.093 409.043 253.438 421.082 261.265 425.606C269.092 430.13 275.438 425.409 275.438 415.075C275.438 404.742 269.092 392.69 261.265 388.166Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.854 404.021C255.392 409.161 258.696 414.617 262.236 416.19C263.796 416.885 265.133 416.715 266.09 415.862C267.336 414.8 267.965 412.623 267.663 409.738C267.126 404.598 263.822 399.142 260.282 397.569C259.325 397.136 258.447 397.044 257.686 397.228C255.654 397.726 254.461 400.27 254.854 404.008V404.021Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.126 403.352C256.664 408.492 259.967 413.948 263.507 415.521C264.464 415.941 265.343 416.046 266.103 415.862C267.349 414.8 267.978 412.623 267.676 409.738C267.139 404.598 263.835 399.142 260.295 397.569C259.338 397.136 258.46 397.044 257.699 397.228C256.467 398.303 255.838 400.467 256.139 403.352H256.126Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.978 394.015C238.978 407.378 246.398 422.852 256.336 431.415C250.449 425.016 244.353 414.289 242.203 404.06C240.315 395.116 241.023 382.291 248.692 379.052C256.296 375.826 266.483 382.645 269.682 385.753C267.073 382.908 264.241 380.521 261.252 378.816C248.941 371.708 238.978 378.514 238.978 394.015Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.753 319.227L128.521 308.828L140.976 301.616C144.936 299.334 150.219 299.596 156.014 302.94C168.312 310.048 178.289 328.381 178.289 343.881C178.289 351.999 175.549 357.729 171.183 360.326L158.217 367.827L152.697 356.851C142.248 348.838 134.172 333.062 133.766 319.227H133.753Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.753 319.227L128.521 308.828L140.976 301.616C144.936 299.334 150.219 299.596 156.014 302.94C168.312 310.048 178.289 328.381 178.289 343.881C178.289 351.999 175.549 357.729 171.183 360.326L158.217 367.827L152.697 356.851C142.248 348.838 134.172 333.062 133.766 319.227H133.753Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.773 325.627C120.773 338.99 128.194 354.464 138.132 363.027C138.158 363.027 138.158 363.053 138.171 363.066C139.744 364.417 141.383 365.597 143.061 366.568C155.372 373.675 165.349 366.869 165.336 351.369C165.336 339.658 159.646 326.322 151.557 317.444C151.531 317.418 151.504 317.405 151.491 317.378C148.882 314.533 146.05 312.146 143.061 310.441C130.75 303.333 120.787 310.14 120.787 325.64L120.773 325.627Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.048 319.791C135.221 315.267 128.875 319.975 128.875 330.322C128.875 340.668 135.221 352.707 143.048 357.231C150.875 361.755 157.22 357.034 157.22 346.701C157.22 336.367 150.875 324.315 143.048 319.791Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.637 335.646C137.175 340.786 140.478 346.242 144.018 347.815C145.578 348.51 146.916 348.34 147.873 347.487C149.118 346.425 149.748 344.248 149.446 341.363C148.909 336.223 145.605 330.767 142.065 329.194C141.108 328.761 140.229 328.669 139.469 328.853C137.437 329.351 136.244 331.895 136.637 335.633V335.646Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.909 334.977C138.446 340.117 141.75 345.573 145.29 347.146C146.247 347.566 147.125 347.671 147.886 347.487C149.131 346.425 149.761 344.248 149.459 341.363C148.922 336.223 145.618 330.767 142.078 329.194C141.121 328.761 140.242 328.669 139.482 328.853C138.25 329.928 137.62 332.092 137.922 334.977H137.909Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.773 325.627C120.773 338.99 128.194 354.464 138.132 363.027C132.245 356.628 126.149 345.901 123.999 335.672C122.111 326.728 122.819 313.903 130.488 310.664C138.092 307.438 148.279 314.257 151.478 317.365C148.869 314.519 146.037 312.133 143.048 310.428C130.737 303.32 120.773 310.126 120.773 325.627Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.915 315.687C409.059 325.22 397.955 344.956 380.82 356.247C355.87 372.692 305.159 383.327 279.174 357.414L251.197 334.649L240.695 278.706C238.348 270.654 234.481 268.871 229.027 265.723C218.512 259.704 156.841 214.068 156.67 206.921C145.71 217.74 130.121 250.97 121.403 282.535C118.702 285.525 116.329 291.557 115.739 294.626C112.357 312.093 113.17 321.076 118.702 324.001C118.702 322.952 118.742 321.942 118.846 320.985C120.276 305.432 131.446 299.124 145.015 306.966C145.854 307.438 146.693 307.963 147.506 308.54C153.786 312.906 159.41 319.621 163.632 327.305C166.385 332.341 168.522 337.77 169.872 343.212C170.397 345.415 170.764 347.592 171.039 349.743C171.485 353.336 171.485 354.503 171.485 354.503C177.372 357.9 224.595 385.32 236.906 392.428C236.906 391.366 236.972 390.356 237.05 389.386C238.492 373.833 249.663 367.499 263.232 375.341C264.071 375.826 264.91 376.364 265.723 376.941C271.99 381.281 277.627 388.022 281.836 395.707C284.287 400.165 286.241 404.899 287.604 409.804C288.81 414.158 288.417 419.849 291.747 422.996C298.669 429.527 306.09 429.999 311.531 430.287C334.789 431.533 361.075 421.619 382.406 408.112C408.692 391.471 414.999 379.747 417.765 368.561C421.357 354.057 414.409 317.785 408.915 315.739V315.687Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M408.915 315.687C409.059 325.22 397.955 344.956 380.82 356.247C355.87 372.692 305.159 383.327 279.174 357.414L251.197 334.649L240.695 278.706C238.348 270.654 234.481 268.871 229.027 265.723C218.512 259.704 156.841 214.068 156.67 206.921C145.71 217.74 130.121 250.97 121.403 282.535C118.702 285.525 116.329 291.557 115.739 294.626C112.357 312.093 113.17 321.076 118.702 324.001C118.702 322.952 118.742 321.942 118.846 320.985C120.276 305.432 131.446 299.124 145.015 306.966C145.854 307.438 146.693 307.963 147.506 308.54C153.786 312.906 159.41 319.621 163.632 327.305C166.385 332.341 168.522 337.77 169.872 343.212C170.397 345.415 170.764 347.592 171.039 349.743C171.485 353.336 171.485 354.503 171.485 354.503C177.372 357.9 224.595 385.32 236.906 392.428C236.906 391.366 236.972 390.356 237.05 389.386C238.492 373.833 249.663 367.499 263.232 375.341C264.071 375.826 264.91 376.364 265.723 376.941C271.99 381.281 277.627 388.022 281.836 395.707C284.287 400.165 286.241 404.899 287.604 409.804C288.81 414.158 288.417 419.849 291.747 422.996C298.669 429.527 306.09 429.999 311.531 430.287C334.789 431.533 361.075 421.619 382.406 408.112C408.692 391.471 414.999 379.747 417.765 368.561C421.357 354.057 414.409 317.785 408.915 315.739V315.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.406 228.887C156.539 231.851 158.493 233.87 155.254 241.489C152.016 249.108 147.69 256.321 143.376 260.635C140.19 263.822 137.778 262.353 134.396 259.337L153.406 228.887Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.437 217.766C142.432 227.353 135.969 240.82 130.331 255.508C134.671 260.806 138.328 262.314 143.691 256.465C149.42 250.21 154.546 239.312 155.202 234.329C156.08 227.602 144.871 223.904 148.437 217.766Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.001 288.226C129.256 284.017 129.518 276.188 128.876 272.175C128.522 269.946 127.46 267.533 126.595 265.815C124.694 271.349 122.937 276.962 121.403 282.522C121.403 287.322 125.139 291.715 127.001 288.213V288.226Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M408.915 315.687C409.059 325.22 397.955 344.956 380.819 356.247C360.184 369.846 321.901 379.485 294.579 367.722L292.337 374.043C298.604 379.524 299.875 388.586 301.436 396.769C303.494 407.509 308.45 415.403 320.275 417.108C326.227 417.96 333.163 417.554 338.342 416.728C342.97 415.993 346.68 414.931 350.39 413.83C369.872 408.06 388.03 398.788 403.12 385.163C407.171 381.504 411.039 377.557 413.936 372.928C415.903 369.781 417.384 367.276 418.512 363.735C420.02 347.304 413.871 317.523 408.915 315.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.611 387.707C397.981 385.924 395.818 385.242 394.271 386.343C390.823 388.809 384.753 392.966 377.542 397.018C367.237 402.827 359.03 406.276 354.206 408.073C351.177 409.201 348.883 411.718 348.057 414.839C347.152 418.249 344.504 420.924 341.121 421.868C335.313 423.495 329.951 424.583 325.402 425.029C303.416 427.166 291.878 419.114 288.378 413.882C288.889 417.265 289.387 420.728 291.734 422.931C298.657 429.461 306.077 429.933 311.518 430.222C334.776 431.468 361.062 421.554 382.393 408.047C408.679 391.405 414.986 379.682 417.752 368.482C415.34 375.577 410.108 382.462 403.212 388.848C401.718 390.225 399.292 389.609 398.611 387.694V387.707Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.823 323.738C408.024 333.613 399.161 350.359 376.663 364.732C357.575 376.928 319.122 392.717 300.059 385.163C293.805 382.685 288.85 377.085 281.849 368.246C278.033 363.434 274.127 357.755 262.353 346.189C253.845 337.836 175.365 286.207 175.038 285.971L233.864 323.568C234.205 323.791 235.66 324.591 235.66 324.591C241.665 327.24 247.591 321.43 245.769 314.742L240.708 278.693C240.629 278.444 240.551 278.194 240.485 277.958C240.328 277.473 240.17 277.027 240.013 276.581C239.764 275.939 239.502 275.323 239.227 274.772C238.414 273.093 237.457 271.795 236.395 270.72C234.389 268.661 231.937 267.376 229.027 265.71C220.007 260.543 182.812 239.391 182.13 238.998C161.232 226.828 152.986 221.333 152.566 215.117V215.065C152.566 214.986 152.566 214.908 152.566 214.855C152.999 209.977 155.91 204.063 186.483 185.598C203.763 175.173 218.827 170.085 232.553 170.085C246.28 170.085 256.847 173.967 274.415 181.455C292.101 188.995 326.699 207.813 337.017 219.497C337.017 219.497 356.578 251.692 368.404 266.143C368.404 266.143 394.861 290.403 402.425 300.711C409.125 309.838 409.492 315.228 408.81 323.725L408.823 323.738Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M408.823 323.738C408.024 333.613 399.161 350.359 376.663 364.732C357.575 376.928 319.122 392.717 300.059 385.163C293.805 382.685 288.85 377.085 281.849 368.246C278.033 363.434 274.127 357.755 262.353 346.189C253.845 337.836 175.365 286.207 175.038 285.971L233.864 323.568C234.205 323.791 235.66 324.591 235.66 324.591C241.665 327.24 247.591 321.43 245.769 314.742L240.708 278.693C240.629 278.444 240.551 278.194 240.485 277.958C240.328 277.473 240.17 277.027 240.013 276.581C239.764 275.939 239.502 275.323 239.227 274.772C238.414 273.093 237.457 271.795 236.395 270.72C234.389 268.661 231.937 267.376 229.027 265.71C220.007 260.543 182.812 239.391 182.13 238.998C161.232 226.828 152.986 221.333 152.566 215.117V215.065C152.566 214.986 152.566 214.908 152.566 214.855C152.999 209.977 155.91 204.063 186.483 185.598C203.763 175.173 218.827 170.085 232.553 170.085C246.28 170.085 256.847 173.967 274.415 181.455C292.101 188.995 326.699 207.813 337.017 219.497C337.017 219.497 356.578 251.692 368.404 266.143C368.404 266.143 394.861 290.403 402.425 300.711C409.125 309.838 409.492 315.228 408.81 323.725L408.823 323.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M276.657 205.335C283.619 208.928 290.646 212.534 297.791 216.022C290.948 212.023 284.065 208.193 277.221 204.404C270.417 200.627 266.654 198.634 259.797 195.093L249.558 189.847C246.136 188.156 242.754 186.425 239.345 184.772C242.596 186.7 245.913 188.549 249.217 190.437L259.247 196.024C265.998 199.761 269.735 201.768 276.67 205.335H276.657ZM183.612 217.727C186.706 219.642 189.866 221.504 192.999 223.392L202.544 228.979C208.955 232.716 212.521 234.722 219.102 238.303C225.723 241.909 232.396 245.515 239.188 249.016C232.685 245.03 226.143 241.188 219.64 237.398C213.163 233.621 209.597 231.615 203.068 228.074L193.34 222.815C190.089 221.11 186.877 219.379 183.625 217.727H183.612ZM259.089 215.406C265.946 219.012 272.868 222.605 279.895 226.107C273.157 222.12 266.379 218.278 259.64 214.488C252.927 210.711 249.243 208.718 242.478 205.164L232.396 199.906C229.027 198.214 225.697 196.47 222.327 194.831C225.54 196.758 228.804 198.607 232.042 200.496L241.928 206.082C248.575 209.82 252.259 211.826 259.089 215.406ZM236.067 228.598C242.793 232.205 249.558 235.811 256.454 239.299C249.859 235.313 243.212 231.47 236.605 227.68C230.036 223.904 226.418 221.897 219.784 218.357L209.912 213.098C206.608 211.393 203.344 209.662 200.053 208.01C203.199 209.938 206.398 211.787 209.584 213.675L219.273 219.261C225.789 222.999 229.394 225.005 236.08 228.585L236.067 228.598Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.635 394.789L340.754 404.086C342.026 405.752 344.163 406.473 346.195 405.948C353.602 404.034 365.258 398.355 376.808 391.681C387.205 385.661 395.058 379.563 398.257 376.246C401.206 373.19 401.888 370.581 402.046 367.643L402.688 355.08C402.714 354.582 402.098 354.346 401.783 354.726C396.762 360.758 387.323 369.073 375.51 375.905C361.049 384.258 345.657 391.772 333.924 393.936C333.53 394.015 333.373 394.487 333.648 394.775L333.635 394.789Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.66 370.79C389.735 384.639 353.865 401.07 344.189 403.417C343.927 403.483 343.77 403.732 343.835 403.994C343.888 404.217 344.084 404.362 344.294 404.362C344.334 404.362 344.373 404.362 344.412 404.348C354.18 401.988 390.391 385.373 400.433 371.354C400.591 371.144 400.538 370.843 400.328 370.686C400.119 370.528 399.817 370.581 399.66 370.79ZM400.092 366.424C389.407 381.491 352.226 398.198 341.751 400.598C341.489 400.65 341.331 400.913 341.397 401.175C341.449 401.398 341.646 401.542 341.856 401.542C341.895 401.542 341.921 401.542 341.961 401.542C352.528 399.116 390.063 382.239 400.866 366.987C401.023 366.778 400.971 366.476 400.748 366.319C400.538 366.174 400.237 366.214 400.079 366.437L400.092 366.424ZM400.512 362.07C389.198 378.187 351.99 395.011 339.312 397.805C339.05 397.857 338.893 398.119 338.945 398.369C338.998 398.591 339.194 398.749 339.417 398.749C339.456 398.749 339.483 398.749 339.522 398.749C352.305 395.929 389.853 378.934 401.298 362.634C401.456 362.424 401.403 362.122 401.18 361.965C400.971 361.807 400.669 361.86 400.512 362.083V362.07ZM401.613 357.585C401.403 357.441 401.102 357.48 400.945 357.703C388.883 375 350.522 392.1 336.874 394.998C336.612 395.051 336.454 395.313 336.507 395.562C336.559 395.785 336.756 395.943 336.979 395.943C337.018 395.943 337.044 395.943 337.083 395.943C350.849 393.018 389.552 375.747 401.744 358.267C401.902 358.044 401.836 357.755 401.626 357.598L401.613 357.585Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.381 349.992C417.961 344.891 417.201 339.593 416.231 334.715C414.277 336.603 412.639 338.924 411.406 341.481C409.807 344.799 408.837 348.471 408.587 351.92C408.522 352.851 408.496 353.795 408.797 354.674C410.515 359.775 416.401 352.93 418.381 349.992Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.599 409.764C317.535 410.433 327.237 411.168 328.024 406.853C328.955 401.791 322.675 398.211 318.755 396.861C314.572 395.418 309.394 395.09 305.552 397.621C303.022 399.3 305.88 403.942 307.217 405.463C309.118 407.627 311.793 409.122 314.599 409.764Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.045 347.75C256.677 350.045 259.876 352.077 261.134 352.877C261.488 353.1 261.711 353.48 261.724 353.9L261.908 357.9C261.934 358.529 261.239 358.936 260.702 358.608L252.639 353.572C252.285 353.349 252.049 352.956 252.036 352.536L251.839 348.445C251.813 347.802 252.508 347.396 253.045 347.737V347.75Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.485 354.477V359.945L236.907 397.87V392.402L171.485 354.477Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.701 297.996C152.016 300.75 158.322 305.891 163.396 311.779C168.601 317.824 172.534 324.879 175.209 332.38C176.716 336.603 178.198 341.193 178.289 345.704C178.289 346.11 177.608 346.491 177.437 345.992C176.782 344.025 176.349 341.993 175.825 339.973C175.313 338.019 174.723 336.092 174.081 334.177C172.77 330.335 171.131 326.597 169.165 323.03C165.494 316.368 160.617 310.415 154.743 305.563C151.544 302.927 148.017 300.671 144.438 298.599C144.176 298.442 144.399 297.878 144.687 297.996H144.701Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.383 384.061C230.797 382.553 228.489 381.662 226.562 380.626C224.7 379.629 222.839 378.619 220.99 377.596C217.188 375.511 213.399 373.387 209.623 371.236C202.19 366.987 194.835 362.594 187.532 358.109C185.618 356.942 183.468 355.867 181.751 354.411C180.046 352.956 179.653 350.713 178.893 348.72C178.775 348.392 178.158 348.222 178.158 348.707C178.119 350.595 178.447 352.418 179.496 354.031C180.544 355.644 182.406 356.588 183.993 357.585C187.768 359.972 191.57 362.306 195.399 364.601C203.042 369.191 210.764 373.636 218.565 377.937C220.715 379.118 222.865 380.298 225.015 381.465C227.257 382.671 229.538 384.14 231.99 384.848C232.475 384.993 232.698 384.376 232.37 384.061H232.383Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.537 336.787C175.537 336.787 175.55 336.787 175.563 336.787C175.851 336.773 176.074 336.524 176.061 336.236C176.048 335.882 175.34 316.801 176.362 291.793C176.362 291.505 176.153 291.256 175.851 291.243C175.851 291.243 175.838 291.243 175.825 291.243C175.55 291.243 175.314 291.466 175.301 291.754C174.278 316.814 174.973 335.947 174.999 336.301C175.012 336.577 175.248 336.8 175.523 336.8L175.537 336.787Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.326 344.117C248.273 343.697 247.513 343.278 247.382 343.868C246.753 346.74 246.753 349.756 246.569 352.694C246.372 355.736 246.15 358.765 245.9 361.794C245.835 362.542 245.769 363.276 245.717 364.024C245.664 364.653 245.678 365.401 245.363 365.965C244.838 366.909 243.396 367.407 242.544 367.997C240.669 369.295 239.044 370.908 237.72 372.757C236.985 373.78 236.356 374.856 235.858 376.01C235.347 377.19 234.809 378.58 235.019 379.891C235.045 380.075 235.373 380.56 235.583 380.272C236.264 379.341 236.592 378.121 237.077 377.059C237.588 375.97 238.165 374.908 238.834 373.898C240.132 371.971 241.81 370.279 243.737 368.981C244.602 368.404 245.651 367.971 246.372 367.197C247.251 366.266 247.251 364.981 247.343 363.775C247.592 360.798 247.828 357.821 248.024 354.844C248.26 351.317 248.732 347.632 248.3 344.117H248.326Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.708 278.693L251.21 334.636L246.254 334.033C252.206 337.364 258.408 341.075 271.164 337.6C291.564 332.039 316.513 321.352 335.969 309.208C355.491 297.039 361.705 289.105 365.926 283.388C368.588 279.781 371.249 272.359 368.417 266.13C363.776 255.901 351.426 238.027 337.044 219.484C344.465 229.044 318.939 243.155 299.876 254.157C280.84 265.159 257.647 278.549 245.586 278.903C243.921 278.955 242.321 278.876 240.722 278.68L240.708 278.693Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.228 324.722L254.029 327.41C254.029 327.41 254.016 327.41 254.002 327.423C259.365 330.426 264.294 333.39 275.792 330.256C294.238 325.233 316.788 315.569 334.37 304.592C352.016 293.59 357.627 286.417 361.456 281.263C363.868 278.011 366.267 271.297 363.711 265.658C363.527 265.238 363.304 264.792 363.081 264.346C361.849 264.779 360.63 265.225 359.411 265.684C322.4 279.532 287.723 299.583 257.228 324.722Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M368.404 266.156C363.763 255.927 351.413 238.053 337.031 219.511C344.451 229.07 318.925 243.181 299.863 254.183C298.958 254.708 298.04 255.232 297.123 255.77C305.736 253.855 314.297 251.443 322.4 254.354C327.565 256.216 331.76 260.058 335.458 264.11C340.308 269.421 344.674 275.506 346.129 282.548C347.808 290.679 345.303 299.111 340.741 306.153C356.539 295.701 362.059 288.62 365.913 283.414C368.575 279.807 371.236 272.385 368.404 266.156Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.21 334.649L153.773 272.359L152.462 271.533C152.147 271.297 151.833 271.061 151.544 270.811C151.243 270.575 150.967 270.339 150.692 270.103C150.443 269.893 150.194 269.684 149.958 269.474C149.669 269.225 149.394 268.962 149.132 268.713C152.003 261.291 159.555 245.082 166.005 238.866C166.215 238.945 166.425 239.05 166.647 239.155C166.792 239.207 166.91 239.286 167.054 239.352C167.303 239.483 167.552 239.614 167.801 239.771C167.88 239.811 167.958 239.85 168.037 239.916C181.869 248.23 196.854 257.055 210.685 265.055C226.47 274.169 230.718 277.473 240.735 278.693L251.236 334.649H251.21Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.781 327.082L240.708 278.706C232.501 277.696 228.149 275.283 218.132 269.421C215.943 268.136 213.491 266.694 210.659 265.068C209.991 264.687 209.309 264.281 208.64 263.901C195.674 256.399 181.843 248.243 168.942 240.493C168.64 240.309 168.326 240.125 168.011 239.942C167.932 239.889 167.854 239.85 167.775 239.798C167.526 239.64 167.277 239.509 167.028 239.378C166.883 239.312 166.765 239.234 166.621 239.181C166.398 239.076 166.189 238.971 165.979 238.893C163.947 240.847 161.81 243.797 159.738 247.154C192.882 269.972 223.193 296.882 249.768 327.096L249.781 327.082Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.572 278.929C246.765 278.89 248.103 278.693 249.492 278.417C245.874 281.447 246.267 286.915 247.932 293.459C250.699 304.396 256.389 325.181 258.617 332.328C260.833 339.436 267.926 337.954 271.138 337.613C256.087 342.058 249.61 335.987 246.228 334.046C248.68 334.347 250.725 332.171 250.266 329.731L240.695 278.693C242.295 278.89 243.907 278.968 245.559 278.916L245.572 278.929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.139 286.666L185.631 292.738L187.939 251.77C185.697 250.446 183.455 249.121 181.213 247.797L176.126 286.666H176.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.421 259.481C153.93 265.264 153.484 269.487 153.76 272.359L152.449 271.533C152.134 271.297 151.819 271.061 151.531 270.811C151.229 270.575 150.954 270.339 150.679 270.103C150.43 269.893 150.181 269.684 149.945 269.474C149.656 269.225 149.381 268.962 149.119 268.713C151.99 261.291 159.541 245.082 165.992 238.866C166.202 238.945 166.411 239.05 166.634 239.155C166.778 239.207 166.896 239.286 167.041 239.352C167.29 239.483 167.539 239.614 167.788 239.771C167.867 239.811 167.945 239.85 168.024 239.916C165.048 243.325 160.708 249.58 156.434 259.481H156.421Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.131 348.445C375.117 349.782 375.497 357.349 373.006 360.05C372.849 360.181 372.744 360.221 372.56 360.286C370.581 360.876 368.43 360.247 366.477 359.539C364.51 358.778 362.557 357.769 361.18 356.182C361.01 355.959 360.957 355.683 361.01 355.342C361.967 352.195 367.814 348.248 371.144 348.445C370.279 348.196 369.335 348.34 368.47 348.563C365.835 349.284 363.462 350.713 361.482 352.654C360.853 353.323 360.21 354.07 359.961 355.146C359.463 358.385 366.123 360.955 368.693 361.453C370.292 361.755 372.259 361.952 373.675 360.929C376.651 358.031 375.733 349.35 371.144 348.458L371.131 348.445Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.849 365.847C277.627 370.594 278.61 377.57 285.965 383.471C294.526 390.343 311.124 392.035 321.613 389.858C332.101 387.668 318.374 379.8 310.678 375.997C301.881 371.643 286.227 360.916 281.849 365.847Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M281.849 365.847C277.627 370.594 278.61 377.57 285.965 383.471C294.526 390.343 311.124 392.035 321.613 389.858C332.101 387.668 318.374 379.8 310.678 375.997C301.881 371.643 286.227 360.916 281.849 365.847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.287 377.675C284.51 378.069 284.759 378.462 285.034 378.829C286.568 380.967 288.928 383.222 291.472 384.101C293.661 384.861 296.453 384.901 297.712 382.567C299.076 380.023 296.768 376.888 295.352 374.829C294.12 373.033 292.848 371.236 291.144 369.886C289.269 368.404 286.057 366.804 284.077 368.955C283.395 369.702 283.041 370.712 282.91 371.708C282.635 373.767 283.264 375.852 284.313 377.662L284.287 377.675Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.206 375.446C302.589 375.302 301.934 375.249 301.344 375.472C300.754 375.695 300.269 376.259 300.282 376.888C300.282 377.623 300.924 378.187 301.528 378.606C303.586 380.062 305.92 381.111 308.371 381.675C308.699 381.753 309.027 381.819 309.354 381.74C309.682 381.662 309.984 381.413 310.023 381.085C310.049 380.809 309.892 380.56 309.735 380.337C308.253 378.2 305.788 376.062 303.193 375.433L303.206 375.446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.305 384.796C301.344 385.425 301.882 386.055 302.419 386.488C303.035 386.973 303.783 387.261 304.53 387.484C305.198 387.681 306.588 387.76 307.204 387.366C307.755 386.999 307.86 386.186 307.585 385.583C306.968 384.206 305.212 383.301 303.756 383.209C302.996 383.157 302.209 383.34 301.672 383.917C301.41 384.206 301.305 384.507 301.318 384.809L301.305 384.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.891 336.013C403.58 333.888 404.733 325.705 404.117 311.962C403.907 307.386 403.147 303.176 402.347 300.711C403.186 300.068 405.821 300.121 408.221 303.019C413.661 309.576 414.592 321.221 412.927 327.633C411.262 334.046 407.198 339.75 404.891 336.026V336.013Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M404.891 336.013C403.58 333.888 404.733 325.705 404.117 311.962C403.907 307.386 403.147 303.176 402.347 300.711C403.186 300.068 405.821 300.121 408.221 303.019C413.661 309.576 414.592 321.221 412.927 327.633C411.262 334.046 407.198 339.75 404.891 336.026V336.013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.129 314.441C408.824 315.542 409.571 316.618 410.436 317.588C410.712 317.903 411.328 318.821 411.76 318.886C412.285 318.965 412.416 318.204 412.39 317.811C412.232 315.503 412.167 313.182 411.459 310.953C410.817 308.907 409.781 306.992 408.404 305.34C407.67 304.461 406.765 303.622 405.638 303.465C405.402 303.425 405.14 303.438 404.956 303.596C404.746 303.766 404.707 304.081 404.707 304.356C404.602 307.91 406.189 311.359 408.129 314.441Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.608 318.322C406.503 318.821 406.464 319.358 406.438 319.608C406.176 321.902 406.097 324.224 406.176 326.545C406.176 326.755 406.189 326.964 406.294 327.148C406.621 327.738 407.067 327.148 407.277 326.807C408.063 325.548 408.68 324.171 408.942 322.716C409.191 321.26 409.06 319.712 408.417 318.375C408.247 318.021 407.709 316.998 407.185 317.208C406.884 317.326 406.713 317.811 406.608 318.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.8 325.115C412.049 324.906 412.18 324.565 412.338 324.289C412.469 324.066 412.521 323.804 412.534 323.542C412.6 322.82 412.39 321.47 411.472 321.352C410.437 321.221 410.03 323.594 410.004 324.289C410.004 324.591 410.004 324.906 410.201 325.142C410.555 325.601 411.407 325.43 411.8 325.102V325.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.419 339.475C292.6 341.494 307.244 355.657 320.328 368.561C325.428 373.059 330.803 378.239 337.791 379.026C344.714 379.472 351.531 377.164 357.863 374.462C370.489 368.64 383.049 361.794 392.698 351.618C408.575 336.931 392.58 316.001 382.891 302.481C377.739 294.98 370.79 287.112 371.105 277.473C371.039 287.125 378.171 294.652 383.455 302.061C393.734 315.673 409.912 337.272 393.563 352.418C383.796 362.791 371.223 369.781 358.375 375.59C351.872 378.331 344.871 380.665 337.686 380.167C330.41 379.354 324.786 373.938 319.673 369.256C306.746 356.234 292.482 341.914 273.432 339.449L273.419 339.475Z",
    fill: "#481A6C"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M518.256 409.725L518.807 410.84L523.92 413.803C523.788 413.476 523.631 413.174 523.474 412.872C523.395 412.728 523.317 412.584 523.225 412.453C523.146 412.308 523.054 412.19 522.963 412.059C522.635 411.613 522.268 411.233 521.887 410.918C521.809 410.866 521.73 410.8 521.638 410.735C521.52 410.656 521.402 410.577 521.284 410.499C521.061 410.368 520.839 410.25 520.603 410.145C520.485 410.092 520.354 410.053 520.236 410C520.209 410 520.183 409.974 520.144 409.974C519.921 409.896 519.685 409.843 519.449 409.804C519.069 409.738 518.675 409.712 518.282 409.725H518.256Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M518.256 409.725L518.807 410.84L523.92 413.803C523.788 413.476 523.631 413.174 523.474 412.872C523.395 412.728 523.317 412.584 523.225 412.453C523.146 412.308 523.054 412.19 522.963 412.059C522.635 411.613 522.268 411.233 521.887 410.918C521.809 410.866 521.73 410.8 521.638 410.735C521.52 410.656 521.402 410.577 521.284 410.499C521.061 410.368 520.839 410.25 520.603 410.145C520.485 410.092 520.354 410.053 520.236 410C520.209 410 520.183 409.974 520.144 409.974C519.921 409.896 519.685 409.843 519.449 409.804C519.069 409.738 518.675 409.712 518.282 409.725H518.256Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.783 429.369C499.783 421.895 504.333 413.2 509.944 409.961C510.232 409.791 510.521 409.659 510.809 409.515C510.835 409.515 510.862 409.489 510.888 409.476C511.084 409.384 511.268 409.318 511.465 409.253C511.609 409.2 511.753 409.135 511.897 409.096C512.042 409.056 512.186 409.017 512.317 408.978C512.513 408.925 512.71 408.886 512.894 408.846C512.999 408.833 513.103 408.82 513.195 408.807C513.418 408.781 513.641 408.768 513.851 408.755C513.89 408.755 513.943 408.755 513.982 408.755C514.074 408.755 514.336 408.755 514.388 408.755C518.426 408.886 521.966 411.05 524.011 414.249C524.929 415.43 525.558 417.095 525.794 419.141C525.86 419.652 525.912 420.177 525.912 420.714C525.912 420.754 525.912 420.806 525.912 420.845C525.912 420.898 525.912 420.937 525.912 420.99C525.912 428.465 521.363 437.159 515.752 440.398C515.463 440.568 515.175 440.7 514.886 440.844C514.86 440.844 514.834 440.87 514.808 440.883C514.611 440.975 514.428 441.041 514.231 441.106C514.087 441.159 513.942 441.224 513.798 441.264C513.654 441.303 513.51 441.342 513.379 441.382C513.182 441.434 512.985 441.473 512.802 441.513C512.697 441.526 512.592 441.539 512.5 441.552C512.277 441.578 511.53 441.604 511.438 441.604C511.399 441.604 511.347 441.604 511.307 441.604C507.269 441.473 503.729 439.31 501.684 436.11C500.767 434.93 500.137 433.264 499.901 431.218C499.836 430.707 499.783 430.182 499.783 429.645C499.783 429.605 499.783 429.553 499.783 429.514C499.783 429.461 499.783 429.422 499.783 429.369Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.617 432.74C505.617 440.214 510.167 443.663 515.778 440.424C521.389 437.185 525.938 428.491 525.938 421.016C525.938 413.541 521.389 410.092 515.778 413.331C510.167 416.57 505.617 425.265 505.617 432.74Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.757 437.447C509.026 436.451 508.03 434.156 508.03 431.166C508.03 425.593 511.439 419.101 515.621 416.688C517.509 415.6 519.344 415.456 520.786 416.295C522.517 417.292 523.513 419.587 523.513 422.577C523.513 428.15 520.105 434.641 515.922 437.054C514.847 437.67 513.798 437.985 512.815 437.985C512.068 437.985 511.373 437.802 510.757 437.447ZM515.922 417.213C511.91 419.534 508.633 425.789 508.633 431.166C508.633 433.933 509.511 436.031 511.058 436.923C512.304 437.644 513.93 437.513 515.621 436.53C519.633 434.208 522.91 427.953 522.91 422.577C522.91 419.81 522.032 417.711 520.485 416.82C519.96 416.518 519.357 416.361 518.728 416.361C517.85 416.361 516.906 416.649 515.922 417.213Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.212 430.379C512.317 430.786 512.12 431.389 511.779 431.717L510.992 432.49C511.556 433.841 512.605 434.589 513.968 434.471L514.152 433.304C514.231 432.792 514.585 432.294 514.939 432.189C515.293 432.097 515.516 432.438 515.437 432.949L515.253 434.117C516.695 433.487 518.085 432.071 519.134 430.287L518.544 429.881C518.36 429.763 518.295 429.474 518.347 429.146C518.374 428.989 518.426 428.819 518.505 428.661C518.754 428.163 519.173 427.901 519.436 428.084L520.039 428.491C520.432 427.52 520.733 426.511 520.891 425.475C521.048 424.439 521.061 423.494 520.956 422.668L520.17 423.442C520.052 423.56 519.934 423.626 519.829 423.652C519.606 423.717 519.422 423.599 519.344 423.337C519.239 422.931 519.436 422.327 519.776 421.999L520.563 421.226C519.999 419.875 518.95 419.128 517.587 419.246L517.403 420.413C517.325 420.924 516.971 421.422 516.617 421.527C516.263 421.619 516.04 421.278 516.132 420.767L516.315 419.6C514.873 420.229 513.483 421.645 512.435 423.429L513.025 423.835C513.208 423.953 513.261 424.242 513.221 424.57C513.195 424.727 513.143 424.898 513.064 425.055C512.815 425.553 512.395 425.816 512.133 425.632L511.53 425.225C511.137 426.183 510.835 427.206 510.678 428.242C510.52 429.278 510.507 430.209 510.612 431.035L511.399 430.261C511.517 430.143 511.635 430.078 511.74 430.051C511.963 429.986 512.146 430.104 512.225 430.366L512.212 430.379Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.055 462.285L517.128 429.907C518.243 429.264 519.147 427.533 519.147 426.039C519.147 424.544 518.243 423.862 517.128 424.504L508.58 429.448L507.007 429.579L457.004 457.747L461.055 462.298V462.285Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.124 432.372L517.155 428.884C517.863 428.478 518.427 427.389 518.427 426.445C518.427 425.501 517.85 425.068 517.155 425.475L511.124 428.963C510.416 429.369 509.853 430.458 509.853 431.402C509.853 432.346 510.429 432.779 511.124 432.372Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.19 431.205L517.102 427.783C517.338 427.651 517.535 427.284 517.535 426.97C517.535 426.655 517.338 426.511 517.102 426.642L511.19 430.064C510.954 430.196 510.757 430.563 510.757 430.877C510.757 431.192 510.954 431.336 511.19 431.205Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.055 462.285L452.573 457.393L448.535 452.843L457.004 457.734L461.055 462.285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.576 447.702L494.815 422.734L505.985 429.186V430.93L462.746 455.898C458.853 458.141 453.202 458.521 450.121 456.738C448.81 455.977 448.181 454.941 448.181 453.84C448.181 453.564 448.181 452.41 448.181 452.109C448.181 450.614 449.348 448.988 451.589 447.702H451.576Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.576 446.942L494.815 421.973L505.985 428.425V430.169L462.746 455.138C458.853 457.38 453.202 457.761 450.121 455.977C448.81 455.217 448.181 454.181 448.181 453.079C448.181 452.804 448.181 451.65 448.181 451.348C448.181 449.853 449.348 448.227 451.589 446.942H451.576Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M451.576 446.942L494.815 421.973L505.985 428.425V430.169L462.746 455.138C458.853 457.38 453.202 457.761 450.121 455.977C448.81 455.217 448.181 454.181 448.181 453.079C448.181 452.804 448.181 451.65 448.181 451.348C448.181 449.853 449.348 448.227 451.589 446.942H451.576Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.121 454.233C453.202 456.016 458.866 455.636 462.746 453.394L505.985 428.425L504.044 427.297L502.93 426.655L497.83 423.704L494.841 421.973L451.603 446.942C447.709 449.184 447.053 452.45 450.134 454.233H450.121Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M450.121 454.233C453.202 456.016 458.866 455.636 462.746 453.394L505.985 428.425L504.044 427.297L502.93 426.655L497.83 423.704L494.841 421.973L451.603 446.942C447.709 449.184 447.053 452.45 450.134 454.233H450.121Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.916 426.655L504.031 427.297C505.25 420.596 509.354 413.79 514.244 410.971C515.66 410.145 517.01 409.738 518.256 409.712C518.649 409.699 519.042 409.712 519.423 409.791C519.658 409.83 519.894 409.882 520.117 409.961C520.144 409.961 520.17 409.987 520.209 409.987C520.327 410.027 520.458 410.066 520.576 410.132C520.812 410.223 521.035 410.355 521.258 410.486C521.376 410.564 521.507 410.63 521.612 410.722C521.704 410.774 521.782 410.84 521.861 410.905C522.254 411.233 522.621 411.6 522.936 412.046C523.028 412.164 523.12 412.295 523.198 412.44C523.29 412.584 523.382 412.715 523.447 412.859C523.605 413.148 523.762 413.462 523.893 413.79C524.378 414.249 524.968 414.407 525.702 414.171C525.073 411.509 523.762 409.581 522.031 408.571C519.947 407.365 517.207 407.483 514.231 409.201C508.96 412.256 504.477 419.416 502.903 426.668L502.916 426.655Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M502.916 426.655L504.031 427.297C505.25 420.596 509.354 413.79 514.244 410.971C515.66 410.145 517.01 409.738 518.256 409.712C518.649 409.699 519.042 409.712 519.423 409.791C519.658 409.83 519.894 409.882 520.117 409.961C520.144 409.961 520.17 409.987 520.209 409.987C520.327 410.027 520.458 410.066 520.576 410.132C520.812 410.223 521.035 410.355 521.258 410.486C521.376 410.564 521.507 410.63 521.612 410.722C521.704 410.774 521.782 410.84 521.861 410.905C522.254 411.233 522.621 411.6 522.936 412.046C523.028 412.164 523.12 412.295 523.198 412.44C523.29 412.584 523.382 412.715 523.447 412.859C523.605 413.148 523.762 413.462 523.893 413.79C524.378 414.249 524.968 414.407 525.702 414.171C525.073 411.509 523.762 409.581 522.031 408.571C519.947 407.365 517.207 407.483 514.231 409.201C508.96 412.256 504.477 419.416 502.903 426.668L502.916 426.655Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.917 426.655C504.49 419.403 508.961 412.243 514.244 409.187C517.233 407.469 519.96 407.351 522.045 408.558L516.919 405.594C514.834 404.388 512.107 404.506 509.118 406.224C503.834 409.279 499.351 416.439 497.79 423.691C497.096 426.852 499.626 428.543 502.89 426.655H502.917Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M502.917 426.655C504.49 419.403 508.961 412.243 514.244 409.187C517.233 407.469 519.96 407.351 522.045 408.558L516.919 405.594C514.834 404.388 512.107 404.506 509.118 406.224C503.834 409.279 499.351 416.439 497.79 423.691C497.096 426.852 499.626 428.543 502.89 426.655H502.917Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M437.955 448.555C438.02 448.712 438.164 448.791 438.322 448.791C438.374 448.791 438.427 448.791 438.492 448.751C438.702 448.66 438.794 448.424 438.702 448.214C436.211 442.601 437.102 438.89 438.767 437.277C439.921 436.175 441.494 435.939 442.976 436.674C443.173 436.779 443.422 436.687 443.513 436.49C443.618 436.293 443.527 436.044 443.33 435.952C441.547 435.074 439.58 435.362 438.204 436.7C436.342 438.497 435.306 442.549 437.955 448.542V448.555ZM435.7 450.587C435.765 450.745 435.909 450.837 436.08 450.837C436.132 450.837 436.185 450.837 436.237 450.797C436.447 450.705 436.539 450.469 436.447 450.26C434.074 444.739 434.952 440.044 436.408 437.697C437.181 436.464 438.44 435.546 439.803 435.244C441.036 434.969 442.268 435.205 443.382 435.913C443.566 436.031 443.828 435.979 443.946 435.795C444.064 435.612 444.012 435.349 443.828 435.231C442.53 434.392 441.088 434.13 439.633 434.444C438.073 434.798 436.604 435.848 435.726 437.264C434.153 439.782 433.209 444.765 435.7 450.574V450.587Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.876 471.464C426.876 463.99 431.426 455.295 437.037 452.056C437.325 451.886 437.614 451.755 437.902 451.61C437.929 451.61 437.955 451.584 437.981 451.571C438.178 451.479 438.361 451.414 438.558 451.348C438.702 451.296 438.846 451.23 438.991 451.191C439.135 451.151 439.279 451.112 439.41 451.073C439.607 451.02 439.803 450.981 439.987 450.941C440.092 450.928 440.197 450.915 440.288 450.902C440.511 450.876 440.734 450.863 440.944 450.85C440.983 450.85 441.036 450.85 441.075 450.85C441.167 450.85 441.429 450.85 441.481 450.85C445.52 450.981 449.059 453.145 451.105 456.344C452.022 457.525 452.652 459.19 452.888 461.236C452.953 461.747 453.006 462.272 453.006 462.809C453.006 462.849 453.006 462.901 453.006 462.941C453.006 462.993 453.006 463.032 453.006 463.085C453.006 470.56 448.456 479.254 442.845 482.493C442.557 482.664 442.268 482.795 441.98 482.926C441.953 482.926 441.927 482.952 441.901 482.965C441.704 483.057 441.521 483.123 441.324 483.188C441.18 483.241 441.036 483.306 440.892 483.345C440.747 483.385 440.603 483.424 440.472 483.464C440.275 483.516 440.079 483.555 439.895 483.595C439.79 483.608 439.685 483.621 439.594 483.634C439.371 483.66 438.623 483.686 438.532 483.686C438.492 483.686 438.44 483.686 438.401 483.686C434.363 483.555 430.823 481.392 428.777 478.192C427.86 477.012 427.23 475.346 426.994 473.3C426.929 472.789 426.876 472.264 426.876 471.727C426.876 471.687 426.876 471.635 426.876 471.596C426.876 471.543 426.876 471.504 426.876 471.451V471.464Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.71 474.848C432.71 482.323 437.26 485.772 442.871 482.532C448.482 479.293 453.032 470.599 453.032 463.124C453.032 455.649 448.482 452.2 442.871 455.439C437.26 458.679 432.71 467.373 432.71 474.848Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.85 479.556C436.119 478.559 435.123 476.264 435.123 473.274C435.123 467.714 438.532 461.21 442.714 458.797C444.602 457.708 446.437 457.564 447.879 458.403C449.61 459.4 450.606 461.695 450.606 464.685C450.606 470.245 447.198 476.749 443.016 479.162C441.94 479.779 440.892 480.093 439.908 480.093C439.161 480.093 438.466 479.91 437.85 479.556ZM443.016 459.321C439.004 461.642 435.726 467.898 435.726 473.274C435.726 476.041 436.605 478.139 438.152 479.031C439.397 479.752 441.023 479.621 442.714 478.638C446.726 476.317 450.003 470.061 450.003 464.685C450.003 461.918 449.125 459.819 447.578 458.928C447.054 458.626 446.45 458.469 445.821 458.469C444.943 458.469 443.999 458.757 443.016 459.321Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.305 472.487C439.41 472.894 439.213 473.497 438.872 473.825L438.086 474.599C438.649 475.949 439.698 476.697 441.062 476.579L441.245 475.412C441.324 474.9 441.678 474.402 442.032 474.297C442.386 474.205 442.609 474.546 442.53 475.058L442.347 476.225C443.789 475.595 445.178 474.179 446.227 472.396L445.637 471.989C445.454 471.871 445.401 471.582 445.441 471.255C445.467 471.097 445.519 470.927 445.598 470.769C445.847 470.271 446.267 470.009 446.529 470.192L447.132 470.599C447.525 469.629 447.827 468.619 447.984 467.583C448.141 466.547 448.155 465.603 448.05 464.776L447.263 465.55C447.145 465.668 447.027 465.734 446.922 465.76C446.699 465.826 446.516 465.708 446.437 465.445C446.332 465.039 446.529 464.436 446.87 464.108L447.656 463.334C447.093 461.983 446.044 461.236 444.68 461.354L444.497 462.521C444.418 463.032 444.064 463.531 443.71 463.636C443.356 463.727 443.133 463.386 443.225 462.875L443.409 461.708C441.966 462.337 440.577 463.754 439.528 465.537L440.118 465.944C440.301 466.062 440.367 466.35 440.314 466.678C440.288 466.835 440.236 467.006 440.157 467.163C439.908 467.661 439.488 467.924 439.226 467.74L438.623 467.334C438.23 468.291 437.928 469.314 437.771 470.35C437.614 471.386 437.601 472.317 437.705 473.143L438.492 472.369C438.61 472.251 438.728 472.186 438.833 472.159C439.056 472.094 439.239 472.212 439.318 472.474L439.305 472.487Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.605 442.155L445.008 433.723L459.299 449.656H459.286C460.033 450.496 459.823 451.558 458.604 452.253C457.096 453.118 454.671 453.118 453.163 452.253C452.888 452.095 452.678 451.912 452.507 451.715H452.494L443.605 442.142V442.155Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.226 448.319H439.213L440.511 428.465L446.254 428.792L445.821 435.48L445.205 445.421L444.956 448.699H444.943C444.903 449.053 444.68 449.394 444.235 449.669C443.186 450.312 441.363 450.312 440.184 449.669C439.502 449.302 439.187 448.804 439.226 448.319Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M439.226 448.319H439.213L440.511 428.465L446.254 428.792L445.821 435.48L445.205 445.421L444.956 448.699H444.943C444.903 449.053 444.68 449.394 444.235 449.669C443.186 450.312 441.363 450.312 440.184 449.669C439.502 449.302 439.187 448.804 439.226 448.319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.532 429.868C444.484 430.51 442.661 430.51 441.481 429.868C440.288 429.225 440.183 428.176 441.232 427.52C442.281 426.878 444.103 426.878 445.283 427.52C446.476 428.163 446.581 429.212 445.532 429.868Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M445.532 429.868C444.484 430.51 442.661 430.51 441.481 429.868C440.288 429.225 440.183 428.176 441.232 427.52C442.281 426.878 444.103 426.878 445.283 427.52C446.476 428.163 446.581 429.212 445.532 429.868Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.205 445.368C444.995 448.135 448.233 449.997 447.748 453.892C447.263 457.787 446.057 468.37 446.057 468.37C445.729 470.533 444.628 472.199 443.186 472.566C442.071 472.802 441.088 471.871 441.258 469.55C441.258 469.55 442.753 456.79 442.989 454.797C443.225 452.817 439.279 451.4 438.086 451.663C438.086 451.663 436.224 452.227 434.021 454.404C434.257 453.079 434.389 452.476 434.743 450.679C435.516 446.666 439.41 446.063 439.567 442.916L445.205 445.381V445.368Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M445.205 445.368C444.995 448.135 448.233 449.997 447.748 453.892C447.263 457.787 446.057 468.37 446.057 468.37C445.729 470.533 444.628 472.199 443.186 472.566C442.071 472.802 441.088 471.871 441.258 469.55C441.258 469.55 442.753 456.79 442.989 454.797C443.225 452.817 439.279 451.4 438.086 451.663C438.086 451.663 436.224 452.227 434.021 454.404C434.257 453.079 434.389 452.476 434.743 450.679C435.516 446.666 439.41 446.063 439.567 442.916L445.205 445.381V445.368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.097 469.93L442.871 463.045C442.963 462.246 443.736 461.328 444.602 461C445.467 460.672 446.083 461.052 445.991 461.852L445.218 468.737C445.126 469.537 444.352 470.455 443.487 470.783C442.622 471.11 442.006 470.73 442.097 469.93Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.133 469.458L443.893 462.718C443.92 462.442 444.182 462.141 444.47 462.023C444.759 461.918 444.969 462.036 444.942 462.311L444.182 469.052C444.156 469.327 443.893 469.629 443.605 469.747C443.317 469.851 443.107 469.733 443.133 469.458Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.507 321.968L436.932 317.365L425.316 310.861C424.962 310.651 424.49 310.677 423.979 310.979C422.969 311.582 422.209 313.038 422.274 314.231C422.301 314.821 422.524 315.228 422.864 315.424L422.891 315.437L434.507 321.955V321.968Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M434.507 321.968L436.932 317.365L425.316 310.861C424.962 310.651 424.49 310.677 423.979 310.979C422.969 311.582 422.209 313.038 422.274 314.231C422.301 314.821 422.524 315.228 422.864 315.424L422.891 315.437L434.507 321.955V321.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.507 321.968L422.891 315.451H422.864V315.437C422.524 315.241 422.301 314.821 422.274 314.244C422.248 313.628 422.432 312.946 422.746 312.356L435.647 319.804L434.507 321.981V321.968Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.903 320.748C433.969 321.942 434.834 322.44 435.844 321.837C436.853 321.234 437.614 319.778 437.548 318.585C437.483 317.391 436.617 316.893 435.608 317.496C434.598 318.1 433.838 319.555 433.903 320.748Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M433.903 320.748C433.969 321.942 434.834 322.44 435.844 321.837C436.853 321.234 437.614 319.778 437.548 318.585C437.483 317.391 436.617 316.893 435.608 317.496C434.598 318.1 433.838 319.555 433.903 320.748Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.923 318.611C436.132 318.48 436.316 318.454 436.486 318.48L449.203 325.837L447.905 328.315L435.503 321.142L435.149 320.932C435.044 320.814 434.992 320.63 434.979 320.421C434.939 319.752 435.372 318.952 435.923 318.611Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.799 428.36L447.105 332.066L452.284 332.354L445.978 428.701C445.939 429.015 445.742 429.33 445.349 429.566C444.405 430.143 442.766 430.143 441.691 429.566C441.075 429.238 440.799 428.779 440.839 428.347L440.799 428.36Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.514 332.262L452.271 332.367L445.965 428.714C445.926 429.028 445.729 429.343 445.336 429.579C444.995 429.789 444.575 429.92 444.129 429.973L450.527 332.262H450.514Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.827 327.843C453.857 328.42 452.232 328.42 451.209 327.843C450.173 327.266 450.134 326.335 451.104 325.758C452.074 325.181 453.7 325.181 454.723 325.758C455.758 326.335 455.798 327.266 454.827 327.843Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.767 334.531C447.709 335.147 444.772 335.042 443.199 334.295C442.531 333.98 442.229 333.6 442.242 333.207C442.268 332.682 442.295 327.279 442.295 327.279L456.926 326.44L456.873 332.393L449.767 334.531Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.82 328.577C447.761 329.194 444.825 329.089 443.251 328.341C442.596 328.027 442.281 327.659 442.294 327.279C442.294 326.755 442.937 326.217 444.143 325.863L451.249 323.725L456.939 326.44L449.833 328.577H449.82Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.82 328.577C447.656 329.167 445.231 329.246 443.12 328.394C442.779 328.223 442.412 328.013 442.229 327.607C441.849 326.23 443.776 325.797 444.68 325.469C446.254 325.024 449.859 323.725 451.341 323.502C453.32 324.46 455.287 325.483 457.253 326.466C454.762 327.135 452.298 327.843 449.833 328.577H449.82ZM449.82 328.577C452.18 327.843 454.539 327.109 456.886 326.322V326.545C454.959 325.679 453.032 324.84 451.131 323.935H451.301C449.23 324.617 446.909 325.273 444.798 325.876C443.579 326.112 441.167 327.096 443.212 328.21C445.244 329.167 447.67 329.115 449.82 328.577Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.26 329.272L470.6 337.888L469.275 340.406L453.949 331.856C453.084 331.384 454.08 328.8 455.247 329.286L455.26 329.272Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.679 346.451L480.406 341.271L467.334 333.941C466.941 333.705 466.404 333.731 465.827 334.072C464.686 334.754 463.834 336.393 463.9 337.744C463.939 338.4 464.188 338.859 464.568 339.095L464.594 339.121L477.679 346.451Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M477.679 346.451L480.406 341.271L467.334 333.941C466.941 333.705 466.404 333.731 465.827 334.072C464.686 334.754 463.834 336.393 463.9 337.744C463.939 338.4 464.188 338.859 464.568 339.095L464.594 339.121L477.679 346.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.679 346.451L464.595 339.121H464.569V339.095C464.188 338.872 463.939 338.4 463.9 337.744C463.874 337.259 463.965 336.747 464.149 336.249L478.636 344.615L477.666 346.451H477.679Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.997 345.088C477.063 346.438 478.046 346.989 479.173 346.307C480.301 345.638 481.166 343.986 481.101 342.635C481.035 341.285 480.052 340.734 478.924 341.416C477.797 342.098 476.932 343.737 476.997 345.088Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M476.997 345.088C477.063 346.438 478.046 346.989 479.173 346.307C480.301 345.638 481.166 343.986 481.101 342.635C481.035 341.285 480.052 340.734 478.924 341.416C477.797 342.098 476.932 343.737 476.997 345.088Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.131 329.338L441.691 328.394C442.137 328.158 442.766 328.223 443.448 328.656C444.824 329.522 445.952 331.502 445.952 333.088C445.952 333.875 445.676 334.426 445.231 334.662L443.671 335.606C443.225 335.842 442.596 335.777 441.914 335.344C440.537 334.479 439.41 332.498 439.41 330.912C439.41 330.125 439.685 329.574 440.131 329.338Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.723 335.58L445.257 334.649C445.703 334.413 445.978 333.862 445.978 333.075C445.978 332.367 445.755 331.58 445.375 330.859L443.815 331.803C444.182 332.538 444.405 333.325 444.418 334.02C444.418 334.793 444.156 335.331 443.723 335.58Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.927 335.344C440.55 334.479 439.423 332.498 439.423 330.912C439.423 329.325 440.524 328.735 441.914 329.6C443.29 330.466 444.418 332.446 444.418 334.033C444.418 335.619 443.317 336.21 441.927 335.344Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.041 335.226C443.828 335.265 443.906 334.374 443.906 333.993C443.906 332.59 442.871 330.767 441.651 330.02C441.337 329.823 441.048 329.718 440.786 329.705C440 329.666 439.921 330.558 439.921 330.938C439.921 332.341 440.957 334.164 442.176 334.911C442.491 335.108 442.779 335.213 443.041 335.226Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.651 330.02C441.376 329.849 441.114 329.744 440.878 329.718C440.734 329.994 440.708 330.348 440.708 330.558C440.708 331.961 441.743 333.784 442.963 334.531C443.238 334.701 443.5 334.806 443.736 334.833C443.88 334.557 443.906 334.203 443.906 333.993C443.906 332.59 442.871 330.767 441.651 330.02Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M441.651 330.02C441.376 329.849 441.114 329.744 440.878 329.718C440.734 329.994 440.708 330.348 440.708 330.558C440.708 331.961 441.743 333.784 442.963 334.531C443.238 334.701 443.5 334.806 443.736 334.833C443.88 334.557 443.906 334.203 443.906 333.993C443.906 332.59 442.871 330.767 441.651 330.02Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.829 455.112C540.151 465.957 546.758 477.536 556.591 480.972C566.424 484.408 575.772 478.388 577.45 467.543C579.141 456.698 572.52 445.119 562.688 441.683C552.855 438.247 543.507 444.267 541.829 455.112Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.778 480.67C556.04 480.775 556.316 480.88 556.591 480.972C558.689 481.706 560.773 482.008 562.753 481.916C553.825 479.188 554.598 465.917 555.844 463.177C552.173 469.812 554.742 477.956 555.778 480.657V480.67Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.376 469.301C574.946 469.078 576.506 468.37 577.437 467.661C577.437 467.622 577.45 467.583 577.463 467.557C577.66 466.298 577.738 465.039 577.712 463.78C576.86 464.645 575.444 465.603 573.097 466.481C566.542 468.933 558.951 465.012 556.027 462.875C560.629 466.835 564.339 469.996 572.389 469.301H572.376Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.014 462.875C555.962 462.954 555.896 463.072 555.844 463.19C555.896 463.085 555.962 462.98 556.014 462.875Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.464 450.351C572.782 449.315 572.009 448.345 571.183 447.44C563.186 445.801 557.522 454.063 556.014 462.888C560.629 449.512 570.423 448.332 573.464 450.364V450.351Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.58 459.321C541.619 460.423 541.737 461.524 541.92 462.6C545.041 464.449 550.259 464.737 556.014 462.875C547.964 463.177 543.625 460.934 541.58 459.321Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.776 441.382C551.308 441.841 549.931 442.509 548.673 443.401C547.506 452.24 550.023 458.403 556.014 462.875C549.354 454.469 551.531 445.04 552.776 441.382Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.678 461.013C550.167 464.265 552.16 467.74 555.11 468.763C558.059 469.799 560.865 467.989 561.363 464.737C561.861 461.485 559.882 458.01 556.932 456.987C553.982 455.951 551.176 457.761 550.678 461.013Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.932 456.987C556.093 456.698 555.267 456.633 554.506 456.777C553.484 457.525 552.75 458.718 552.514 460.239C552.002 463.491 553.995 466.966 556.945 467.989C557.784 468.278 558.61 468.343 559.37 468.199C560.393 467.452 561.127 466.258 561.363 464.737C561.874 461.485 559.882 458.01 556.932 456.987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M565.349 479.988C560.341 480.539 552.173 478.087 548.804 469.642C545.434 461.196 548.804 456.711 551.295 455.046C553.786 453.367 554.061 450.26 553.799 446.417C553.536 442.575 558.623 440.516 562.688 441.683C552.855 438.247 543.507 444.267 541.829 455.112C540.151 465.957 546.758 477.536 556.591 480.972C564.523 483.739 572.114 480.369 575.654 473.287C573.753 476.985 570.318 479.438 565.349 479.988Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.912 465.117L574.841 466.311C574.146 466.717 573.412 467.006 572.652 467.189C570.567 467.714 568.312 467.412 566.398 466.311L565.506 465.799C564.497 465.222 563.802 464.199 563.684 463.045C563.291 459.256 560.773 455.715 557.338 454.508C555.175 453.761 553.064 454.076 551.426 455.203C550.233 456.03 548.659 456.082 547.401 455.348L543.494 453.092C542.576 452.554 542.012 451.61 541.96 450.6C541.934 450.115 542.025 449.63 542.235 449.158C545.041 443.126 550.573 439.362 557.194 439.362C559.174 439.362 561.193 439.716 563.173 440.411C571.576 443.349 577.765 451.899 578.918 461.105C579.115 462.731 578.341 464.304 576.939 465.131L576.912 465.117Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M576.912 465.117L574.841 466.311C574.146 466.717 573.412 467.006 572.652 467.189C570.567 467.714 568.312 467.412 566.398 466.311L565.506 465.799C564.497 465.222 563.802 464.199 563.684 463.045C563.291 459.256 560.773 455.715 557.338 454.508C555.175 453.761 553.064 454.076 551.426 455.203C550.233 456.03 548.659 456.082 547.401 455.348L543.494 453.092C542.576 452.554 542.012 451.61 541.96 450.6C541.934 450.115 542.025 449.63 542.235 449.158C545.041 443.126 550.573 439.362 557.194 439.362C559.174 439.362 561.193 439.716 563.173 440.411C571.576 443.349 577.765 451.899 578.918 461.105C579.115 462.731 578.341 464.304 576.939 465.131L576.912 465.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M572.638 467.189C570.554 467.714 568.299 467.412 566.385 466.311L565.493 465.799C564.484 465.222 563.789 464.199 563.671 463.045C563.277 459.256 560.76 455.715 557.325 454.508C555.162 453.761 553.051 454.076 551.413 455.203C550.219 456.03 548.646 456.082 547.388 455.348L543.481 453.092C542.563 452.554 541.999 451.61 541.947 450.6C544.621 445.971 548.908 443.178 553.917 443.178C555.66 443.178 557.417 443.532 559.161 444.227C566.529 447.165 571.97 455.715 572.979 464.921C573.071 465.721 572.953 466.507 572.651 467.202L572.638 467.189Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.742 455.531L524.995 468.671C523.383 469.602 522.596 470.848 522.596 472.146V475.464C522.085 475.477 521.6 475.582 521.219 475.805L519.135 477.012C518.742 477.235 518.558 477.549 518.545 477.864V478.782C514.625 477.379 509.787 477.471 506.798 479.189L484.051 492.328V496.826L501.554 506.937L524.3 493.797C525.913 492.866 526.686 491.62 526.7 490.322V487.398C527.473 487.516 528.273 487.411 528.823 487.096L530.908 485.89C531.314 485.654 531.498 485.339 531.498 485.011V483.936C535.261 485.077 539.692 484.893 542.485 483.28L565.231 470.14V465.642L547.729 455.531H547.742Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.287 489.286L501.541 502.426L484.038 492.315L506.785 479.175C510.351 477.116 516.578 477.379 520.695 479.752L523.291 481.247C527.407 483.621 527.853 487.214 524.287 489.273V489.286Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.816 500.288L487.735 492.158L508.24 480.316C510.862 478.808 515.438 478.992 518.453 480.736L521.573 482.546C524.602 484.29 524.93 486.939 522.308 488.447L501.803 500.288H501.816Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.498 478.769L565.244 465.629L547.742 455.518L524.995 468.658C521.429 470.717 521.875 474.31 525.991 476.684L528.587 478.179C532.704 480.552 538.932 480.814 542.498 478.756V478.769Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.547 465.786L547.466 457.656L526.961 469.497C524.339 471.005 524.667 473.654 527.696 475.399L530.816 477.208C533.844 478.952 538.42 479.149 541.029 477.628L561.534 465.786H561.547Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.908 481.392L528.824 482.598C527.932 483.109 526.385 483.044 525.362 482.454L519.384 479.005C518.361 478.415 518.243 477.523 519.135 477.012L521.22 475.805C522.111 475.294 523.658 475.359 524.681 475.949L530.659 479.398C531.682 479.988 531.8 480.88 530.908 481.392Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.804 480.998L521.888 478.152C521.521 477.943 521.481 477.615 521.796 477.431L521.98 477.326C522.307 477.143 522.858 477.169 523.238 477.379L528.155 480.224C528.522 480.434 528.561 480.762 528.246 480.946L528.063 481.051C527.735 481.234 527.185 481.208 526.804 480.998Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.824 488.42L503.73 496.564C503.533 496.682 503.179 496.669 502.956 496.538C502.721 496.407 502.707 496.21 502.904 496.092L516.998 487.948C517.194 487.83 517.548 487.843 517.771 487.975C518.007 488.106 518.02 488.302 517.824 488.42Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.926 486.742L500.833 494.886C500.636 495.004 500.282 494.99 500.059 494.859C499.823 494.728 499.81 494.531 500.007 494.413L514.1 486.27C514.297 486.152 514.651 486.165 514.874 486.296C515.11 486.427 515.123 486.624 514.926 486.742Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.029 485.063L497.935 493.207C497.738 493.325 497.384 493.312 497.162 493.181C496.926 493.05 496.912 492.853 497.109 492.735L511.203 484.591C511.4 484.473 511.754 484.486 511.976 484.617C512.212 484.749 512.225 484.945 512.029 485.063Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.131 483.398L495.038 491.542C494.841 491.66 494.487 491.646 494.264 491.515C494.028 491.384 494.015 491.187 494.212 491.069L508.305 482.926C508.502 482.808 508.856 482.821 509.079 482.952C509.315 483.083 509.328 483.28 509.131 483.398Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.99 475.045L555.084 466.901C555.281 466.783 555.254 466.586 555.031 466.455C554.795 466.324 554.455 466.311 554.258 466.429L540.164 474.572C539.968 474.69 539.994 474.887 540.217 475.018C540.453 475.149 540.794 475.163 540.99 475.045Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.093 473.366L552.186 465.222C552.383 465.104 552.357 464.908 552.134 464.776C551.898 464.645 551.557 464.632 551.36 464.75L537.267 472.894C537.07 473.012 537.096 473.209 537.319 473.34C537.555 473.471 537.896 473.484 538.093 473.366Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.195 471.687L549.289 463.544C549.486 463.426 549.459 463.229 549.237 463.098C549.001 462.967 548.66 462.954 548.463 463.072L534.369 471.215C534.173 471.333 534.199 471.53 534.422 471.661C534.658 471.792 534.999 471.805 535.195 471.687Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.298 470.022L546.392 461.878C546.588 461.76 546.562 461.564 546.339 461.432C546.103 461.301 545.762 461.288 545.566 461.406L531.472 469.55C531.275 469.668 531.301 469.865 531.524 469.996C531.76 470.127 532.101 470.14 532.298 470.022Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.278 495.279C470.587 506.124 477.207 517.703 487.04 521.139C496.873 524.575 506.221 518.556 507.899 507.711C509.577 496.866 502.969 485.286 493.137 481.85C483.304 478.415 473.956 484.434 472.278 495.279Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.227 520.838C486.49 520.942 486.765 521.047 487.04 521.139C489.138 521.874 491.222 522.175 493.202 522.083C484.274 519.356 485.047 506.085 486.293 503.344C482.622 509.979 485.192 518.11 486.227 520.824V520.838Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.825 509.468C505.395 509.245 506.955 508.537 507.886 507.829C507.886 507.789 507.899 507.75 507.912 507.724C508.109 506.465 508.187 505.206 508.161 503.947C507.309 504.813 505.893 505.77 503.546 506.649C496.991 509.101 489.4 505.18 486.477 503.042C491.078 507.003 494.789 510.163 502.838 509.468H502.825Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.477 503.042C486.424 503.121 486.359 503.239 486.306 503.357C486.359 503.252 486.424 503.147 486.477 503.042Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.913 490.519C503.219 489.483 502.458 488.512 501.632 487.607C493.635 485.968 487.971 494.23 486.463 503.055C491.078 489.679 500.872 488.499 503.913 490.532V490.519Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.029 499.475C472.068 500.577 472.186 501.678 472.37 502.754C475.49 504.603 480.708 504.891 486.463 503.029C478.414 503.331 474.074 501.088 472.029 499.475Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.225 481.549C481.757 482.008 480.38 482.677 479.122 483.568C477.955 492.407 480.472 498.57 486.464 503.042C479.803 494.636 481.98 485.208 483.225 481.549Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.127 501.18C480.616 504.432 482.609 507.907 485.559 508.93C488.509 509.966 491.314 508.157 491.812 504.904C492.324 501.652 490.331 498.177 487.381 497.154C484.431 496.118 481.626 497.928 481.127 501.18Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.381 497.154C486.542 496.866 485.716 496.8 484.956 496.944C483.933 497.692 483.199 498.885 482.963 500.406C482.452 503.659 484.444 507.134 487.394 508.157C488.233 508.445 489.059 508.511 489.82 508.366C490.842 507.619 491.576 506.426 491.812 504.904C492.324 501.652 490.331 498.177 487.381 497.154Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M495.798 520.156C490.79 520.706 482.622 518.254 479.253 509.809C475.883 501.364 479.253 496.879 481.744 495.213C484.235 493.548 484.51 490.427 484.248 486.584C483.986 482.742 489.072 480.683 493.137 481.85C483.304 478.415 473.956 484.434 472.278 495.279C470.6 506.124 477.208 517.703 487.04 521.139C494.972 523.906 502.563 520.536 506.103 513.455C504.202 517.153 500.767 519.605 495.798 520.156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.362 505.272L505.29 506.465C504.595 506.871 503.861 507.16 503.101 507.344C501.016 507.868 498.761 507.566 496.847 506.465L495.956 505.953C494.946 505.376 494.251 504.354 494.133 503.2C493.74 499.41 491.223 495.869 487.788 494.663C485.625 493.915 483.514 494.23 481.875 495.358C480.682 496.184 479.109 496.236 477.85 495.502L473.943 493.246C473.025 492.709 472.462 491.764 472.409 490.755C472.383 490.269 472.475 489.784 472.685 489.312C475.49 483.28 481.023 479.516 487.644 479.516C489.623 479.516 491.642 479.87 493.622 480.565C502.026 483.503 508.214 492.053 509.368 501.259C509.564 502.885 508.791 504.459 507.388 505.285L507.362 505.272Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M507.362 505.272L505.29 506.465C504.595 506.871 503.861 507.16 503.101 507.344C501.016 507.868 498.761 507.566 496.847 506.465L495.956 505.953C494.946 505.376 494.251 504.354 494.133 503.2C493.74 499.41 491.223 495.869 487.788 494.663C485.625 493.915 483.514 494.23 481.875 495.358C480.682 496.184 479.109 496.236 477.85 495.502L473.943 493.246C473.025 492.709 472.462 491.764 472.409 490.755C472.383 490.269 472.475 489.784 472.685 489.312C475.49 483.28 481.023 479.516 487.644 479.516C489.623 479.516 491.642 479.87 493.622 480.565C502.026 483.503 508.214 492.053 509.368 501.259C509.564 502.885 508.791 504.459 507.388 505.285L507.362 505.272Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M503.088 507.357C501.003 507.881 498.748 507.58 496.834 506.478L495.942 505.967C494.933 505.39 494.238 504.367 494.12 503.213C493.727 499.423 491.209 495.882 487.775 494.676C485.611 493.928 483.501 494.243 481.862 495.371C480.669 496.197 479.095 496.249 477.837 495.515L473.93 493.259C473.012 492.722 472.448 491.778 472.396 490.768C475.071 486.139 479.358 483.345 484.366 483.345C486.11 483.345 487.866 483.699 489.61 484.395C496.978 487.332 502.419 495.882 503.428 505.088C503.52 505.888 503.402 506.675 503.101 507.37L503.088 507.357Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.268 509.324L396.394 495.541C395.896 495.253 395.293 495.253 394.795 495.541L379.81 504.183C379.311 504.472 379.01 504.996 379.01 505.573V506.373C379.01 506.95 379.311 507.475 379.81 507.763L403.697 521.559C404.195 521.848 404.798 521.848 405.296 521.559L420.268 512.917C420.767 512.629 421.068 512.104 421.068 511.527V510.727C421.068 510.15 420.767 509.626 420.268 509.337V509.324Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M420.268 509.324L396.394 495.541C395.896 495.253 395.293 495.253 394.795 495.541L379.81 504.183C379.311 504.472 379.01 504.996 379.01 505.573V506.373C379.01 506.95 379.311 507.475 379.81 507.763L403.697 521.559C404.195 521.848 404.798 521.848 405.296 521.559L420.268 512.917C420.767 512.629 421.068 512.104 421.068 511.527V510.727C421.068 510.15 420.767 509.626 420.268 509.337V509.324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.536 500.236L396.394 495.541C395.896 495.253 395.293 495.253 394.795 495.541L379.81 504.183C379.311 504.472 379.01 504.996 379.01 505.573V506.373C379.01 506.95 379.311 507.475 379.81 507.763L403.697 521.559C403.959 521.716 404.247 521.782 404.549 521.769V500.262L404.536 500.236Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M404.536 500.236L396.394 495.541C395.896 495.253 395.293 495.253 394.795 495.541L379.81 504.183C379.311 504.472 379.01 504.996 379.01 505.573V506.373C379.01 506.95 379.311 507.475 379.81 507.763L403.697 521.559C403.959 521.716 404.247 521.782 404.549 521.769V500.262L404.536 500.236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M404.536 500.236L396.394 495.541C395.896 495.253 395.293 495.253 394.795 495.541L379.81 504.183C379.311 504.472 379.01 504.996 379.01 505.573V506.373C379.01 506.95 379.311 507.475 379.81 507.763L403.697 521.559C403.959 521.716 404.247 521.782 404.549 521.769V500.262L404.536 500.236Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.749 518.923C404.208 519.185 404.772 519.185 405.231 518.923L420.845 509.901C420.701 509.665 420.504 509.455 420.255 509.311L396.381 495.528C395.883 495.24 395.28 495.24 394.782 495.528L379.797 504.17C379.547 504.314 379.351 504.511 379.207 504.76L403.736 518.923H403.749Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M403.749 518.923C404.208 519.185 404.772 519.185 405.231 518.923L420.845 509.901C420.701 509.665 420.504 509.455 420.255 509.311L396.381 495.528C395.883 495.24 395.28 495.24 394.782 495.528L379.797 504.17C379.547 504.314 379.351 504.511 379.207 504.76L403.736 518.923H403.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.74 515.736C403.081 515.933 403.487 515.933 403.815 515.736L415.169 509.18C415.064 509.009 414.92 508.852 414.749 508.76L397.391 498.741C397.037 498.531 396.591 498.531 396.224 498.741L385.329 505.022C385.146 505.127 385.001 505.272 384.91 505.442L402.74 515.736Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.407 506.399L398.61 511.474C398.492 511.54 398.269 511.54 398.125 511.448C397.981 511.37 397.968 511.238 398.086 511.173L406.883 506.098C407.001 506.032 407.223 506.032 407.368 506.124C407.512 506.203 407.525 506.334 407.407 506.399Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.598 505.363L396.801 510.438C396.683 510.504 396.46 510.504 396.316 510.412C396.172 510.334 396.158 510.202 396.276 510.137L405.074 505.062C405.192 504.996 405.414 504.996 405.559 505.088C405.703 505.167 405.716 505.298 405.598 505.363Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.788 504.314L394.991 509.389C394.873 509.455 394.65 509.455 394.506 509.363C394.362 509.284 394.349 509.153 394.467 509.088L403.264 504.013C403.382 503.947 403.605 503.947 403.749 504.039C403.893 504.118 403.906 504.249 403.788 504.314Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.979 503.265L393.182 508.34C393.064 508.406 392.841 508.406 392.697 508.314C392.553 508.235 392.54 508.104 392.658 508.039L401.455 502.964C401.573 502.898 401.796 502.898 401.94 502.99C402.084 503.069 402.097 503.2 401.979 503.265Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.881 497.338C413.071 503.79 411.235 511.055 405.899 515.291C403.172 517.454 399.855 518.635 396.119 518.635C392.382 518.635 388.672 517.507 384.805 515.277C374.998 509.612 366.62 497.889 362.241 484.972C360.052 478.52 361.888 471.255 367.223 467.032C369.95 464.868 373.267 463.675 377.004 463.675C380.74 463.675 384.451 464.803 388.318 467.032C398.125 472.697 406.502 484.408 410.881 497.338Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M410.881 497.338C413.071 503.79 411.235 511.055 405.899 515.291C403.172 517.454 399.855 518.635 396.119 518.635C392.382 518.635 388.672 517.507 384.805 515.277C374.998 509.612 366.62 497.889 362.241 484.972C360.052 478.52 361.888 471.255 367.223 467.032C369.95 464.868 373.267 463.675 377.004 463.675C380.74 463.675 384.451 464.803 388.318 467.032C398.125 472.697 406.502 484.408 410.881 497.338Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.278 516.235C410.278 498.505 399.502 477.916 386.208 470.232C385.513 469.825 384.831 469.511 384.149 469.196C384.084 469.17 384.018 469.13 383.953 469.104C383.494 468.894 383.035 468.737 382.576 468.566C382.235 468.435 381.881 468.304 381.54 468.186C381.199 468.081 380.872 468.002 380.531 467.911C380.072 467.793 379.613 467.688 379.154 467.609C378.905 467.57 378.669 467.543 378.433 467.504C377.909 467.439 377.384 467.399 376.873 467.399C376.768 467.399 376.663 467.373 376.571 467.373C376.362 467.373 375.719 467.373 375.614 467.386C366.031 467.701 357.666 472.815 352.802 480.408C350.626 483.214 349.144 487.135 348.594 492.001C348.436 493.22 348.318 494.466 348.318 495.738C348.318 495.843 348.318 495.948 348.331 496.053C348.331 496.171 348.318 496.289 348.318 496.407C348.318 496.407 348.318 496.407 348.318 496.42C348.318 514.15 359.095 534.738 372.389 542.423C373.084 542.829 373.766 543.144 374.447 543.459C374.513 543.485 374.579 543.524 374.644 543.551C375.103 543.76 375.562 543.918 376.021 544.088C376.362 544.219 376.716 544.351 377.056 544.469C377.397 544.573 377.725 544.652 378.066 544.731C378.525 544.849 378.984 544.954 379.443 545.032C379.692 545.072 379.928 545.098 380.164 545.137C380.688 545.203 382.471 545.282 382.668 545.268C382.773 545.268 382.878 545.269 382.982 545.255C392.566 544.941 400.931 539.826 405.795 532.233C407.971 529.427 409.452 525.506 410.003 520.641C410.16 519.421 410.278 518.176 410.278 516.904C410.278 516.799 410.278 516.694 410.265 516.589C410.265 516.471 410.278 516.353 410.278 516.235Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.73 523.67C382.406 526.857 379.901 528.653 376.689 528.365L376.257 525.585C376.06 524.365 375.221 523.172 374.395 522.949C373.556 522.726 373.032 523.539 373.228 524.759L373.661 527.539C370.252 526.044 366.948 522.687 364.457 518.464L365.873 517.507C366.306 517.231 366.45 516.549 366.332 515.776C366.28 515.409 366.149 515.015 365.965 514.635C365.375 513.455 364.392 512.851 363.762 513.271L362.333 514.215C361.389 511.933 360.695 509.52 360.301 507.081C359.921 504.629 359.882 502.374 360.157 500.433L362.019 502.269C362.294 502.544 362.569 502.701 362.832 502.78C363.356 502.924 363.802 502.662 363.972 502.033C364.221 501.075 363.749 499.646 362.936 498.846L361.088 497.01C362.425 493.81 364.916 492.027 368.128 492.315L368.574 495.095C368.758 496.315 369.61 497.495 370.449 497.731C371.275 497.954 371.799 497.141 371.616 495.922L371.183 493.141C374.592 494.636 377.896 497.994 380.387 502.216L378.971 503.173C378.551 503.449 378.394 504.131 378.525 504.904C378.577 505.272 378.695 505.665 378.892 506.058C379.482 507.226 380.465 507.842 381.094 507.422L382.523 506.465C383.467 508.734 384.162 511.16 384.556 513.625C384.936 516.064 384.962 518.294 384.7 520.261L382.838 518.425C382.576 518.149 382.301 517.979 382.038 517.913C381.501 517.769 381.055 518.031 380.885 518.674C380.649 519.631 381.108 521.061 381.92 521.847L383.769 523.683L383.73 523.67Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.402 478.231C359.108 470.56 348.332 478.703 348.332 496.433C348.332 514.163 359.108 534.751 372.402 542.423C385.696 550.094 396.473 541.951 396.473 524.234C396.473 506.517 385.696 485.903 372.402 478.231ZM372.756 533.217C363.238 527.722 355.49 512.891 355.49 500.157C355.49 493.6 357.574 488.63 361.219 486.519C362.465 485.798 363.881 485.444 365.388 485.444C367.46 485.444 369.715 486.113 372.035 487.45C381.567 492.958 389.302 507.789 389.302 520.523C389.302 527.08 387.217 532.05 383.572 534.161C380.609 535.879 376.755 535.538 372.756 533.23V533.217Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.756 486.204C368.286 483.621 363.933 483.293 360.498 485.273C356.408 487.647 354.048 493.063 354.048 500.157C354.048 513.35 362.124 528.745 372.035 534.476C374.579 535.945 377.083 536.692 379.404 536.692C381.16 536.692 382.812 536.259 384.281 535.42C388.384 533.047 390.731 527.631 390.731 520.536C390.731 507.344 382.668 491.948 372.743 486.217L372.756 486.204ZM383.586 534.148C380.623 535.866 376.768 535.525 372.77 533.217C363.251 527.722 355.503 512.891 355.503 500.157C355.503 493.6 357.588 488.63 361.232 486.519C362.478 485.798 363.894 485.444 365.402 485.444C367.473 485.444 369.728 486.112 372.049 487.45C381.58 492.958 389.315 507.789 389.315 520.523C389.315 527.08 387.23 532.05 383.586 534.161V534.148Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.036 487.437C369.715 486.099 367.46 485.431 365.389 485.431C363.881 485.431 362.465 485.785 361.219 486.506C357.575 488.617 355.49 493.574 355.49 500.144C355.49 512.878 363.239 527.709 372.757 533.204C376.769 535.525 380.61 535.853 383.573 534.135C387.218 532.024 389.302 527.067 389.302 520.497C389.302 507.763 381.554 492.932 372.036 487.424V487.437ZM384.648 520.234L382.786 518.398C382.524 518.123 382.249 517.953 381.986 517.887C381.449 517.743 381.003 518.005 380.833 518.648C380.597 519.605 381.056 521.034 381.868 521.821L383.717 523.657C382.393 526.844 379.889 528.64 376.677 528.352L376.244 525.572C376.047 524.352 375.208 523.159 374.382 522.936C373.543 522.713 373.019 523.526 373.216 524.746L373.648 527.526C370.24 526.031 366.936 522.674 364.445 518.451L365.861 517.494C366.293 517.218 366.437 516.536 366.319 515.763C366.267 515.395 366.136 515.002 365.952 514.622C365.362 513.441 364.379 512.838 363.75 513.258L362.321 514.202C361.377 511.92 360.682 509.507 360.289 507.068C359.908 504.616 359.869 502.36 360.144 500.42L362.006 502.255C362.281 502.531 362.557 502.688 362.819 502.767C363.343 502.911 363.789 502.649 363.96 502.019C364.209 501.062 363.737 499.633 362.924 498.833L361.075 496.997C362.413 493.797 364.904 492.014 368.116 492.302L368.561 495.082C368.745 496.302 369.597 497.482 370.436 497.718C371.262 497.941 371.787 497.128 371.603 495.908L371.17 493.128C374.579 494.623 377.883 497.98 380.374 502.203L378.958 503.16C378.538 503.436 378.381 504.118 378.512 504.891C378.565 505.259 378.683 505.652 378.879 506.045C379.469 507.212 380.453 507.829 381.082 507.409L382.511 506.452C383.455 508.721 384.15 511.147 384.543 513.612C384.923 516.051 384.949 518.28 384.687 520.248L384.648 520.234Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.832 518.648C380.596 519.605 381.055 521.034 381.868 521.821L383.716 523.657C382.392 526.844 379.888 528.64 376.676 528.352L376.244 525.572C376.047 524.352 375.208 523.159 374.382 522.936C373.543 522.713 373.018 523.526 373.215 524.746L373.648 527.526C370.239 526.031 366.935 522.674 364.444 518.451L365.86 517.494C366.293 517.218 366.437 516.536 366.319 515.763C366.266 515.395 366.135 515.002 365.952 514.622C365.362 513.442 364.379 512.838 363.749 513.258L362.32 514.202C361.376 511.92 360.681 509.507 360.288 507.068C359.908 504.616 359.869 502.36 360.144 500.42L362.006 502.256C362.281 502.531 362.556 502.688 362.818 502.767C363.343 502.911 363.789 502.649 363.959 502.019C364.208 501.062 363.736 499.633 362.923 498.833L361.075 496.997C362.412 493.797 364.903 492.014 368.115 492.302L368.561 495.082C368.744 496.302 369.596 497.482 370.436 497.718C371.262 497.941 371.786 497.128 371.602 495.908L371.17 493.128C374.578 494.623 377.882 497.98 380.373 502.203L378.957 503.16C378.538 503.436 378.38 504.118 378.512 504.891C378.564 505.259 378.682 505.652 378.879 506.045C379.469 507.213 380.452 507.829 381.081 507.409L382.51 506.452C383.454 508.721 384.149 511.147 384.542 513.612C384.923 516.051 384.949 518.28 384.687 520.248L382.825 518.412C382.563 518.136 382.287 517.966 382.025 517.9C381.488 517.756 381.042 518.018 380.872 518.661L380.832 518.648Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.881 497.338C406.503 484.421 398.138 472.697 388.318 467.045C384.464 464.816 380.649 463.688 377.004 463.688C374.198 463.688 371.642 464.357 369.374 465.603L368.823 465.93L355.411 473.668C357.627 472.487 360.131 471.845 362.858 471.845C362.989 471.845 363.107 471.845 363.225 471.845C366.752 471.91 370.436 473.051 374.159 475.189C383.966 480.854 392.343 492.578 396.722 505.495C397.928 509.022 397.915 512.786 396.801 516.169C400.078 507.212 401.468 504.183 404.248 502.57C407.106 500.931 411.17 502.57 410.685 508.721C412.061 505.154 412.153 501.101 410.868 497.325L410.881 497.338Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M410.881 497.338C406.503 484.421 398.138 472.697 388.318 467.045C384.464 464.816 380.649 463.688 377.004 463.688C374.198 463.688 371.642 464.357 369.374 465.603L368.823 465.93L355.411 473.668C357.627 472.487 360.131 471.845 362.858 471.845C362.989 471.845 363.107 471.845 363.225 471.845C366.752 471.91 370.436 473.051 374.159 475.189C383.966 480.854 392.343 492.578 396.722 505.495C397.928 509.022 397.915 512.786 396.801 516.169C400.078 507.212 401.468 504.183 404.248 502.57C407.106 500.931 411.17 502.57 410.685 508.721C412.061 505.154 412.153 501.101 410.868 497.325L410.881 497.338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M402.989 502.269C399.855 504.721 399.095 508.248 397.627 503.921C396.683 501.154 392.186 492.617 387.623 486.69C383.048 480.762 376.833 475.045 369.557 473.064C371.078 473.615 372.612 474.31 374.159 475.202C383.966 480.867 392.343 492.591 396.722 505.508C397.915 509.035 397.915 512.799 396.801 516.182C400.078 507.226 401.468 504.196 404.247 502.583C406.856 501.088 410.449 502.334 410.698 507.226C410.894 501.665 406.096 499.829 402.976 502.282L402.989 502.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.722 505.495C398.912 511.947 397.076 519.225 391.74 523.447C389.013 525.611 385.696 526.791 381.96 526.791C378.223 526.791 374.513 525.663 370.645 523.434C360.826 517.769 352.461 506.045 348.082 493.115C345.893 486.663 347.728 479.398 353.064 475.176C355.791 473.012 359.108 471.832 362.845 471.832C366.581 471.832 370.291 472.959 374.159 475.189C383.966 480.854 392.343 492.578 396.722 505.495Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.844 526.542L384.687 517.546C384.582 514.91 384.857 511.147 384.307 508.616C383.153 503.619 380.006 498.912 375.392 496.525L373.438 495.41L369.544 493.155C368.233 492.407 367.001 491.581 365.572 491.319C362.32 490.584 360.288 493.286 360.236 496.328C360.118 501.508 360.092 509.035 359.961 514.307C359.829 508.301 359.738 502.321 359.725 496.302C359.738 494.007 360.891 491.345 363.33 490.781C365.677 490.152 367.971 491.476 369.859 492.604L373.766 494.846L375.706 495.974C380.754 498.662 384.215 504.026 384.962 509.652C385.211 514.294 384.844 521.834 384.831 526.542H384.844Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M352.776 486.637C353.445 487.017 353.982 487.961 353.982 488.722C353.982 489.483 353.445 489.797 352.776 489.417C352.107 489.037 351.57 488.093 351.57 487.332C351.57 486.571 352.107 486.257 352.776 486.637Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.758 480.395C358.427 480.775 358.964 481.719 358.964 482.48C358.964 483.241 358.427 483.555 357.758 483.175C357.089 482.795 356.552 481.85 356.552 481.09C356.552 480.329 357.089 480.015 357.758 480.395Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.087 478.887C365.755 479.267 366.293 480.211 366.293 480.972C366.293 481.732 365.755 482.047 365.087 481.667C364.418 481.287 363.88 480.342 363.88 479.582C363.88 478.821 364.418 478.507 365.087 478.887Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.281 482.244C373.95 482.624 374.487 483.568 374.487 484.329C374.487 485.09 373.95 485.404 373.281 485.024C372.612 484.644 372.075 483.7 372.075 482.939C372.075 482.178 372.612 481.864 373.281 482.244Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.403 487.673C380.072 488.053 380.61 488.997 380.61 489.758C380.61 490.519 380.072 490.833 379.403 490.453C378.735 490.073 378.197 489.129 378.197 488.368C378.197 487.607 378.735 487.293 379.403 487.673Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.687 494.82C385.355 495.2 385.893 496.144 385.893 496.905C385.893 497.666 385.355 497.98 384.687 497.6C384.018 497.22 383.48 496.276 383.48 495.515C383.48 494.754 384.018 494.44 384.687 494.82Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.83 503.134C389.498 503.514 390.036 504.459 390.036 505.219C390.036 505.98 389.498 506.295 388.83 505.914C388.161 505.534 387.624 504.59 387.624 503.829C387.624 503.069 388.161 502.754 388.83 503.134Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.53 512.051C392.199 512.432 392.737 513.376 392.737 514.136C392.737 514.897 392.199 515.212 391.53 514.832C390.862 514.451 390.324 513.507 390.324 512.746C390.324 511.986 390.862 511.671 391.53 512.051Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.776 486.637C353.445 487.017 353.982 487.961 353.982 488.722C353.982 489.483 353.445 489.797 352.776 489.417C352.107 489.037 351.57 488.093 351.57 487.332C351.57 486.571 352.107 486.257 352.776 486.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.758 480.395C358.427 480.775 358.964 481.719 358.964 482.48C358.964 483.241 358.427 483.555 357.758 483.175C357.089 482.795 356.552 481.85 356.552 481.09C356.552 480.329 357.089 480.015 357.758 480.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.087 478.887C365.755 479.267 366.293 480.211 366.293 480.972C366.293 481.732 365.755 482.047 365.087 481.667C364.418 481.287 363.88 480.342 363.88 479.582C363.88 478.821 364.418 478.507 365.087 478.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.281 482.244C373.95 482.624 374.487 483.568 374.487 484.329C374.487 485.09 373.95 485.404 373.281 485.024C372.612 484.644 372.075 483.7 372.075 482.939C372.075 482.178 372.612 481.864 373.281 482.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.403 487.673C380.072 488.053 380.61 488.997 380.61 489.758C380.61 490.519 380.072 490.833 379.403 490.453C378.735 490.073 378.197 489.129 378.197 488.368C378.197 487.607 378.735 487.293 379.403 487.673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.687 494.82C385.355 495.2 385.893 496.144 385.893 496.905C385.893 497.666 385.355 497.98 384.687 497.6C384.018 497.22 383.48 496.276 383.48 495.515C383.48 494.754 384.018 494.44 384.687 494.82Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.83 503.134C389.498 503.514 390.036 504.459 390.036 505.219C390.036 505.98 389.498 506.295 388.83 505.914C388.161 505.534 387.624 504.59 387.624 503.829C387.624 503.069 388.161 502.754 388.83 503.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.53 512.051C392.199 512.432 392.737 513.376 392.737 514.136C392.737 514.897 392.199 515.212 391.53 514.832C390.862 514.451 390.324 513.507 390.324 512.746C390.324 511.986 390.862 511.671 391.53 512.051Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M385.29 529.519L361.416 515.736C360.918 515.448 360.314 515.448 359.816 515.736L344.831 524.378C344.333 524.667 344.031 525.191 344.031 525.768V526.568C344.031 527.145 344.333 527.67 344.831 527.958L368.718 541.754C369.216 542.043 369.819 542.043 370.318 541.754L385.29 533.112C385.788 532.824 386.09 532.299 386.09 531.722V530.922C386.09 530.345 385.788 529.821 385.29 529.532V529.519Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M385.29 529.519L361.416 515.736C360.918 515.448 360.314 515.448 359.816 515.736L344.831 524.378C344.333 524.667 344.031 525.191 344.031 525.768V526.568C344.031 527.145 344.333 527.67 344.831 527.958L368.718 541.754C369.216 542.043 369.819 542.043 370.318 541.754L385.29 533.112C385.788 532.824 386.09 532.299 386.09 531.722V530.922C386.09 530.345 385.788 529.821 385.29 529.532V529.519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.57 520.431L361.429 515.736C360.931 515.448 360.328 515.448 359.829 515.736L344.844 524.378C344.346 524.667 344.044 525.191 344.044 525.768V526.568C344.044 527.145 344.346 527.67 344.844 527.958L368.731 541.754C368.994 541.911 369.282 541.977 369.584 541.964V520.457L369.57 520.431Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M369.57 520.431L361.429 515.736C360.931 515.448 360.328 515.448 359.829 515.736L344.844 524.378C344.346 524.667 344.044 525.191 344.044 525.768V526.568C344.044 527.145 344.346 527.67 344.844 527.958L368.731 541.754C368.994 541.911 369.282 541.977 369.584 541.964V520.457L369.57 520.431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M369.57 520.431L361.429 515.736C360.931 515.448 360.328 515.448 359.829 515.736L344.844 524.378C344.346 524.667 344.044 525.191 344.044 525.768V526.568C344.044 527.145 344.346 527.67 344.844 527.958L368.731 541.754C368.994 541.911 369.282 541.977 369.584 541.964V520.457L369.57 520.431Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.784 539.131C369.243 539.394 369.807 539.394 370.265 539.131L385.88 530.109C385.736 529.873 385.539 529.663 385.29 529.519L361.416 515.736C360.918 515.448 360.315 515.448 359.816 515.736L344.831 524.378C344.582 524.523 344.385 524.719 344.241 524.968L368.771 539.131H368.784Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M368.784 539.131C369.243 539.394 369.807 539.394 370.265 539.131L385.88 530.109C385.736 529.873 385.539 529.663 385.29 529.519L361.416 515.736C360.918 515.448 360.315 515.448 359.816 515.736L344.831 524.378C344.582 524.523 344.385 524.719 344.241 524.968L368.771 539.131H368.784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.774 535.932C368.115 536.128 368.521 536.128 368.849 535.932L380.203 529.375C380.098 529.204 379.954 529.047 379.783 528.955L362.425 518.936C362.071 518.726 361.625 518.726 361.258 518.936L350.363 525.218C350.18 525.323 350.036 525.467 349.944 525.637L367.774 535.932Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.442 526.595L363.645 531.67C363.527 531.735 363.304 531.735 363.16 531.643C363.015 531.565 363.002 531.434 363.12 531.368L371.917 526.293C372.035 526.227 372.258 526.227 372.402 526.319C372.547 526.398 372.56 526.529 372.442 526.595Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.633 525.559L361.836 530.634C361.718 530.699 361.495 530.699 361.35 530.607C361.206 530.529 361.193 530.398 361.311 530.332L370.108 525.257C370.226 525.191 370.449 525.191 370.593 525.283C370.738 525.362 370.751 525.493 370.633 525.559Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.823 524.509L360.026 529.584C359.908 529.65 359.685 529.65 359.541 529.558C359.397 529.48 359.384 529.348 359.502 529.283L368.299 524.208C368.417 524.142 368.64 524.142 368.784 524.234C368.928 524.313 368.941 524.444 368.823 524.509Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.014 523.46L358.217 528.535C358.099 528.601 357.876 528.601 357.732 528.509C357.588 528.431 357.574 528.299 357.692 528.234L366.49 523.159C366.608 523.093 366.83 523.093 366.975 523.185C367.119 523.264 367.132 523.395 367.014 523.46Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2317 474.94C90.5011 474.94 88.7967 474.73 87.1448 474.31L86.699 474.192C84.9291 473.707 83.0937 472.92 81.2451 471.858C69.4195 465.026 59.7964 448.358 59.7964 434.694C59.7964 432.228 60.111 429.973 60.7272 428.006C63.5329 418.852 73.523 411.679 83.4739 411.679C85.1913 411.679 86.8826 411.889 88.5083 412.308L88.9934 412.44C90.7764 412.925 92.6119 413.712 94.4604 414.774C106.286 421.593 115.909 438.274 115.909 451.938C115.909 454.43 115.594 456.685 114.965 458.679L114.795 459.229C111.779 468.094 101.999 474.953 92.2448 474.953L92.2317 474.94Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4609 412.059C85.1129 412.059 86.7385 412.256 88.3118 412.649L88.8756 412.807C90.6192 413.279 92.4285 414.053 94.2377 415.102C105.958 421.868 115.503 438.392 115.503 451.938C115.503 454.39 115.188 456.607 114.572 458.561L114.415 459.072C111.465 467.806 101.829 474.572 92.2187 474.572C90.5537 474.572 88.9149 474.376 87.3285 473.969L86.791 473.825C85.0473 473.353 83.2512 472.579 81.4288 471.53C69.7081 464.763 60.1637 448.24 60.1637 434.694C60.1637 432.268 60.4652 430.051 61.0814 428.111C63.8346 419.115 73.6674 412.059 83.4609 412.059ZM83.4609 411.286C72.9857 411.286 63.0873 418.931 60.3472 427.888C59.731 429.855 59.3901 432.136 59.3901 434.694C59.3901 448.502 69.0788 465.288 81.0355 472.199C82.9496 473.3 84.8113 474.087 86.5812 474.572C88.456 475.097 90.357 475.346 92.2318 475.346C102.694 475.346 112.592 467.74 115.332 458.797C115.962 456.816 116.303 454.522 116.303 451.938C116.303 438.129 106.614 421.331 94.6573 414.433C92.7431 413.331 90.8815 412.545 89.0984 412.059C87.2367 411.535 85.3488 411.286 83.474 411.286H83.4609Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0487 472.186C69.0919 465.288 59.4033 448.489 59.4033 434.681C59.4033 420.872 69.0919 415.272 81.0487 422.17C93.0054 429.068 102.694 445.853 102.694 459.675C102.694 473.484 93.0054 479.097 81.0487 472.186Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7109 470.966C98.0265 470.966 98.5903 462.272 98.5903 459.597C98.5903 447.322 89.6227 431.769 78.9901 425.645C76.2632 424.072 73.628 423.245 71.373 423.245C64.0573 423.245 63.4805 431.94 63.4805 434.615C63.4805 446.889 72.4611 462.429 83.0806 468.566C85.8076 470.14 88.4428 470.979 90.6978 470.979L90.7109 470.966Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3464 462.993C74.5325 458.482 67.938 447.06 67.938 438.038C67.938 436.018 68.3837 429.422 74.0344 429.422C75.7387 429.422 77.7053 430.038 79.7505 431.218C87.5512 435.73 94.1458 447.152 94.1458 456.174C94.1458 458.193 93.7 464.79 88.0494 464.79C86.3451 464.79 84.3785 464.173 82.3464 462.993ZM68.6984 438.051C68.6984 446.837 75.1225 457.957 82.7266 462.35C84.6407 463.465 86.4893 464.042 88.0625 464.042C93.0183 464.042 93.3985 458.023 93.3985 456.174C93.3985 447.388 86.9744 436.267 79.3703 431.874C77.4431 430.773 75.6076 430.182 74.0344 430.182C69.0786 430.182 68.6853 436.202 68.6853 438.051H68.6984Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0488 437.5C76.447 434.851 72.7236 437.002 72.7236 442.313C72.7236 447.624 76.447 454.076 81.0488 456.738C85.6505 459.387 89.3739 457.236 89.3739 451.925C89.3739 446.614 85.6505 440.162 81.0488 437.5Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0485 443.821C79.4753 442.916 78.1904 443.65 78.1904 445.473C78.1904 447.296 79.4621 449.499 81.0485 450.417C82.6349 451.335 83.9066 450.587 83.9066 448.765C83.9066 446.942 82.6349 444.739 81.0485 443.821Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.865 462.796L146.496 441.644C146.496 441.644 166.148 465.826 181.37 461.091C181.37 461.091 185.237 501.665 167.25 505.154C149.262 508.642 138.066 493.758 129.452 484.867C120.826 475.976 109.865 462.809 109.865 462.809V462.796Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M109.865 462.796L146.496 441.644C146.496 441.644 166.148 465.826 181.37 461.091C181.37 461.091 185.237 501.665 167.25 505.154C149.262 508.642 138.066 493.758 129.452 484.867C120.826 475.976 109.865 462.809 109.865 462.809V462.796Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9762 397.7C75.4636 395.654 88.6658 388.061 92.1138 386.068C99.2328 381.95 108.397 381.36 116.539 386.068L136.925 397.647C145.696 402.709 163.055 412.571 164.208 422.642C165.703 435.756 154.428 455.531 166.476 468.566L146.496 480.106L59.9146 426.262L59.9408 418.813C59.9408 409.476 64.949 401.831 71.9893 397.7H71.9762Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M143.428 445.604C144.516 439.362 148.685 431.625 154.166 428.451L154.27 428.399C159.764 425.226 164.497 427.822 163.408 434.077C161.403 445.657 157.574 458.967 166.476 468.593L146.496 480.133C137.594 470.507 141.422 457.21 143.428 445.617V445.604Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M96.5846 397.621L116.958 409.187C125.729 414.249 143.087 424.111 144.241 434.182C145.736 447.296 134.461 467.071 146.509 480.106L59.9277 426.261V418.813C59.9671 400.008 80.3145 388.219 96.5977 397.621H96.5846Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.89 448.371C124.89 448.686 124.89 449.014 124.864 449.342C124.706 453.04 122.661 456.384 119.449 458.246C117.889 459.151 116.145 459.623 114.389 459.675C114.323 459.675 114.271 459.675 114.205 459.675C114.153 459.675 114.1 459.675 114.035 459.675C112.868 459.675 111.701 459.492 110.586 459.098C110.075 458.941 109.59 458.731 109.118 458.482C108.961 458.39 108.803 458.311 108.646 458.22L96.7812 451.361L62.2613 431.415L53.1496 426.157C52.7432 415.954 57.4498 408.742 61.9205 405.384C61.9205 405.384 62.0254 405.306 62.0909 405.28C64.3459 403.955 70.0621 400.664 71.7402 399.706C77.653 396.362 85.7553 395.457 96.5714 401.175C96.8205 401.293 97.0696 401.437 97.3187 401.568C97.594 401.726 97.8693 401.87 98.1578 402.04C112.92 410.564 124.89 431.297 124.89 448.358V448.371Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.402 459.675C112.881 459.728 111.347 459.465 109.931 458.875C113.012 460.147 116.539 459.938 119.462 458.246C122.674 456.397 124.719 453.053 124.877 449.355C124.877 449.014 124.89 448.699 124.89 448.384C124.89 438.877 121.167 428.229 115.319 419.193L105.329 424.963C111.176 434.012 114.887 444.647 114.887 454.154C114.887 456.135 114.716 457.984 114.402 459.675Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M114.887 454.141C114.887 456.121 114.716 457.97 114.402 459.675C114.336 459.675 114.284 459.675 114.218 459.675C112.999 459.675 111.766 459.505 110.586 459.111C110.075 458.941 109.59 458.731 109.118 458.495C108.961 458.403 108.803 458.325 108.646 458.233L96.7812 451.374L62.2613 431.428L53.1496 426.17C52.7432 415.967 57.4498 408.755 61.9205 405.398C61.9205 405.398 62.0254 405.319 62.0909 405.293C67.9775 402.106 75.9749 401.359 86.5681 406.958C86.8172 407.076 87.0663 407.22 87.3154 407.352C87.5907 407.509 87.8661 407.653 88.1414 407.81C102.917 416.334 114.887 437.067 114.887 454.128V454.141Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.014 411.181L76.5649 421.606L84.759 425.684L79.423 436.988L91.4453 425.566L82.7137 420.688L87.014 411.181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M61.9204 405.411C67.8201 402.145 75.8699 401.319 86.5681 406.971C86.8172 407.089 87.0663 407.22 87.3154 407.365C87.5907 407.509 87.866 407.666 88.1413 407.824C94.6834 411.6 100.675 417.764 105.316 424.95L115.306 419.18C110.678 411.994 104.687 405.83 98.1446 402.054C97.8693 401.896 97.5809 401.739 97.3186 401.595C97.0695 401.45 96.8204 401.319 96.5713 401.201C85.7552 395.484 77.653 396.388 71.7401 399.732C70.0227 400.703 64.0312 404.165 61.9204 405.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.181 390.33V388.887C128.181 387.76 127.42 384.153 126.49 383.511L109.879 373.269C108.948 372.626 107.388 372.574 106.404 373.138L83.3168 386.474C82.3335 387.038 81.5469 388.415 81.5469 389.556V394.841C81.5469 395.969 82.3466 397.346 83.3168 397.91L99.7704 406.735C100.754 407.299 102.34 407.299 103.323 406.735L126.411 393.398C127.394 392.835 128.181 391.458 128.181 390.317V390.33Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.398 385.701L103.31 399.037C102.327 399.601 100.78 399.549 99.8359 398.906L83.2249 388.664C82.2941 388.022 82.3203 387.051 83.3036 386.488L106.391 373.151C107.374 372.587 108.921 372.639 109.865 373.282L126.476 383.524C127.407 384.166 127.381 385.137 126.398 385.701Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.541 399.405V407.168C102.183 407.168 102.825 407.024 103.324 406.735L126.411 393.399C127.394 392.835 128.194 391.458 128.194 390.317V386.711C128.194 385.648 127.525 384.324 126.673 383.642C127.434 384.284 127.342 385.163 126.424 385.688L103.337 399.024C102.838 399.313 102.196 399.431 101.554 399.405H101.541Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.806 414.59V413.148C169.806 412.02 169.046 410.577 168.115 409.948L134.867 387.261C133.936 386.619 132.376 386.566 131.393 387.13L108.305 400.467C107.322 401.031 106.535 402.408 106.535 403.535V408.82C106.535 409.948 107.335 411.325 108.305 411.889L141.383 430.996C142.366 431.559 143.952 431.559 144.936 430.996L168.023 417.659C169.006 417.095 169.793 415.718 169.793 414.59H169.806Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.036 412.125L144.949 425.462C143.965 426.025 142.418 425.973 141.474 425.33L108.226 402.644C107.296 402.001 107.322 401.031 108.305 400.467L131.393 387.13C132.376 386.566 133.923 386.619 134.867 387.261L168.115 409.948C169.046 410.591 169.02 411.561 168.036 412.125Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.166 425.842V431.428C143.808 431.428 144.45 431.284 144.949 430.996L168.036 417.659C169.019 417.095 169.819 415.718 169.819 414.59V413.148C169.819 412.086 169.15 410.761 168.298 410.079C169.059 410.722 168.967 411.6 168.049 412.125L144.962 425.462C144.463 425.75 143.821 425.868 143.179 425.842H143.166Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.865 462.796C109.865 462.796 127.604 484.722 148.554 497.351L148.594 505.245C125.637 492.905 109.878 466.639 109.878 466.639V462.796H109.865Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.121 400.401C207.105 394.316 199.147 392.546 193.261 395.942C188.436 398.723 182.746 402.014 177.922 404.794C172.035 408.191 169.282 416.085 171.13 422.616C173.936 432.595 177.266 448.109 177.266 465.773C177.266 496.407 164.221 503.488 157.286 501.337C154.532 500.485 151.609 499.2 148.541 497.351L148.58 505.245C152.933 507.58 157.168 508.812 161.297 509.022C183.585 510.15 205.034 495.187 210.567 489.784C215.273 485.194 222.064 477.09 222.314 456.082C222.615 430.668 215.575 411.43 210.121 400.388V400.401Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M182.169 489.797C187.492 478.926 190.586 470.56 203.906 462.875C214.132 456.974 219.94 460.41 220.963 469.943C218.695 481.051 214.054 486.401 210.566 489.797C205.034 495.2 183.572 510.163 161.297 509.035C170.606 509.035 176.846 500.669 182.169 489.797Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M192.828 447.886C192.946 449.014 193.798 450.391 194.782 450.955L197.889 452.751C198.872 453.315 200.118 452.987 200.694 452.004L205.309 444.017C205.873 443.034 206.253 441.329 206.135 440.201C205.388 433.408 202.307 411.181 193.012 396.113L179.691 403.771C179.691 403.771 190.508 424.544 192.828 447.886Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.746 447.375C193.864 448.502 194.716 449.879 195.7 450.443L198.807 452.24C199.79 452.804 201.035 452.476 201.612 451.492L206.227 443.506C206.791 442.522 207.171 440.818 207.053 439.69C206.306 432.897 203.225 410.669 193.93 395.602L180.609 403.26C180.609 403.26 191.426 424.032 193.746 447.375Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M193.746 447.375C193.864 448.502 194.716 449.879 195.7 450.443L198.807 452.24C199.79 452.804 201.035 452.476 201.612 451.492L206.227 443.506C206.791 442.522 207.171 440.818 207.053 439.69C206.306 432.897 203.225 410.669 193.93 395.602L180.609 403.26C180.609 403.26 191.426 424.032 193.746 447.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.647 441.093C195.647 441.093 195.778 441.08 195.83 441.041L204.103 436.267C204.287 436.162 204.339 435.939 204.247 435.756C204.142 435.572 203.906 435.52 203.736 435.611L195.463 440.385C195.28 440.49 195.227 440.713 195.319 440.896C195.385 441.014 195.516 441.08 195.647 441.08V441.093Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.198 443.663C196.198 443.663 196.329 443.65 196.381 443.611L203.828 439.31C204.012 439.205 204.064 438.982 203.972 438.798C203.867 438.615 203.631 438.562 203.461 438.654L196.014 442.955C195.831 443.06 195.778 443.283 195.87 443.467C195.935 443.585 196.067 443.65 196.198 443.65V443.663Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.761 446.234C196.761 446.234 196.892 446.221 196.945 446.181L203.565 442.365C203.749 442.26 203.801 442.037 203.71 441.854C203.605 441.67 203.369 441.618 203.198 441.709L196.578 445.525C196.394 445.63 196.342 445.853 196.433 446.037C196.499 446.155 196.63 446.221 196.761 446.221V446.234Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.312 448.804C197.312 448.804 197.443 448.791 197.495 448.751L203.277 445.407C203.461 445.303 203.513 445.08 203.421 444.896C203.317 444.712 203.081 444.66 202.91 444.765L197.128 448.109C196.945 448.214 196.892 448.437 196.984 448.62C197.05 448.738 197.181 448.804 197.312 448.804Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.05 450.115L182.969 451.899C181.986 452.463 181.173 453.84 181.212 454.98C181.252 456.344 181.357 458.206 181.645 460.042C182.196 463.622 185.145 466.337 188.751 466.599C188.79 466.599 188.816 466.599 188.856 466.599C189.773 466.665 190.639 465.865 190.442 464.96C189.629 461.367 188.659 456.869 188.043 451.125C187.925 449.997 187.046 449.538 186.063 450.115H186.05Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.376 434.89L214.592 433.605C215.575 433.041 216.624 433.461 216.873 434.562C217.306 436.425 217.869 439.283 217.869 441.709C217.869 446.64 216.217 449.932 215.129 451.099C214.028 452.266 212.153 453.092 212.179 451.65C212.232 448.424 212.179 444.424 210.986 437.92C210.79 436.805 211.393 435.454 212.376 434.877V434.89Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.188 500.157C153.103 499.515 150.901 498.623 148.541 497.351C151.661 499.174 154.572 500.485 157.286 501.337C164.221 503.488 177.266 496.407 177.266 465.773C177.266 448.122 173.949 432.608 171.13 422.616C169.282 416.085 172.035 408.191 177.922 404.794C182.746 402.014 188.436 398.723 193.261 395.942C196.801 393.897 201.088 393.726 204.601 395.234C200.826 392.559 195.437 392.297 191.15 394.762C186.325 397.555 180.635 400.834 175.824 403.614C169.937 407.01 167.184 414.892 169.033 421.436C171.838 431.402 175.168 446.929 175.168 464.58C175.168 495.213 162.137 502.295 155.188 500.144V500.157Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M155.188 500.157C162.137 502.308 175.168 495.226 175.168 464.593C175.168 446.942 171.851 431.415 169.033 421.449C168.194 418.459 168.312 415.193 169.256 412.19L171.34 413.423C170.409 416.413 170.291 419.652 171.13 422.629C173.936 432.608 177.266 448.122 177.266 465.786C177.266 496.42 164.221 503.514 157.286 501.351C154.585 500.511 151.661 499.2 148.541 497.364C150.888 498.623 153.09 499.515 155.188 500.17V500.157Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M175.837 403.614C180.662 400.821 186.351 397.542 191.163 394.762C195.437 392.297 200.825 392.559 204.614 395.234C201.101 393.726 196.814 393.897 193.274 395.942C188.449 398.723 182.759 402.014 177.935 404.794C174.736 406.643 172.468 409.843 171.353 413.41L169.269 412.177C170.383 408.623 172.651 405.45 175.837 403.601V403.614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.415 541.636C221.685 541.636 219.967 541.426 218.302 540.993L217.869 540.875C216.1 540.39 214.264 539.603 212.416 538.541C200.59 531.709 190.967 515.041 190.967 501.377C190.967 498.911 191.281 496.656 191.898 494.689C194.703 485.535 204.693 478.362 214.644 478.362C216.362 478.362 218.053 478.572 219.692 478.992L220.164 479.123C221.947 479.608 223.782 480.395 225.618 481.457C237.443 488.276 247.066 504.957 247.066 518.621C247.066 521.113 246.752 523.369 246.122 525.362L245.939 525.926C242.924 534.777 233.143 541.649 223.389 541.649L223.415 541.636Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.657 478.756C216.296 478.756 217.922 478.952 219.495 479.346L220.072 479.503C221.816 479.975 223.625 480.749 225.434 481.798C237.155 488.565 246.699 505.088 246.699 518.634C246.699 521.074 246.385 523.303 245.768 525.257L245.611 525.755C242.661 534.489 233.025 541.256 223.415 541.256C221.75 541.256 220.098 541.059 218.512 540.652L217.987 540.508C216.244 540.036 214.447 539.262 212.625 538.213C200.904 531.447 191.36 514.923 191.36 501.377C191.36 498.951 191.661 496.735 192.278 494.794C195.031 485.798 204.864 478.743 214.657 478.743M214.657 477.982C204.182 477.982 194.284 485.627 191.544 494.584C190.927 496.551 190.586 498.833 190.586 501.39C190.586 515.199 200.275 531.984 212.232 538.895C214.146 539.997 216.008 540.784 217.778 541.269C219.652 541.793 221.553 542.042 223.428 542.042C233.89 542.042 243.789 534.437 246.529 525.493C247.158 523.513 247.499 521.218 247.499 518.634C247.499 504.826 237.81 488.027 225.854 481.129C223.939 480.028 222.078 479.241 220.308 478.756C218.446 478.231 216.558 477.982 214.683 477.982H214.657Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.232 538.882C200.275 531.984 190.586 515.186 190.586 501.377C190.586 487.568 200.275 481.968 212.232 488.866C224.189 495.764 233.877 512.55 233.877 526.372C233.877 540.18 224.189 545.793 212.232 538.882Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.907 537.662C229.223 537.662 229.787 528.968 229.787 526.293C229.787 514.018 220.819 498.466 210.186 492.341C207.459 490.768 204.824 489.942 202.569 489.942C195.254 489.942 194.677 498.636 194.677 501.311C194.677 513.586 203.644 529.125 214.277 535.263C217.004 536.836 219.639 537.676 221.894 537.676L221.907 537.662Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.543 529.689C205.742 525.178 199.134 513.756 199.134 504.734C199.134 502.714 199.58 496.118 205.231 496.118C206.935 496.118 208.902 496.735 210.934 497.915C218.734 502.413 225.329 513.848 225.329 522.87C225.329 524.89 224.883 531.486 219.233 531.486C217.528 531.486 215.562 530.87 213.516 529.689H213.543ZM199.882 504.747C199.882 513.533 206.306 524.654 213.91 529.047C215.824 530.161 217.672 530.738 219.246 530.738C224.201 530.738 224.582 524.719 224.582 522.87C224.582 514.084 218.158 502.95 210.553 498.57C208.639 497.469 206.791 496.879 205.218 496.879C200.262 496.879 199.868 502.898 199.868 504.747H199.882Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.232 504.196C207.63 501.547 203.907 503.698 203.907 509.009C203.907 514.32 207.63 520.772 212.232 523.434C216.834 526.083 220.557 523.932 220.557 518.621C220.557 513.31 216.834 506.858 212.232 504.196Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.232 510.517C210.658 509.612 209.374 510.347 209.374 512.169C209.374 513.992 210.645 516.195 212.232 517.113C213.805 518.018 215.09 517.284 215.09 515.461C215.09 513.638 213.818 511.435 212.232 510.517Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.795 480.644C197.745 478.939 208.718 472.802 211.419 471.058C216.112 468.042 222.746 468.291 230.101 472.553C237.233 476.671 243.671 483.778 248.325 491.896C249.046 493.155 248.6 494.754 247.342 495.476C243.644 497.587 236.394 501.744 232.474 504.078C227.977 506.74 217.253 500.052 206.712 501.049C204.969 501.206 203.238 501.574 201.534 502.242C194.428 505.009 191.976 505.953 189.315 504.983C188.449 504.668 187.82 503.882 187.689 502.964C187.414 501.049 187.256 499.147 187.256 497.298C187.256 489.102 190.128 483.332 194.782 480.657L194.795 480.644Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M194.795 480.644C197.745 478.939 208.718 472.802 211.419 471.058C216.112 468.042 222.746 468.291 230.101 472.553C233.602 474.572 236.919 477.313 239.96 480.526L203.395 501.639C202.766 501.81 202.15 501.993 201.534 502.242C194.428 505.009 191.976 505.953 189.315 504.983C188.449 504.668 187.82 503.882 187.689 502.964C187.414 501.049 187.256 499.147 187.256 497.298C187.256 489.102 190.128 483.332 194.782 480.657L194.795 480.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.269 497.285C187.269 499.567 187.492 501.914 187.912 504.301C191.294 506.203 193.222 505.455 201.534 502.229C203.225 501.56 204.969 501.193 206.712 501.036C217.253 500.039 227.991 506.727 232.474 504.065C230.036 499.384 226.994 494.964 223.533 491.161C220.308 487.621 216.729 484.604 212.953 482.441C210.357 480.946 207.853 479.936 205.493 479.398C201.389 478.467 197.732 478.926 194.782 480.631C190.128 483.319 187.256 489.076 187.256 497.272L187.269 497.285Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M187.269 497.285C187.269 499.567 187.492 501.914 187.912 504.301C191.294 506.203 193.222 505.455 201.534 502.229C203.225 501.56 204.969 501.193 206.712 501.036C217.253 500.039 227.991 506.727 232.474 504.065C230.036 499.384 226.994 494.964 223.533 491.161C220.308 487.621 216.729 484.604 212.953 482.441C210.357 480.946 207.853 479.936 205.493 479.398C201.389 478.467 197.732 478.926 194.782 480.631C190.128 483.319 187.256 489.076 187.256 497.272L187.269 497.285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.365 365.138L212.428 360.077L224.831 352.916C225.211 352.694 225.735 352.72 226.312 353.048C227.453 353.703 228.384 355.316 228.384 356.628C228.384 357.27 228.161 357.716 227.807 357.939L227.781 357.965L215.378 365.125L215.365 365.138Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.968 363.801C215.968 365.125 215.037 365.65 213.897 364.994C212.756 364.338 211.825 362.725 211.825 361.414C211.825 360.103 212.756 359.565 213.897 360.221C215.037 360.876 215.968 362.489 215.968 363.801Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.358 367.761L205.559 366.384L213.425 361.834C213.53 361.768 213.674 361.781 213.831 361.873C214.146 362.057 214.395 362.489 214.395 362.857C214.395 363.027 214.33 363.158 214.238 363.211L206.371 367.761H206.358Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.516 367.394C206.516 367.748 206.267 367.905 205.952 367.722C205.637 367.538 205.388 367.105 205.388 366.751C205.388 366.397 205.637 366.24 205.952 366.424C206.267 366.607 206.516 367.04 206.516 367.407V367.394Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.043 398.696C168.6 398.592 174.028 399.982 175.837 403.614L191.163 394.762C191.163 394.762 189.537 387.878 199.96 379.826L166.03 398.696H166.043Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.043 398.696C168.6 398.592 174.028 399.982 175.837 403.614L191.163 394.762C191.163 394.762 189.537 387.878 199.96 379.826L166.03 398.696H166.043Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.899 394.933L152.868 403.26V397.778L171.825 386.828L176.899 394.933Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.092 384.101L148.135 395.038L152.868 397.778L171.825 386.829L167.092 384.101Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M167.092 384.101L148.135 395.038L152.868 397.778L171.825 386.829L167.092 384.101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.868 403.26L148.135 400.519V395.038L152.868 397.778V403.26Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M152.868 403.26L148.135 400.519V395.038L152.868 397.778V403.26Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.002 375.223L210.96 364.273L206.214 361.532L187.256 372.482L192.002 375.223Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M192.002 375.223L210.96 364.273L206.214 361.532L187.256 372.482L192.002 375.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.96 369.741L196.735 383.432L192.002 375.223L210.96 364.273V369.741Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.488 380.167C171.235 379.314 172.625 378.16 173.608 377.596L189.013 368.705C189.996 368.141 191.386 368.377 192.133 369.23L194.192 371.603C194.939 372.456 195.83 374.016 196.211 375.092L199.606 384.901C199.973 385.976 199.488 387.301 198.505 387.864L183.1 396.756C182.117 397.319 180.531 397.319 179.547 396.756L178.354 396.074C177.371 395.51 176.125 394.251 175.549 393.267L172.861 388.612C172.297 387.628 171.039 386.383 170.055 385.806L167.092 384.088L170.488 380.167Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M170.488 380.167C171.235 379.314 172.625 378.16 173.608 377.596L189.013 368.705C189.996 368.141 191.386 368.377 192.133 369.23L194.192 371.603C194.939 372.456 195.83 374.016 196.211 375.092L199.606 384.901C199.973 385.976 199.488 387.301 198.505 387.864L183.1 396.756C182.117 397.319 180.531 397.319 179.547 396.756L178.354 396.074C177.371 395.51 176.125 394.251 175.549 393.267L172.861 388.612C172.297 387.628 171.039 386.383 170.055 385.806L167.092 384.088L170.488 380.167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.221 382.553L173.162 380.18C172.415 379.327 172.612 378.173 173.595 377.61L189 368.718C189.983 368.155 191.373 368.391 192.12 369.243L194.179 371.617C194.926 372.469 194.729 373.623 193.746 374.187L178.341 383.078C177.358 383.642 175.968 383.406 175.221 382.553Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.24 386.029L180.635 395.838C181.002 396.913 182.104 397.319 183.087 396.756L198.492 387.864C199.475 387.301 199.96 385.976 199.593 384.901L196.197 375.092C195.83 374.016 194.729 373.61 193.746 374.174L178.341 383.065C177.358 383.629 176.872 384.953 177.24 386.029Z",
    fill: "#455A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.261 395.339L197.666 386.448C197.967 386.278 198.151 385.766 198.046 385.438L194.65 375.629C194.65 375.629 194.637 375.59 194.624 375.577L179.167 384.507C178.865 384.678 178.682 385.189 178.787 385.517L182.182 395.326C182.182 395.326 182.195 395.366 182.208 395.379C182.221 395.379 182.235 395.366 182.261 395.352V395.339Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.916 377.203L196.761 385.596L182.995 393.648L182.405 392.1C182.405 392.1 189.904 388.297 191.989 385.478C194.074 382.658 193.916 377.216 193.916 377.216V377.203Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.138 386.199C187.427 387.012 188.226 387.34 188.921 386.933C189.629 386.527 189.97 385.53 189.682 384.717C189.393 383.904 188.593 383.576 187.899 383.983C187.191 384.389 186.85 385.386 187.138 386.199Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.759 404.427L141.959 403.05L149.826 398.5C149.931 398.434 150.075 398.447 150.232 398.539C150.547 398.723 150.796 399.155 150.796 399.523C150.796 399.693 150.73 399.824 150.639 399.877L142.772 404.427H142.759Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.93 404.06C142.93 404.414 142.681 404.571 142.366 404.388C142.051 404.204 141.802 403.771 141.802 403.417C141.802 403.063 142.051 402.906 142.366 403.089C142.681 403.273 142.93 403.706 142.93 404.06Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.962 411.954L131.025 406.893L143.428 399.732C143.808 399.509 144.332 399.536 144.909 399.864C146.05 400.519 146.981 402.132 146.981 403.444C146.981 404.086 146.758 404.532 146.404 404.755L146.378 404.781L133.975 411.941L133.962 411.954Z",
    fill: "#37474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.565 410.617C134.565 411.941 133.634 412.466 132.494 411.81C131.353 411.154 130.422 409.541 130.422 408.23C130.422 406.919 131.353 406.381 132.494 407.037C133.634 407.692 134.565 409.305 134.565 410.617Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.815 398.67C134.959 398.67 135.103 398.631 135.221 398.565L154.441 387.471L156.552 391.89C156.748 392.297 157.234 392.467 157.64 392.271C158.046 392.074 158.217 391.589 158.02 391.182L155.529 385.963C155.437 385.753 155.254 385.596 155.031 385.53C154.808 385.465 154.572 385.491 154.375 385.609L135.156 396.703L133.045 392.284C132.848 391.877 132.363 391.707 131.957 391.903C131.55 392.1 131.38 392.585 131.576 392.992L134.08 398.211C134.185 398.421 134.356 398.578 134.579 398.644C134.657 398.67 134.736 398.683 134.815 398.683V398.67Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.126 384.311L133.516 379.511C134.106 379.17 134.644 379.144 135.024 379.367C135.313 379.537 136.44 380.154 136.729 380.35C137.083 380.586 137.305 381.045 137.305 381.701V387.327C137.305 388.691 136.348 390.343 135.181 391.012L126.791 395.811C126.214 396.152 125.69 396.179 125.296 395.969C124.995 395.798 123.907 395.169 123.618 394.998C123.225 394.775 122.989 394.303 122.989 393.621V387.996C122.989 386.632 123.946 384.979 125.113 384.311H125.126Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.182 391.025L126.791 395.824C125.611 396.506 124.667 395.956 124.667 394.592V388.966C124.667 387.602 125.624 385.95 126.791 385.281L135.182 380.481C136.362 379.8 137.305 380.35 137.305 381.714V387.34C137.305 388.704 136.348 390.356 135.182 391.025Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.182 391.025L126.791 395.824C125.611 396.506 124.667 395.956 124.667 394.592V388.966C124.667 387.602 125.624 385.95 126.791 385.281L135.182 380.481C136.362 379.8 137.305 380.35 137.305 381.714V387.34C137.305 388.704 136.348 390.356 135.182 391.025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.576 367.538C200.93 367.538 201.245 367.315 201.363 366.961L203.762 359.159L215.142 352.602C215.326 352.497 215.457 352.326 215.522 352.13L218.485 342.583C218.616 342.15 218.38 341.691 217.948 341.56C217.515 341.429 217.056 341.665 216.925 342.098L214.067 351.33L202.687 357.887C202.504 357.991 202.372 358.162 202.307 358.359L199.803 366.463C199.672 366.896 199.908 367.355 200.34 367.486C200.419 367.512 200.498 367.525 200.576 367.525V367.538Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.703 333.797L221.094 328.997C221.684 328.656 222.222 328.63 222.602 328.853C222.89 329.023 224.018 329.64 224.306 329.836C224.66 330.072 224.883 330.531 224.883 331.187V336.813C224.883 338.177 223.926 339.829 222.759 340.498L214.368 345.297C213.792 345.638 213.267 345.665 212.874 345.455C212.572 345.284 211.484 344.655 211.196 344.484C210.802 344.261 210.566 343.789 210.566 343.107V337.482C210.566 336.118 211.523 334.465 212.69 333.797H212.703Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.759 340.498L214.369 345.297C213.189 345.979 212.245 345.428 212.245 344.065V338.439C212.245 337.075 213.202 335.423 214.369 334.754L222.759 329.954C223.939 329.272 224.883 329.823 224.883 331.187V336.813C224.883 338.177 223.926 339.829 222.759 340.498Z",
    fill: "#481A6C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M222.759 340.498L214.369 345.297C213.189 345.979 212.245 345.428 212.245 344.065V338.439C212.245 337.075 213.202 335.423 214.369 334.754L222.759 329.954C223.939 329.272 224.883 329.823 224.883 331.187V336.813C224.883 338.177 223.926 339.829 222.759 340.498Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3142_7091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 582,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketPulseMain);
export default __webpack_public_path__ + "static/media/market_pulse_main.dc5d60e235b86b878152afe099048d70.svg";
export { ForwardRef as ReactComponent };